/* eslint-disable no-magic-numbers,@typescript-eslint/no-magic-numbers */
import { normalizeSubstring } from "./helpers/normalize";
/**
 * Result of running getManufacturerList
 * NOTE: the list has redundancy. The same IDs may be repeated for various
 * names. names
 */
export const digikeyManufacturerList = {
    "Optiks Mechatronics Pvt. Ltd.": [3719],
    "3G Shielding Specialties": [2276],
    "3M": [19, 1067, 8002, 1717, 2089],
    "4D Systems": [1613, 2114],
    "5G Hub": [3082],
    "A&D Engineering": [3715],
    Aavid: [59, 1061, 8101],
    "ABB Embedded Power": [555, 8012, 235],
    "ABLIC U.S.A. Inc.": [1662],
    Abracon: [535],
    "AC Electronics": [2352],
    "Accelerated / Digi International": [602, 504, 8038, 316, 1969],
    "Acconeer AB": [1891],
    "Aceinna Electric Inc.": [2783, 2955],
    "Aceinna Inc.": [2783, 2955],
    "ACKme (Zentri)": [1586],
    "ACL Staticide, Inc.": [134],
    "ACT (Advanced Cable Ties)": [2162],
    "Actuonix Motion Devices, Inc.": [2495],
    "Acura Embedded Systems": [3549],
    Acuva: [3709],
    Adafruit: [1528],
    "Adam Equipment": [2342],
    "Adam Tech": [2057],
    Adapteva: [1554],
    "Adels-Contact": [2098],
    "Adesto Technologies": [1265],
    "ADI (Analog Devices, Inc.)": [505, 1127, 161, 8054, 855],
    ADSANTEC: [2837],
    "Advanced Cable Ties": [2162],
    "Advanced Energy": [633, 2309],
    "Advanced Linear Devices, Inc.": [1014],
    "Advanced Micro Lites": [2451],
    "Advanced Photonix": [209],
    "Advanced Sensors / Amphenol": [45],
    "Advanced Thermal Solutions, Inc.": [684],
    Advantech: [1588, 2084, 1165, 2963],
    "Aearo Technologies, LLC – a 3M company": [1717],
    AEM: [2989],
    "Aeon Matrix": [3467],
    "Aeonsemi Inc.": [2905],
    Aeris: [1615],
    "Aeroflex (MACOM Technology Solutions)": [1465, 1657, 1700, 1702],
    "Aerospace Defense and Marine / TE Connectivity": [844, 1122],
    "Affinity Medical Technologies - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "AFSI (Amphenol Fiber Systems International)": [1968],
    "Agastat Relays / TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "Agile Focus Designs": [3172],
    "Aim Dynamics": [2272],
    "AIM-Cambridge / Cinch Connectivity Solutions": [116, 24, 367, 1097, 1255, 652, 1299, 1427, 2110, 2111, 1599],
    "AIMS Power": [3491],
    Aimtec: [2374],
    AIMtti: [2207],
    "Air LB (Amphenol Pcd)": [623, 1032, 1591],
    "Air Science USA LLC": [3041],
    Airgain: [2944],
    "Airpax / Sensata Technologies": [723],
    "AIRTEC Pneumatics": [2613],
    "Aker Technology USA": [2754],
    "AKM Semiconductor, Inc.": [974],
    "AK-NORD GmbH": [1851],
    Alango: [3116],
    "ALCOSWITCH Switches / TE Connectivity": [450],
    "ALFA Network Inc.": [3050],
    "AlfaMag Electronics (AMGIS)": [419],
    "Alfra Tools": [2481],
    "Alive Telecom": [2662],
    "All Flex, Inc.": [2340],
    "All Sensors Corporation": [442],
    "Allegro MicroSystems": [620],
    Alliance: [2455],
    "Alliance (Essentra Components)": [145],
    "Alliance Memory, Inc.": [1450],
    "Alliance Sensors Group a div of HG Schaevitz LLC": [1817],
    "Allied Components International": [3475],
    "Allied Vision": [2285],
    "Allison Park Group": [3389],
    Allystar: [3106],
    "Almit (ANA TRADING)": [2345],
    "Alorium Technology": [2003],
    "Alpenglow Industries": [3028],
    "Alpha and Omega Semiconductor, Inc.": [785],
    "Alpha Lighting": [3355],
    "Alpha Wire": [216, 8089, 1412],
    "Altech Corporation": [1920],
    "Altera (Intel) ": [544],
    "Altran Magnetics, Inc.": [2040],
    "Altum RF": [3463],
    "AM Equipment": [3117],
    "AMBER Wireless GmbH (Würth Elektronik)": [732, 1773, 1297, 1917, 2101],
    "Ambiq Micro, Inc.": [1822],
    "American Beauty Tools": [2491],
    "American Bright": [2007],
    "American Electrical, Inc. ": [288],
    "American Hakko Products, Inc.": [1691],
    "American Microsemiconductor, Inc.": [2335],
    "American Opto Plus LED Corp.": [2460],
    "American Technical Ceramics": [1284],
    "American Zettler": [2487, 3385],
    Amerivacs: [3060],
    "Amerway Inc.": [2757],
    Ametherm: [570],
    Amgis: [419],
    "AMI (Altran Magnetics, Inc.)": [2040],
    "AMI Semiconductor/ON Semiconductor": [488, 261, 1567, 46],
    "AMP Connectors/TE Connectivity": [17, 1712, 2132, 2094],
    "Ampco Safety Tools": [2991],
    "Amp'ed RF Tech": [2676],
    Ampere: [2914],
    Amphenol: [
        8010, 45, 1178, 1202, 1179, 664, 152, 339, 956, 965, 1201, 873, 623, 1032, 115, 889, 1270, 609, 1678, 1754,
        1819, 442, 1818, 1967, 1993, 1782, 734, 1946, 2053, 1812, 2217, 2496, 3272,
    ],
    "Amphenol Advanced Sensors": [45],
    "Amphenol Aerospace Operations": [1178, 1069, 1202, 1179],
    "Amphenol Air LB": [623, 1032, 1591],
    "Amphenol All Sensors": [442],
    "Amphenol Anytek": [1818],
    "Amphenol Aorora": [609, 664, 2188],
    "Amphenol Audio": [889],
    "Amphenol Cables on Demand": [3272],
    "Amphenol Commercial IO": [609, 664, 2188],
    "Amphenol Connex (Amphenol RF)": [115],
    "Amphenol Custom Cable": [2217],
    "Amphenol Entertainment": [889],
    "Amphenol FCi Basics": [609, 664, 2188],
    "Amphenol Fiber Systems International": [1968],
    "Amphenol High Speed Backplane Products": [609, 664, 2188],
    "Amphenol High Speed IO": [609, 664, 2188],
    "Amphenol Industrial": [339, 956, 965, 873, 1177, 1201],
    "Amphenol Information Communication & Commercial": [609, 664, 2188],
    "Amphenol InterCon Systems": [609, 664, 2188],
    "Amphenol Limited": [623, 1032, 1591],
    "Amphenol LTD": [623, 1032, 1591],
    "Amphenol LTW": [1754],
    "Amphenol Mezzanine Products": [609, 664, 2188],
    "Amphenol NEXUS Technologies": [1967],
    "Amphenol NovaSensor": [45],
    "Amphenol Pcd": [623, 1032, 1591],
    "Amphenol Piher Sensing Systems": [1993],
    "Amphenol Power Solutions": [609, 664, 2188],
    "Amphenol Procom": [2496],
    "Amphenol RF": [115],
    "Amphenol SGX Sensortech": [1782],
    "Amphenol Sine Systems": [889],
    "Amphenol Socapex": [623, 1032, 1591],
    "Amphenol SSI Technologies": [734],
    "Amphenol Storage & Server IO": [609, 664, 2188],
    "Amphenol SV Microwave": [1678, 3122],
    "Amphenol Telaire": [45],
    "Amphenol Thermometrics": [45],
    "Amphenol Times Microwave Systems": [1946],
    "Amphenol Tuchel Electronics": [889],
    "Amphenol Wilcoxon Sensing Technologies": [2053],
    Ampleon: [1603],
    Amprobe: [705],
    ams: [961, 8075, 1194, 1728, 1729, 1746, 2142, 3454],
    "Amtery Corporation": [3315],
    "Amulet Technologies, LLC.": [681],
    "Analog Devices, Inc.": [505, 1127, 161, 8054, 855],
    "Anamet Electrical Inc": [3460],
    Anaren: [1173],
    "Anatech Electronics Inc.": [3078],
    AnDAPT: [1744],
    "Anderson Power Products": [2243],
    AndyMark: [2511],
    "Anfield Industries": [3200],
    "Angstrohm / Vishay": [56, 1896, 749],
    "Antenna Technologies Limited Company": [2480],
    Antenova: [627],
    "Antimatter Research": [2850],
    ANYSOLAR: [2994],
    "Anytek (Amphenol Anytek)": [1818],
    "Aorora (Amphenol ICC)": [609, 664, 2188],
    Apacer: [1582],
    "APEM Inc.": [679, 8059],
    "Apex Microtechnology": [1240],
    "Apex Tool Group": [72],
    "API Delevan": [197, 1134, 8070],
    "API Technologies Corp.": [1171, 8077],
    "APM Hexseal": [335],
    "Applied Photon Technology": [2690],
    APS: [2667],
    "Aptina/ON Semiconductor": [488, 261, 1567, 46],
    "APW Company": [2507],
    "Aras Power Technologies": [2454],
    "Arbiter Systems Inc.": [3654],
    "Arc Suppression Technologies": [3436],
    ARCH: [3550],
    "ARCOL (Ohmite)": [273],
    "Arcolectric (Bulgin)": [708, 1091],
    Arcotek: [3277],
    "Arcotronics (KEMET)": [399],
    "Arcus Technology": [3051],
    Arduino: [1050],
    Arieltech: [3560],
    "Aries Electronics, Inc.": [43],
    "ARIES Embedded": [3199],
    "ArkX Laboratories": [3281],
    ARM: [685],
    "Arrgh!!": [3555],
    "Arshon Technology Inc.": [3643],
    "Artaflex Inc.": [748],
    "Artesyn Embedded Power": [454, 1078, 393],
    "ARTIK (Samsung ARTIK)": [1683],
    "Asahi Kasei Microdevices / AKM Semiconductor": [974],
    "ASAHI RUBBER INC.": [3356],
    "ASC Capacitors": [2380],
    Asentek: [3125],
    "ASI-Ez": [3500],
    "ASSMANN WSW Components": [123],
    "Astec America (Artesyn Embedded Technologies)": [454, 1078, 393],
    "Astera Labs": [3365],
    "Astro Tool Corp.": [358],
    "Astrodyne TDI": [2622, 3109],
    Asus: [3518],
    ATC: [2728],
    ATGBICS: [3441],
    "Atmel (Microchip Technology)": [313, 453, 427, 8025, 1288, 150],
    "Atop Technologies": [1710],
    "ATP Electronics, Inc.": [1282],
    "Atrix International": [2663],
    Attabox: [2665],
    "ATX LED": [2359],
    Audiowell: [1922],
    "Ault / SL Power": [271],
    "Autonics USA": [3689],
    "Avago Technologies (Broadcom)": [516],
    Aven: [243],
    "Avery Dennison": [1543],
    AVMATRIX: [2937],
    "AVR Global Technologies, Inc.": [3425],
    "AVX Corporation": [478, 1010, 939],
    "AWG TECH Pte. Ltd.": [2731],
    "Axicom Relays / TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "AZ Displays": [2470, 3387],
    Azoteq: [1790],
    "Aztronic / Vishay": [56, 1896, 749],
    Azumo: [2004],
    "B B Battery": [522],
    "B&F Fastener Supply": [186],
    "B&J USA": [3600],
    "B&K Precision": [22],
    "B+B SmartWorx (Advantech)": [1165, 590],
    "B+B Thermo-Technik GmbH": [3083],
    "B4 Limits": [2848],
    Balluff: [2608],
    "Band Solutions, LLC": [2391],
    "Banner Engineering": [2170],
    "Bantam Tools": [1932],
    "BAPI/Building Automation Products Inc.": [3474],
    "Bardac Corporation": [3447],
    Bartovation: [2893],
    Basler: [2938],
    "BATTERY WORLD": [3102],
    BatteryGuy: [2788],
    "Bayshore Networks": [2614],
    "BDE Technology": [3707],
    "BDNC (Holding) Limited": [2055],
    "Beacon EmbeddedWorks": [460],
    "BeagleBoard.org": [8126, 1711, 1777, 2246],
    "Beau Interconnect - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "BECOM Systems GmbH": [978],
    "BEI Sensors / Sensata Technologies": [1724],
    Bel: [8033, 507, 179, 116, 367, 24, 652, 1255, 1097, 1427, 595, 380, 1419, 1847],
    "Bel Fuse, Inc.": [507],
    "Bel Power Solutions": [179],
    Belden: [135],
    "Belden Hirschmann": [1797],
    "Bellnix Co., LTD.": [2277],
    BenchPro: [2902],
    "Bend Labs": [2190],
    "Bergquist / Henkel": [211],
    "Berkeley Nuclonics Corporation (Directed Energy Inc.)": [2145],
    Bertech: [2363],
    "BeStar Technologies, Inc.": [2895],
    "BI Technologies/TT Electronics": [987],
    "Bias Power": [440],
    Binho: [2280],
    "Bird Technologies": [2753],
    "Birk Manufacturing": [2282],
    "Birtcher / nVent": [8092, 1440, 1439],
    "Bittware - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Bivar, Inc.": [492, 8080, 1247],
    "BLA ETECH PVT LTD": [3563],
    Bluatec: [2396],
    "Blue Clover Devices": [2443],
    "Blue Harmonics": [2993],
    "Bluebird Labs": [3343],
    BlueCreation: [1495],
    "BNS Solutions": [867],
    "Bomar (Winchester Electronics)": [991],
    "Bopla Enclosures": [8119, 902, 1758, 1757],
    "Boréas Technologies": [2158],
    "Bosch Connected Devices and Solutions": [1723],
    "Bosch Sensortec": [828],
    "BotBlox/Kapek": [3240],
    BotFactory: [3531],
    "Botron Company Inc.": [2071],
    "Boundary Devices": [2851],
    "Bourns, Inc.": [118],
    "Brad Harrison - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Brady Corporation": [2267],
    Brainboxes: [2265],
    "Breadware, Inc.": [1919],
    "Bridgelux, Inc.": [976],
    Bridgetek: [2005],
    "Bright Toward Industrial": [3008],
    "Bright Way Group": [2717],
    Broadcom: [516],
    "Broadsens Corporation": [3461],
    "Buchanan Terminal Blocks / TE Connectivity": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "Bud Industries, Inc.": [377],
    Buildtak: [2390],
    Bulgin: [708, 1091],
    "Bumper Specialties, Inc.": [2042],
    "Burr-Brown (Texas Instruments)": [296],
    "BusBoard Prototype Systems": [2864],
    "Business Systems Connection Inc.": [2996],
    "Bussmann (Eaton)": [2041],
    "BWI Eagle": [3359],
    "C&D Technologies (Murata Power Solutions)": [811],
    "C&K": [108],
    c3controls: [2649],
    "Cables on Demand (Amphenol Cables on Demand)": [3272],
    "Caddock Electronics, Inc.": [683],
    "CAIG Laboratories, Inc.": [2220],
    "Cal Test Electronics": [1768],
    "CAL-CHIP ELECTRONICS INC.": [2571],
    "Califia Lighting (Bivar)": [492, 8080, 1247],
    "Calmark / nVent": [8092, 1440, 1439],
    "Caly Technologies": [3633],
    Cannon: [1003, 998, 1408, 2009],
    Canon: [2157],
    Cantherm: [317],
    CapeSym: [3340],
    "Capital Advanced Technologies, Inc.": [191],
    "Carclo Technical Plastics": [1066],
    "Cardinal Components": [370],
    "Carling Technologies": [432],
    "Carlisle Interconnect Technologies": [2317, 2445, 8150],
    "Carlo Gavazzi": [1864],
    "Carnegie Manufacturing": [3353],
    Cartesiam: [3101],
    "Catalyst Semiconductor/ON Semiconductor": [488, 261, 1567, 46],
    "CCI (Conductive Containers, Inc.)": [2079],
    "CEL (California Eastern Laboratories)": [51, 883, 8058],
    "CENTER TECHNOLOGY": [3697],
    "Central Semiconductor": [1514],
    "Century Spring Corp.": [2343],
    "Cera-Mite / Vishay": [56, 1896, 749],
    CEVA: [1888],
    "CEVA Hillcrest Labs": [1888],
    "CGS Resistors / TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "CH Products": [1040],
    "Challenge Electronics": [2603],
    "CHASM Advanced Materials": [3370],
    "Chemi-Con": [565],
    "Chempure Brand Chemicals": [3189],
    Chemtronics: [75, 8047],
    "Cherry Americas": [1644],
    Cheval: [3014],
    "Chicago Electronic Distributors": [2270],
    "Chilisin Electronics": [2184],
    "ChinCheng Casters Co., Ltd.": [3317],
    "Chip Quik, Inc.": [315],
    "Chip Shine / CSRF": [2376],
    "Chiral Photonics": [2567],
    "Chogori Technologies": [2150],
    ChromeLED: [2661],
    Cicoil: [1233],
    "CII / TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    CIMON: [3411],
    "Cinch Connectivity Solutions": [116, 24, 367, 1097, 1255, 652, 1299, 1427, 2110, 2111, 1599],
    Cincon: [2034],
    "Circuit Design": [3728],
    "Circuit Dojo": [3090],
    "Circuit Scribe/Electroninks Writeables Inc.": [2440],
    "Cirronet / RFM (Murata Power Solutions)": [811],
    "Cirrus Logic": [598],
    CISSOID: [3276],
    "CIT (Carlisle Interconnect Technologies)": [2317, 2445, 8150],
    "CIT Relay and Switch": [2449],
    "Cita Technologies": [440],
    "CITEL INC": [2666],
    "Citizen Electronics Co., Ltd.": [1642],
    "Citizen Finedevice Co., LTD.": [300],
    "City Technology": [1933],
    "Clarion Safety Systems": [3174],
    "Clarostat (Honeywell Sensing and Productivity Solutions)": [480],
    Cliff: [3185],
    "CMD (ON Semiconductor)": [488],
    "CML Innovative Technologies": [2216],
    "CML Microcircuits": [2032],
    "CnC Tech": [1175],
    Coex: [3456],
    COILCRAFT: [2457],
    "Coiltronics (Eaton)": [283],
    "Comair Rotron": [25],
    "Comchip Technology": [641, 8084],
    "Comet America": [2283],
    "Commercial IO (Amphenol ICC)": [609, 664, 2188],
    "Compass Instruments": [3131],
    ComScire: [2765],
    "Comus International": [1835],
    "Concept Technologie (Power Integrations)": [596],
    "Concord Electronics": [2395],
    "Condor / SL Power": [271],
    "Conductive Containers, Inc.": [2079],
    ConductRF: [2210],
    CONEC: [626],
    congatec: [2144],
    "Connective Peripherals": [3477],
    "Connex (Amphenol RF)": [115],
    "Connor Winfield": [222],
    "Construction Resource Management, LLC": [2354],
    "Conta-Clip": [2080],
    "Contrinex - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Control By Web": [2907],
    ControlAir: [3732],
    "Conxall / Switchcraft": [137, 468, 8027],
    Coolgear: [2671],
    "Cooper Bussmann (Eaton)": [2041],
    "Copal Electronics (Nidec Copal Electronics)": [563],
    "Corcom Filters / TE Connectivity": [174],
    "Cordova Flow Controls": [3065],
    "CoreLED Systems LLC": [3103],
    "Cornell Dubilier Electronics": [338, 1572],
    "Correct Products": [2483],
    Cosel: [1776],
    "Coto Technology": [306, 8046],
    "CPR Global Tech": [3039],
    "CR Magnetics, Inc.": [582],
    "Cree LED": [90, 2138],
    "Cree Wolfspeed": [1697],
    Crescent: [72],
    "Crest Electronics": [3162],
    "Criteria Labs": [3626],
    "Critical Link": [1057],
    Crouzet: [966],
    "Crown Matting Technologies": [2720],
    "Crydom / Sensata Technologies": [172, 8041],
    "Crystal IS": [2570],
    Crystalfontz: [3482],
    "Crystek Corporation": [744],
    Crytur: [3521],
    "CS Hyde Company": [3636],
    "CS Instruments": [3273],
    "CTI Electronics": [2288],
    "CTi Sensors": [2539],
    "C-Ton Industries": [101],
    "CTR Electronics": [2353],
    "CTS Corporation": [119, 60, 294, 410, 110, 177],
    "CUI Devices": [2223],
    "CUI Inc.": [102, 8094],
    "Curtis Industries": [364],
    "Curtis Instruments": [267],
    "Custom Computer Services": [429],
    CviLux: [2987],
    "CW Industries": [32],
    Cymbet: [859],
    "Cynergy3 / Sensata Technologies": [725],
    "Cyntec / Delta Electronics": [2037],
    "Cypress Semiconductor": [428, 1274, 1534, 1574, 2015],
    "D6 Labs": [1661],
    "DAB-Embedded": [3347],
    Daburn: [49, 3040],
    "Dale / Vishay": [541, 1135],
    Danisense: [2186],
    "Dantona Industries, Inc.": [3145],
    "Dart Controls": [2456],
    "Darwin Tech": [3048],
    "Data Modul Inc.": [2621],
    "DataComm Electronics, Inc.": [2497],
    Dataforth: [2382],
    "Datawave Wireless": [1857],
    "DAVE Embedded Systems": [1525],
    "Davies Molding, LLC.": [1722],
    "DB Unlimited": [2104],
    DComponents: [2721],
    "ddm hopt+schuler": [3130],
    Deca: [2839],
    "DEI (Berkeley Nuclonics Corporation)": [2145],
    "Delkin Devices": [3247],
    "Delta Electronics": [8060, 941, 1145, 1144, 603, 2037, 2035, 2039],
    "Delta Electronics / Cyntec": [2037],
    "Delta Electronics / EMI": [1144],
    "Delta Electronics / Fans": [603],
    "Delta Electronics / Industrial Automation": [2039],
    "Delta Electronics / Power": [941, 1145],
    "Deltatech / Sensata Technologies": [2149],
    "Denso Robotics": [2401],
    "Deschner Corporation": [3108],
    Desco: [16, 2654],
    "DET LLC/Diamond Edge Technology LLC": [3161],
    "DEUTSCH Connectors / TE Connectivity": [1508, 1208, 1506],
    "DEUTSCH ICT / TE Connectivity": [1734],
    DFRobot: [1738],
    "DGH Corporation": [2739],
    Dialight: [350],
    "Dialog Semiconductor": [1564, 1695, 1827],
    "Diamond Systems": [2572],
    "Dielectric Laboratories": [1761],
    "Dielectric Laboratories (Knowles)": [423],
    Digi: [602, 504, 8038, 316, 1969],
    "Digilent, Inc.": [1286],
    "Digi-Pas Technologies": [2256],
    "Digital Power Corporation": [2647],
    "Digital Six Laboratories, LLC": [1661],
    "Digital View Inc.": [586],
    "DINKLE Corporation USA": [2861],
    "Diodes Incorporated": [31, 8050, 89, 1034],
    "Diotec Semiconductor": [2796],
    "Directed Energy Inc. (Berkeley Nuclonics Corporation)": [2145],
    "Display Visions": [1481],
    Displaytech: [1756],
    "DiTom Microwave Inc.": [2236, 3088],
    "Divelbiss Corporation": [2698],
    DLI: [1761],
    "DLP Design, Inc.": [813],
    "Doodle Labs": [3136],
    "Dormeyer (Division of Johnson Electric)": [2024],
    "Dou Yee Enterprises": [2547],
    "Draloric/Vishay": [749],
    Dremel: [2017],
    "dresden elektronik": [1018],
    "Dreyer Electronics LLC": [3204],
    "Dunwell Tech, Inc.": [2420],
    Duracell: [3046],
    "Dynapar Corp": [2602],
    "Dynastream Innovations Inc. (Garmin Canada Inc.)": [1094],
    Dynics: [3135],
    "E Ink": [1272],
    "E S D Control Centre Ltd.": [2838],
    EAO: [1948],
    "Earth People Technology": [3289],
    EarthLCD: [2541],
    "East Electronics": [2769],
    "EasyBraid (Menda/EasyBraid/Tronex)": [154, 8076],
    Eaton: [8013, 2041, 283],
    "Eaton Souriau-Sunbank": [666, 874, 8055, 1539, 1792],
    "Eaton-Bussmann Electrical Division": [2041],
    "Eaton-Electronics Division": [283],
    "ebm-papst Inc.": [381],
    "Echelon by Adesto": [1499],
    "Eclipse Tools": [3235],
    Ecliptek: [2773],
    "ECS Inc. International": [50],
    "Ectron Corporation": [2968],
    "ED2 Corp": [3000],
    "EDAC Inc.": [151, 8015],
    "EDSYN Inc.": [2590],
    EFCO: [2400],
    "Effulgent Inc.": [2489],
    "Efinix, Inc.": [2134],
    "EI Sensor Technologies": [3262],
    "EIC Semiconductor, Inc.": [2439],
    "EKSMA Optics": [3731],
    "Elba Lubes": [2615],
    "Elco (AVX)": [478],
    "Elcom International Pvt Ltd.": [3464],
    "Elcon Connectors / TE Connectivity": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "Electric Imp": [1413],
    "Electric Motors & Specialties": [3214],
    "Electro Corp (Honeywell Sensing and Productivity Solutions)": [480],
    "Electro-Films (EFI) / Vishay": [
        8026, 274, 112, 751, 56, 749, 541, 1135, 909, 716, 742, 693, 718, 1012, 764, 720, 1119, 1129, 1131,
    ],
    "Electronic Assembly (Display Visions)": [1481],
    "Electronic Concepts Inc.": [2563],
    "Electroreel Components, LLC": [2565],
    Electroswitch: [451],
    Electrotech: [2591],
    "Ellsworth Adhesives": [2281, 2275],
    "Elna America": [604],
    Elprotronic: [2366],
    "EM Microelectronic": [2651],
    "EMA Design Automation": [3416],
    "EMAC, Inc.": [2227],
    "Embedded Artists": [982],
    "EMC Test Design": [2804],
    "Emerging Power, Inc.": [2906],
    "Emerson Connectivity Solutions": [116, 24, 367, 1097, 1255, 652, 1299, 1427, 2110, 2111, 1599],
    "Emerson Embedded Power (Artesyn Embedded Technologies)": [454, 1078, 393],
    "Emerson SolaHD": [2106],
    "EMI Filter Co": [2478],
    EMIT: [16, 2654],
    "EMO Inc.": [3759],
    Enclustra: [2879],
    "Encoder Products Company": [2239],
    enDAQ: [2579],
    "Energizer Battery Company": [547],
    "Energy Micro (Silicon Labs)": [336, 1586],
    EnerSys: [842],
    "ENG ELECTRIC CO., LTD": [3209],
    "ENM Counting Instruments": [2140],
    "enmo Technologies": [1733],
    "Enmotus, Inc.": [3510],
    EnOcean: [1084],
    "EOS Power": [2107],
    EPC: [917],
    "EPCOS (TDK)": [495],
    "e-peas SA": [2658],
    "EPS WORKS SL (ArduSimple)": [3619],
    Epson: [114, 502, 8031],
    "EPtronics, Inc.": [2367],
    "Equinox Technologies": [483],
    EREM: [72],
    "Ergo Advantage": [3245],
    "ERNI Electronics": [2684],
    "ERP Power": [1800],
    "Espressif Systems": [1904, 1965],
    "ESPROS Photonics AG": [2199],
    "Essen Deinki": [3303],
    "Essentra Access Solutions": [2082],
    "Essentra Access Solutions / Mesan": [2082],
    "Essentra Components": [145],
    "Essentra Components / Alliance": [145],
    "Essentra Components / Micro Plastics, Inc.": [145],
    "Essentra Components / Richco, Inc.": [145],
    "ESTA / Vishay": [56, 1896, 749],
    Estatec: [2490],
    "E-Switch": [141],
    "E-T-A": [302],
    "ETA Compute": [2742],
    "ETA-USA": [2387],
    Ethertronics: [939],
    "Etron Technology": [2174],
    EuControls: [3212],
    "Eupec (Infineon)": [448],
    "Ever Win International Corporation": [3042],
    "Eveready (Energizer Battery Company)": [547],
    "Everlight Electronics": [1080],
    "Everspin Technologies, Inc.": [819],
    Everswitch: [3660],
    "Exar (MaxLinear)": [1016],
    ExAscend: [3044],
    "Excelitas Technologies": [1601],
    Excelsys: [633, 2309],
    Excelta: [2827],
    Exeltech: [3107],
    "Exostiv Labs": [3650],
    "Extech (FLIR Extech)": [1669],
    EXXELIA: [2821],
    "Eyecloud, Inc.": [2990],
    "eze System, Inc.": [3755],
    "E-Z-Hook": [461],
    "EZQuest, Inc.": [3058],
    "Fairchild (ON Semiconductor)": [261, 8007, 46, 1567],
    "Fair-Rite Products Corp.": [1934],
    "Falconer Electronics, Inc.": [2350],
    "Fan-S Division / Qualtek Electronics Corp.": [189],
    "Fanstel Corp.": [1914],
    "FATH Inc.": [2724],
    "FCi Basics (Amphenol ICC)": [609, 664, 2188],
    "FCT Electronics - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "FDK America": [935],
    Fechometal: [2466],
    "Fedco Batteries": [1706],
    "FEIG ELECTRONIC": [629],
    "FEITIAN Technologies": [3036],
    FERROXCUBE: [1779],
    Festo: [2171],
    "Fiber Instrument Sales": [2641],
    "FiberSource, Inc.": [2444],
    "FIBOX Enclosures": [2319],
    "Finder Relays, Inc.": [2066],
    "Fingerprint Cards AB": [2304],
    "Finisar Corporation": [775],
    FinishAdapt: [2206],
    "FIT (Foxconn Interconnect Technology)": [1685],
    "Flamar - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Flambeau, Inc.": [510],
    "Flex Power Modules": [2166],
    FlexPoint: [2514],
    Flexxon: [3052],
    "Flip Electronics": [2832],
    FLIR: [2067],
    "FLIR Extech": [1669],
    "FLIR Lepton": [1577],
    "Floyd Bell, Inc.": [2339],
    "Fluke Electronics": [614],
    "Fluke Networks": [1986],
    Flusso: [3638],
    "Focus LCDs": [2632],
    "Formerica Optoelectronics Inc.": [1785],
    "Formosa Microsemi Co. Ltd.": [3584],
    Fotofab: [2811],
    "Fox Electronics": [631],
    "Foxconn OE Technologies": [1685],
    "FRÄENKISCHE INDUSTRIAL PIPES": [2124],
    "FRÄENKISCHE USA, LP": [2124],
    Free2move: [647],
    "Freescale / NXP Semiconductors": [568, 375, 8018, 8065],
    "Freescale Semiconductor, Inc. (NXP Semiconductors)": [375],
    "FreeWave Technologies, Inc.": [2108],
    "Fremont Micro Devices": [1219],
    "FRESH DIGIT": [3498],
    "Frontier Electronics": [2819],
    "FSP Technology": [2967],
    "FTDI (Future Technology Devices International, Ltd.)": [768],
    FTS: [3003],
    "Fujitsu Electronics America, Inc.": [865],
    FULLSTEM: [3231],
    "Furuno (Kaga Electronics USA)": [62],
    Fuspower: [2375],
    Futaba: [2279],
    Future: [3094],
    "Future Designs, Inc.": [622],
    "Future Technology Devices International, Ltd.": [768],
    "Gaia Converter": [2551],
    "Gamma Electronics": [2807],
    "GAPTEC Electronic": [3182],
    GardTec: [1997],
    "Garmin Canada Inc.": [1094],
    "Gas Sensing Solutions Ltd": [2091],
    "Gateworks Corporation": [2518],
    "GC Electronics": [183],
    GCT: [2073],
    "GE Critical Power (ABB Embedded Power)": [555, 8012, 235],
    Geckodrive: [2465],
    "GEDORE Tools, Inc.": [2128],
    "Gemalto (Thales DIS)": [2213],
    "Genasun by Sunforge LLC": [3310],
    "General Cable": [42],
    "General Semiconductor (Vishay)": [8026],
    "GeneSiC Semiconductor": [1242],
    Genicom: [2096],
    "Genuino (Arduino)": [1050],
    "GES High Voltage": [2961],
    "Gettop Acoustics": [2631],
    "Geyer Electronic America, Inc.": [2482],
    "GHI Electronics, LLC": [1711],
    GigaDevice: [1970],
    "Glas-Col, LLC": [2980],
    "GLF Integrated Power": [2500],
    "Global Connector Technology, Limited (GCT)": [2073],
    "Global Specialties": [1769],
    "Global Technologies Group, Inc.": [3390],
    "GlobTek, Inc.": [1939],
    Glowforge: [2810],
    "GMEMS Technologies": [3533],
    "GMW Associates": [3663],
    GotRad: [3306],
    "GP Systems GmbH": [3280],
    GradConn: [2072],
    "Grayhill, Inc.": [136],
    "Greenlee Communications": [131],
    "Grepow Inc.": [3254],
    GroupGets: [2077],
    "GS Software": [3057],
    "GSI Technology": [2364],
    "GWConnect - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "H&D Wireless": [1036],
    "H.G. Schaevitz, LLC / Alliance Sensors Group": [1817],
    "Hagiwara Solutions": [3513],
    Hakko: [1691],
    "Hallsten Innovations": [3529],
    "Hamlin / Littelfuse": [18, 3766, 33, 53, 143, 8011, 238, 8032, 212, 1898],
    "Hammond Manufacturing": [164],
    "Hankscraft, Inc.": [2406],
    HARTING: [1195],
    "Harvatek Corporation": [3147],
    Harwin: [952],
    "Hasco Relays": [2595],
    Hayata: [3056],
    "HDP Power": [1987],
    Heatron: [1503],
    Helium: [1900],
    "Helix Semiconductors": [2117],
    HellermannTyton: [1436],
    "Henkel / Bergquist": [211],
    "Henkel/Loctite": [1000, 999, 82, 211],
    "Henrich Electronics Corporation": [1953],
    "Heraeus Nexensos USA": [1759],
    "High Speed Backplane Products (Amphenol ICC)": [609, 664, 2188],
    "High Speed IO (Amphenol ICC)": [609, 664, 2188],
    "High-Tech Conversions": [2948],
    "Hillcrest Labs (CEVA)": [1888],
    "HI-LO Systems": [3423],
    "HiRel Systems / Vishay": [541, 1135],
    Hirose: [26],
    Hirschmann: [1797],
    "Hitec Commercial Solutions LLC": [2589],
    HiTek: [633, 2309],
    "Hittite (Analog Devices)": [505],
    HKC: [3305],
    "HMS Networks": [1976],
    HOBO: [3016],
    Hoffman: [1441],
    Hologram: [1887],
    "Holsworthy Resistors / TE Connectivity": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "Holt Integrated Circuits, Inc.": [1245],
    "Holy Stone Enterprise": [2873],
    "HOMEVISION TECHNOLOGY INC.": [3608],
    "Honeywell Aerospace": [342],
    "Honeywell Sensing and Productivity Solutions": [480, 1566, 1409],
    "Hong Kong X’tals Limited (HKC)": [3305],
    "Horus Scope": [3568],
    "Hosonic Electronic": [3186],
    "HPC Optics": [2842],
    "Hubbell Lighting Components (Thomas Research Products)": [1121],
    "HVM Technology, Inc.": [2244],
    HYPERSPACE: [3495],
    "I W Tremont": [2943],
    "I/O Interconnect": [111],
    "IAC Industries": [2809],
    "IAR Systems Software Inc": [854, 8074],
    "iBASE Technology": [2228],
    "ICCNexergy (Inventus Power)": [166],
    "ICP DAS USA Inc.": [2488],
    "Ideal Power": [2882],
    "Ideal-tek": [2014],
    IDEC: [1885],
    "IdentaZone Inc.": [3671],
    "IDT (Renesas Electronics America)": [800, 1725, 1833],
    "iEi Technology": [2560],
    iFixit: [2434],
    "ifm Efector": [2330],
    Ignion: [2115],
    "Ignion (Fractus Antennas)": [2115],
    "Igus, Inc.": [2389],
    "II-VI Marlow": [1681],
    "iKey, Ltd.": [3081],
    "Illinois Capacitor": [1572],
    illumequip: [2846],
    ILLUMRA: [1082],
    ILSI: [2780],
    "Imagination Supply Co": [2334],
    Imperix: [3497],
    IMS: [3207],
    "Industrial Fiber Optics, Inc.": [107],
    "Industrial Safety Controls, Inc.": [3690],
    "Industrial Shields": [2198],
    IndustrialeMart: [2371],
    "IndustrialSupplies.com": [3539],
    "Infineon Technologies": [448],
    Infiray: [3733],
    "Initial State Technologies, Inc.": [1693],
    "InnoSenT GmbH": [2191],
    "Innovasic Semiconductor / Analog Devices, Inc.": [1108],
    "Innovative Sensor Technology": [2952],
    Innovisionsemi: [2812],
    Inolux: [1830],
    iNRCORE: [1902],
    "Insight SiP": [1786],
    "Insignis Technology Corporation": [1982],
    "Inspired LED": [1647],
    "Integra Enclosures": [2321],
    "Integra Technologies": [2251],
    "Integrated Device Technology (IDT) ": [800, 1725, 1833],
    "Integrated Device Technology (Renesas Electronics America)": [800, 1725, 1833],
    "Integrated Power Designs": [2625],
    "Integrated Silicon Solution, Inc. (ISSI)": [706],
    Intel: [544, 2311],
    "Intelligent Technology Trade": [3595],
    Intematix: [1079],
    "InterCon Systems (Amphenol ICC)": [609, 664, 2188],
    "Interconnect Systems - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Interlink Electronics": [1027],
    "International Components Corp.": [2377],
    "International Power DC Power Supplies": [2695],
    "International Rectifier (Infineon Technologies)": [448],
    "International Test Instruments Corporation": [3448],
    Interpower: [2710],
    "Intersil (Renesas Electronics America)": [20],
    "Introspect Technology": [3025],
    "Intwine Connect LLC": [2559],
    "InvenSense/TDK": [1428],
    "Inventek Systems": [1475],
    "Inventus Power": [166],
    "Io Audio Technologies": [1937],
    "IOT-BOTS.COM": [3430],
    "IoThink Solutions": [3349],
    IoTize: [2087],
    "Iowa Scaled Engineering": [3278],
    "I-PEX": [3508],
    "IQD Frequency Products": [1923],
    "IR (Infineon Technologies)": [448],
    "IRISO Electronics": [2248],
    "IRTOUCH Systems Co., Ltd.": [653],
    ISC: [3439],
    "ISL Products International": [2685],
    "Isocom Components": [58],
    "ISSI (Integrated Silicon Solution, Inc.)": [706],
    "itbrainpower.net/R&D Software Solutions": [3252],
    Iteco: [3602],
    "ITG Electronics, Inc.": [3013],
    "ITT Cannon, LLC": [1003, 998, 1408, 2009],
    "ITT Interconnect Solutions": [1003, 998, 1408, 2009],
    "ITW Chemtronics (Chemtronics)": [75, 8047],
    "iVativ Inc.": [3538],
    "iWave Systems": [2503],
    "IXYS / Littelfuse": [238, 8032, 1898, 212],
    "IXYS Integrated Circuits Division": [238, 8032, 1898, 212],
    "IXYS RF": [238, 8032, 1898, 212],
    "J.W. Miller / Bourns": [118],
    "J.W. Winco": [2419],
    Jabil: [2646, 3285, 3227, 3534],
    Jacob: [2291],
    "JAE Electronics": [670],
    "Jameson LLC": [2219],
    "Janesville Tool & Mfg. Inc.": [3075],
    "Janus Remote Communications": [2360],
    "Jasper Electronics": [3178],
    "Jauch Quartz": [1908, 3027],
    "JBC TOOLS USA INC.": [2761],
    "JBL Products, Inc.": [2405],
    "Jensen Global Inc.": [2045],
    "Jinlong Machinery & Electronics, Inc.": [1670],
    "JKL Components Corporation": [289],
    "Johanson Dielectrics, Inc.": [709, 8043],
    "Johanson Manufacturing": [1956],
    "Johanson Technology": [712],
    "Johnson / Cinch Connectivity Solutions": [116, 24, 367, 1097, 1255, 652, 1299, 1427, 2110, 2111, 1599],
    "Johnson Electric - Ledex Dormeyer Saia": [2024],
    "Jonard Tools": [40],
    Jorjin: [2393],
    Joulescope: [3295],
    "JRC Corporation / NJRC": [190],
    JST: [455],
    "Judco Manufacturing, Inc.": [78],
    JULABO: [2880],
    "Kaga Electronics USA": [62],
    "Kainos Systems": [2650],
    Kamaya: [2315],
    "Kang Yang International": [2862],
    "Kavlico Pressure Sensors / Sensata Technologies": [1861],
    "Keene Village Plastics": [2324],
    "Keil (ARM)": [685],
    "Keller America Inc.": [3092],
    KEMET: [399, 1001, 1680],
    "Kendall Howard": [2934],
    "Kennedy Labs": [1767],
    "Kepco Power": [2759],
    Kester: [117],
    "Keystone Electronics Corp.": [36],
    Khadas: [2064],
    Khatod: [1621],
    "Kilo International": [226],
    "Kilovac Relays / TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    Kimya: [2823],
    "Kinetic Technologies": [2763],
    Kingbright: [754, 3011],
    "Kings (Winchester Electronics)": [991],
    Kingston: [3217],
    Kionix: [1191],
    "Kioxia America, Inc.": [1853],
    Kitronik: [1927],
    "Klein Tools": [1742],
    "Knick Interface": [2834],
    "KNIPEX Tools": [2172],
    Knowles: [423],
    "Knowles DLI": [1761],
    "Knowles Johanson Manufacturing": [1956],
    "Knowles NOVACAP": [1763],
    "Knowles Syfer": [1608],
    "Knowles Voltronics": [1674],
    "KOA Speer Electronics, Inc.": [2019],
    "Krohn-Hite Corporation": [2930],
    "Kübler, Inc.": [2308],
    "KUKA Robotics ": [2122],
    "KUNBUS GmbH": [2178],
    KUROKESU: [3313],
    "Kurtz Ersa, Inc.": [2519],
    Kycon: [2092],
    "KYOCERA Corporation": [1253],
    "Kyocera Display": [73],
    "L3 Narda-MITEQ": [1949],
    LabJack: [2173],
    "Laird - Antennas": [994],
    "Laird - Performance Materials": [903, 926, 240],
    "Laird Connectivity": [776],
    "Laird Connectivity (LSR)": [1070, 776],
    "Laird Thermal Systems": [1487],
    Lantronix: [1829],
    "LAPIS Technology": [846, 511, 8056, 1191],
    LAPP: [2181],
    "Lascar Electronics": [2136],
    "Laser Technology, Inc.": [2018],
    "Lattice Semiconductor": [220],
    "Leader Tech Inc. ": [1798],
    "LeCroy (Teledyne LeCroy)": [1133],
    "LED Engin": [1537],
    "LED Lighting Inc.": [2712],
    "LEDdynamics, Inc.": [788],
    "Ledex Dormeyer Saia": [2024],
    LEDiL: [711],
    "LEM USA, Inc.": [398],
    LEMO: [1124],
    "Leopard Imaging Inc.": [2289],
    "Lepton (FLIR Lepton)": [1577],
    Leuze: [2540],
    "LICAP Technologies": [2610],
    "Lighthorse Technologies Inc.": [2868],
    "Lighting Science": [521],
    "Lilliput Electronics USA": [2416],
    "Lime Microsystems": [1434],
    "Limited (Amphenol Pcd)": [623, 1032, 1591],
    "Lin Engineering": [2090],
    "Linear Integrated Systems, Inc.": [3218],
    "Linear Technology (Analog Devices, Inc.)": [505, 1127, 161, 8054, 855],
    "Link Labs": [1616],
    "Linx Technologies": [343],
    "Lite-On, Inc.": [160],
    Littelfuse: [18, 3766, 33, 53, 143, 8011, 238, 8032, 212, 1898],
    "LMB Heeger, Inc.": [57],
    "Loadstar Sensors": [2263],
    "LOCTITE / Henkel": [1000, 999, 82, 211],
    LoggerFlex: [3523],
    "Logic PD (Beacon EmbeddedWorks)": [460],
    "Logical Systems": [309],
    LogiSwitch: [2978],
    "LOW PIM RF/Mobiyu Corporation": [2750],
    "LPD TRADE INC": [3765],
    "LSI/CSI": [2808],
    "LTI (Laser Technology, Inc.)": [2018],
    "LTW (Amphenol LTW)": [1754],
    LulzBot: [1942],
    "Lumberg Automation": [1794],
    "Lumex, Inc.": [67, 8024],
    Lumileds: [1416],
    "Luminary Micro/Texas Instruments": [296, 8003],
    "Luminus Devices": [1214],
    "Lumissil Microsystems": [2521],
    "Luna Optoelectronics (Advanced Photonix)": [209],
    "Lunasea Lighting": [2672],
    Luner: [2950],
    LUXTECH: [2061],
    "Lyn-Tron": [3093],
    "M+A Matting": [2384],
    M5Stack: [2221],
    Macchina: [2325],
    Machinechat: [2953],
    "MACOM Technology Solutions": [1465, 1657, 1700, 1702],
    "Macraigor Systems LLC": [1041],
    "Macromatic Industrial Controls": [2561],
    Macronix: [1092],
    "Made Systems": [2609],
    MadgeTech: [3283],
    "Maestro Wireless Solutions (Lantronix)": [1829, 1530],
    "Mag Layers": [2669],
    MagicDAQ: [3198],
    "Mag-LED Solutions": [1518],
    "Magna-Power Electronics": [2205],
    "Magnasphere Corp.": [735],
    "Magnetic Shield Corporation": [2875],
    "Magnitude Lighting": [3165],
    "Maida Development Company": [2693],
    "Major League Electronics": [2611],
    Makeblock: [1890],
    MakersLED: [3073],
    "MAKESafe Tools, Inc.": [3404],
    "Mallory Sonalert Products": [458],
    "Man & Machine Inc.": [3350],
    "Maple Systems": [2212],
    "Mark-10": [2779],
    "Marktech Optoelectronics": [1125],
    "Marlin Technologies": [2617],
    "Marlow Industries, Inc.": [1681],
    Marutsuelec: [1796],
    "Marvell Semiconductor, Inc.": [2208],
    Masach: [2333],
    "Master Appliance Corp.": [133],
    "MATRIX Industries": [2225],
    "MATRIX Labs": [2523],
    "Matrix Orbital": [635],
    "Matter and Form": [3678],
    "Maudlin Products": [2738],
    "MaxBotix Inc.": [1863],
    "Maxim Integrated": [175, 8022],
    MaxLinear: [1016],
    "MaxStream (Digi International)": [602, 8038, 504, 316],
    "Maxwell Technologies, Inc.": [1182],
    "MCB Industrie/Vishay": [716],
    "McGraw-Hill Education": [1751],
    mCube: [2548],
    "MEAN WELL": [1866],
    "Measurement Computing Corporation": [3159],
    "Measurement Specialties / TE Connectivity": [223],
    "MEC switches": [882],
    Mechatronics: [1570],
    "Mechatronics Bearing Group": [1995],
    Meftronics: [2499],
    MegaChips: [1654, 2065],
    Megapro: [2355],
    Melexis: [413],
    "Memory Protection Devices": [61],
    MEMSIC: [1267],
    "Menda/EasyBraid/Tronex ": [154, 8076],
    "Mentech Technology USA Inc.": [2659],
    "Mercury United Electronics": [2425],
    Meritek: [2997],
    "Mesan (Essentra Access Solutions)": [2082],
    "Metelics (MACOM Technology Solutions)": [1465, 1657, 1700, 1702],
    "Methode Datamate": [3265],
    "METZ CONNECT": [1849],
    "Mezzanine Products (Amphenol ICC)": [609, 664, 2188],
    "MG Chemicals": [473],
    "Micrel / Microchip Technology": [150, 8008],
    Micrium: [1072],
    "Micro Commercial Components (MCC)": [353],
    "Micro Connectors, Inc.": [2768],
    "Micro Crystal": [2195],
    "Micro Plastics, Inc. (Essentra Components)": [145],
    "Micro/sys": [970],
    MicroCare: [2805],
    "Microchip Technology": [150, 8008],
    "Microfire LLC": [3780],
    "Micro-Measurements / Vishay Precision Group": [1033],
    "Micromega Dynamics Recovib": [3662],
    "Micron Technology": [557, 8053],
    "Micronas / TDK": [246],
    "Micronel USA": [3114],
    Micronet: [3071],
    "Micropower Battery Company": [2984],
    Microsemi: [8035, 549, 278, 1403, 877, 1100, 691, 907, 1814, 1086, 1088, 1259],
    "Microwave Technology": [1203],
    "Mid Atlantic Rugged Systems": [3242],
    "Midas Displays": [3086],
    "Mide Technology": [997],
    "Midwest Microwave / Cinch Connectivity Solutions": [116, 24, 367, 1097, 1255, 652, 1299, 1427, 2110, 2111, 1599],
    "Midwest Motion Products": [3163],
    MightyZAP: [3275],
    MikroElektronika: [1471, 3432],
    "Mill-Max": [54],
    "Mills / Vishay": [274],
    "Millspaw Electronics": [2933],
    "Milwaukee / Vishay": [274],
    "MinebeaMitsumi / NMB": [12, 942, 8061],
    "Mini-Circuits": [3157],
    MISCO: [2806],
    "MITEQ, Inc.（L3 Narda-MITEQ）": [1949],
    "mitex LLC": [3297],
    "Mitsubishi Materials U.S.A": [2259],
    "Mitsumi  Electric Company": [2508],
    "MM Newman Corporation": [3610],
    "MMB Networks": [1096],
    MMD: [2775],
    "Mobiveil Technologies": [3440],
    Moddable: [3428],
    "Moffatt Products": [2556],
    Molex: [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Affinity Medical Technologies ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Beau Interconnect ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Bittware": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Brad Harrison": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Contrinex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex FCT Electronics ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Flamar ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex GWConnect ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Interconnect Systems ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Nallatech": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Nistica": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex NuCurrent": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Oplink Communications, LLC": [1720],
    "Molex Phillips-Medisize": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex PolyMicro Technologies ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex SensorCon": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Temp-Flex ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Triton Manufacturing": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Molex Woodhead ": [8093, 23, 900, 1454, 1520, 1720, 2605],
    Monnit: [1859],
    MonoDAQ: [3038],
    "Monolithic Power Systems": [1589],
    "Monsoon Solutions Inc.": [3333],
    Monzite: [2975],
    Mornsun: [2725],
    MoSys: [2331],
    Moujen: [3453],
    "Move-X": [3673],
    MP: [2473],
    "MP Antenna": [2421],
    "MPD (Memory Protection Devices)": [61],
    "MPS (Monolithic Power Systems)": [1589],
    "MTE Corporation": [2237],
    MtronPTI: [3655],
    "Mueller Electric Co.": [314],
    MULTIDIMENSION: [3542],
    "Multi-Tech Systems, Inc.": [591, 881, 8057],
    "Multi-Tek": [2814],
    "Murata Electronics": [490, 8051, 551],
    "Murata Power Solutions": [811],
    Murrplastik: [2160, 3504],
    myDevices: [2119],
    "MYIR Tech Limited": [3309],
    "N2 Power": [3243],
    NAC: [2596],
    "Naina Semiconductor Ltd.": [3489],
    "Nakagawa Manufacturing USA, Inc.": [258],
    "Nallatech - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    Nanmac: [2247],
    "Nano3DPrint/Carbon Design Innovations": [2520],
    "Nanoport Technology Inc.": [3151],
    "Nanotron, an Inpixon Company": [2897],
    "National Control Devices": [2273],
    "National Instruments (NI)": [2770],
    "National Semiconductor/Texas Instruments": [296, 8003],
    "Navitas Semiconductor": [1913],
    "Navman Wireless (Telit)": [943],
    NDK: [644],
    Nearson: [730],
    "Neohm Resistors / TE Connectivity": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    Neonode: [1816],
    "Neptune Control": [2461],
    "Nesscap Co., Ltd": [589],
    "NetBurner, Inc.": [528],
    "Netlist Inc.": [2655],
    "NetPower Corporation": [2392],
    "New Age Enclosures": [2362],
    "New Boundary Technologies, Inc.": [3118],
    "New Energy": [1672],
    "New Japan Radio (NJR)": [190],
    "Newava Technology": [470],
    "Newhaven Display, Intl.": [757],
    Newland: [2637],
    "NexLight-PerfectSense": [2983],
    Nexperia: [1727],
    "Next Industries SRL, The Tactigon": [2386],
    "Nextera Video": [2550],
    "NextGen Components": [3372],
    "NEXUS (Amphenol NEXUS Technologies)": [1967],
    "NGD Systems": [3597],
    NI: [2770],
    Nichicon: [493],
    Nicomatic: [2645],
    "Nidec Copal Electronics": [563],
    "NightShade Electronics": [3635],
    NimbeLink: [1477, 1749],
    "Nippon Chemi-Con": [565],
    "Nippon Pulse America": [2866],
    Niryo: [3274],
    "Nistica - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "NK Technologies": [3249],
    "NKK Switches": [360],
    "NMB Technologies Corp.": [12, 942, 8061],
    "Nominal Controls": [3087],
    NorComp: [37],
    "Nordic Semiconductor": [1490],
    "Noritake Co., Inc.": [286],
    "North Atlantic Industries (NAI)": [2745],
    "Northern Mechatronics Inc.": [3406],
    "Northwest Scada": [3696],
    NOVACAP: [1763],
    "NovaSensor (Amphenol Advanced Sensors)": [45],
    "Novasom Industries": [3449],
    "Novus Automation": [3588],
    Nowi: [3344],
    "NTE Electronics, Inc.": [2368],
    "NuCurrent - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Nuvoton Technology Corporation America": [816],
    "NuWaves Engineering": [3069],
    "NVE Corporation": [390, 391, 8018],
    nVent: [3661],
    "nVent Birtcher": [8092, 1440, 1439],
    "nVent Calmark": [8092, 1440, 1439],
    "nVent Hoffman": [1441],
    "nVent Schroff": [8092, 1440, 1439],
    "NXP Semiconductors": [568, 375, 8018, 8065],
    "O.C. White Co.": [1844],
    "Octavo Systems": [1676],
    ODU: [1907],
    "OEG Relays / TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "OHM Americas": [3680],
    Ohmite: [273, 2485],
    "OK Industries (Jonard Tools)": [40],
    OKdo: [2261],
    "Ole Wolff": [3253],
    Olimex: [1188],
    Omnetics: [2262],
    OmniPreSense: [2887],
    "OmniVision Technologies": [884],
    "Omron Automation": [236],
    "Omron Electronics Components": [39, 8009],
    "OMS Motion": [3236],
    "ON Semiconductor": [488, 261, 1567, 46],
    OneSimCard: [3043],
    "Onion Corporation": [2070],
    "On-Shore Technology, Inc.": [52],
    "Oplink, a Molex company": [1720],
    OptConnect: [2241],
    "Optek Technology/TT Electronics": [365],
    OptiFuse: [2298],
    "Optilumen Inc.": [3144],
    "Optimus Logic": [3397],
    "Option NV": [1468],
    Optiwave: [3525],
    "Opto Diode Corporation": [958],
    Orbel: [2347],
    "O'Reilly Media, Inc.": [1653],
    "Orient Display": [2544, 3444],
    "Orion Fans": [1053],
    Oscium: [2552],
    Osela: [3674],
    "OSEPP Electronics": [2234],
    "Oshino Lamps": [3029],
    "OSI Optoelectronics": [2640],
    "OSRAM Opto Semiconductors, Inc.": [475],
    Oupiin: [2553],
    "OVERCONN SRL": [3640],
    "OWON Technology Lilliput Electronics": [2250],
    "Oyen Digital": [3684],
    "P1dB, Inc.": [3648],
    "Pacer Instruments": [2853],
    "Pacific Goal": [3318],
    "Packet Digital LLC": [1156],
    Pactech: [3505],
    Paktron: [3215],
    "Paladin Tools (Greenlee Communications)": [131],
    "Palmer Wahl Instruments, Inc.": [2628],
    PalmSens: [2802],
    Panasonic: [8001, 276, 11, 656, 219, 255, 8069, 10, 9, 1110, 1903],
    PanaVise: [74],
    "Panduit Corporation": [298],
    "Parallax, Inc.": [149],
    "Parker Chomerics": [1944],
    "Parlex Corp.": [215],
    Particle: [1878],
    "Patco Electronics": [195],
    "Patco Services": [91],
    "PCA Electronics, Inc.": [3110],
    "PCD / Amphenol": [623, 1032, 1591],
    "PCE Instruments": [3208],
    "P-DUKE Technology, Inc.": [2369],
    "Peak Electronic Design Ltd": [2013],
    "Peerless by Tymphany": [1699],
    "PEI-Genesis": [2403],
    "Pelonis Technologies": [3611],
    "Peltec Timers and Controls": [3357],
    Peplink: [3250],
    "Pepperl+Fuchs": [2046],
    "Peregrine Semiconductor (pSemi)": [1046],
    "Pericom Semiconductor Corp. (Diodes Incorporated)": [242],
    "Pervasive Displays": [1452],
    PFLITSCH: [2081],
    "Phase Dock Inc.": [2568],
    "PHIHONG USA": [993],
    "Philips (LUMILEDS)": [1416],
    "Phillips-Medisize - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Phoenix America": [2222],
    "Phoenix Contact": [277],
    "Phoenix Mecano": [8119, 902, 1758, 1757],
    "Phoenix Passive Components / Vishay": [
        8026, 274, 112, 751, 56, 749, 541, 1135, 909, 716, 742, 693, 718, 1012, 764, 720, 1119, 1129, 1131,
    ],
    "Photo Solutions, Inc.": [2694],
    "Phytec America": [2919],
    "Phyton, Inc.": [911],
    Phytools: [2633],
    "Pi Supply": [1910],
    "PIC GmbH": [2010],
    "Picker Components": [2634],
    "Piezo Electric Technology": [3412],
    "Piezo System Jena": [3490],
    "Piher Sensing Systems, an Amphenol company": [1993],
    "Pilot Things / 9386-2845": [3711],
    Pimoroni: [1778],
    "Piton Engineering": [3030],
    "pi-top": [1989],
    Pixelink: [2751],
    "Plastronics Sockets & Connectors": [2409],
    "Platinum Tools": [2692],
    "Playing With Fusion": [3405],
    "Plazmo Industries": [2657],
    "Pletronics, Inc.": [2402],
    "Pokit Innovations": [2235],
    "Pololu Corporation": [2183],
    Polymaker: [2890],
    "Polymer Optics Ltd.": [2372],
    "PolyMicro Technologies - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Polyrack Tech Group": [3168],
    "Polytech / Vishay": [56, 1896, 749],
    "Pomona Electronics": [501],
    "Pontiac Coil, Inc.": [527],
    Portescap: [403],
    "Posifa Technologies": [3567],
    "Potter & Brumfield Relays / TE Connectivity": [41],
    "Powell Electronics": [2992],
    "Power Connector": [2789],
    "Power Dynamics, Inc.": [2668],
    "Power Integrations": [596, 1810],
    "Power Solutions (Amphenol ICC)": [609, 664, 2188],
    "Power Sonic": [3164],
    Powerbox: [3180],
    "Powerbx Inc.": [3426],
    Powercast: [1964],
    "Powerex, Inc.": [835],
    "PowerFilm Inc.": [1996],
    "Power-One (Bel Power Solutions)": [179],
    PowerRESPONDER: [3298],
    PowerSight: [2986],
    "PowerStor (Eaton)": [283],
    "Powertip Technology Inc.": [2642],
    Powertraveller: [3522],
    POWERWAREHOUSE: [3167],
    "PRD Plastics": [193],
    "Preci-Dip": [1212],
    "Precision Design Associates, Inc.": [1230],
    "Precision Electronics Corporation": [98],
    "Precision Fiber MX": [3409],
    "Precision Resistive Products Inc.": [2557],
    "Precision Technology, Inc.": [1777],
    PrehKeyTec: [3034],
    "Premo S.A.U.": [3012],
    Prinsta: [3066],
    ProAnt: [1532],
    "ProComSol, Ltd.": [3583],
    "Prodigy SmartLock": [3420],
    "Prodigy Technovations": [3657],
    Productech: [3005],
    "Products Unlimited Transformers & Relays / TE Connectivity": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "Professional Cable": [3205],
    Promik: [2581],
    Prostat: [2505],
    "ProTek Devices": [2718],
    "Protektive Pak": [2293],
    pSemi: [1046],
    "PSI Technics GmbH": [3516],
    "Psiber Data Systems, Inc.": [2847],
    "PUI Audio, Inc.": [668],
    PULS: [1736],
    Pulsar: [182],
    "Pulse Electronics": [553, 8040, 1840, 1837],
    "PulseCore Semiconductor/ON Semiconductor": [488, 261, 1567, 46],
    "PulseLarsen Antenna": [553, 8040, 1840, 1837],
    "PulseR (iNRCORE": [1902],
    Pycom: [1871],
    "Pyro-E, Inc.": [3494],
    "Q-Cee's / TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    Qoitech: [1916],
    QST: [3001],
    "QT Brightek": [1516],
    Quadcept: [1619],
    Qualcomm: [660],
    "Qualcomm® RF front-end (RFFE) filter products": [1752],
    "Quallink Technology Inc.": [2592],
    "Qualtek Electronics Corp.": [189],
    "Quantum Integration": [2817],
    "Quantum Microwave Components": [3221],
    "Quarton, Inc.": [100],
    "Quatech / B+B SmartWorx": [1165, 590],
    Quectel: [2958],
    "Quest Manufacturing": [2215],
    "Quest Technology International": [2229],
    "R&R Lotion": [3329],
    "Rabbit Semiconductor (Digi)": [602, 504, 316],
    "Radial Magnets, Inc.": [469, 2517],
    "Radiall USA, Inc.": [2201],
    Radian: [3341],
    "Radio Bridge Inc.": [2027],
    RadioControlli: [3206],
    Radiocrafts: [1783],
    RAF: [1772],
    RAFI: [1715],
    Raltron: [2151],
    "Ramtron (Cypress Semiconductor)": [428],
    "Raspberry Pi": [1690, 2648],
    Rathbun: [3486],
    "RATOC Systems": [3501],
    "Raychem Cable Protection/TE Connectivity": [484],
    Raytac: [3271],
    "RDI Inc.": [2326],
    "Reach Technology": [3618],
    "RECOM Power": [945],
    "Rectron USA": [2516],
    "Red Lion": [68],
    "Red Pitaya": [3133],
    "REDEL / LEMO": [1124],
    "REED Instruments": [2867],
    "Rees, Inc.": [3264],
    REGAL: [3609],
    "Remington Industries": [2328],
    "Rendeer Systems": [3112],
    "Renesas Electronics America": [559, 1044, 20, 8034, 1725, 1833, 800],
    "Renetec, Inc.": [3146],
    "Rennsteig Tools": [3100, 2829],
    "Reonix Automation": [2903],
    "ReVibe Energy": [2030],
    "RevX Systems": [1998],
    "RF Industries": [2737],
    "RF Solutions": [357],
    "RFbeam Microwave GmbH": [2012],
    "RFE/Fuzetec": [3451],
    RFMD: [689, 8045],
    RFMi: [2410],
    "Rhomb.io": [3055],
    "RIA Connect / METZ CONNECT ": [1849],
    "Richco, Inc. (Essentra Components)": [145],
    Richtek: [1028],
    "RICOH Electronic Devices Co., LTD.": [2129],
    Riedon: [696],
    "Rieker Inc.": [2131],
    Rigado: [1604],
    "RIGOL Technologies": [2211],
    "Ritron Wireless Solutions": [3091],
    "RIVER/River Eletec Corporation": [3625],
    Riverdi: [3408],
    "R-K Electronics, Inc.": [3307],
    "RLE Technologies": [2740],
    ROBOTIS: [2700],
    RobotShop: [2513],
    "Rochester Electronics": [2156],
    "Rochester Gauges, LLC": [3241],
    "Rocom Couplings": [2413],
    "Roederstein / Vishay": [56, 1896, 749],
    "ROHM Semiconductor": [846, 511, 8056, 1191],
    "Rose Enclosures": [8119, 902, 1758, 1757],
    "Rose+Krieger": [8119, 902, 1758, 1757],
    Rosenberger: [1868],
    Rotrics: [3187],
    "Roving Networks / Microchip Technology": [150, 8008],
    "RPM Systems": [770, 2598],
    Rubycon: [1189],
    "Ruffy Controls": [2524],
    "Ruland Manufacturing": [3188],
    "Runic Technology": [3565],
    RushUp: [1770],
    "Russtech Engineering": [2760],
    "S.I. Tech, Inc.": [3352],
    "SAB North America": [2337],
    "Saelig Company Inc.": [3062],
    Sagrad: [831],
    "Saia (Division of Johnson Electric)": [2024],
    "Saiko Systems": [3457],
    "Samsung ARTIK": [1683],
    "Samsung Electro-Mechanics": [1276],
    "Samsung Semiconductor": [1510, 1683],
    "Samtec, Inc.": [612, 2031],
    "Sanken Electric Co., Ltd.": [1261],
    "SanMotion Products (Sanyo Denki)": [2300],
    Sanoxy: [2981],
    "SanUPS Products (Sanyo Denki)": [2385],
    "Sanyo Denki": [1688],
    "Sanyo Denki SanMotion Products": [2300],
    "Sanyo Denki SanUPS Products": [2385],
    "Sanyo Semiconductor/ON Semiconductor": [488, 261, 1567, 46],
    "Sanyou Relay": [3015],
    Sarnikon: [3591],
    "Schaffner EMC, Inc.": [817],
    "SchmalzTech, LLC": [3132],
    SchmartBoard: [1988],
    "Schrack Relays / TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "Schroff / nVent": [8092, 1440, 1439],
    SCHUNK: [2202],
    Schurter: [486],
    ScioSense: [2618],
    SCS: [1569],
    SD: [2856],
    "Sealing Devices, Inc.": [3445],
    Seeed: [1597],
    "Seek Thermal": [2126],
    "Segger Microcontroller Systems": [899],
    "Seiko Instruments, Inc.": [728],
    "SEIP (Sumitomo Electric Interconnect Products)": [2786],
    Seltech: [2673],
    "Semflex / Cinch Connectivity Solutions": [116, 24, 367, 1097, 1255, 652, 1299, 1427, 2110, 2111, 1599],
    "Semiconductor Circuits, Inc.": [2351],
    SemiQ: [1560],
    Semtech: [600, 1243],
    Senasys: [3376],
    Senix: [2078, 3068],
    Sensaphone: [2752],
    "Sensata Pressure & Temperature Sensors & Switches": [1862],
    "Sensata Technologies": [8118, 723, 1724, 172, 1861, 1862],
    "Sensata Technologies – Airpax": [723],
    "Sensata Technologies – BEI Sensors": [1724],
    "Sensata Technologies – Crydom": [172, 8041],
    "Sensata Technologies – Cynergy3": [725],
    "Sensata Technologies – Deltatech": [2149],
    "Sensata Technologies – Kavlico Pressure Sensors": [1861],
    "SENSE Software": [3113],
    Senseair: [2194],
    SensiML: [3703],
    Sensirion: [1649],
    "Sensor Electronic Technology": [2112],
    "SensorCon - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Sensorview America": [2723],
    "Seoul Semiconductor": [897],
    Septentrio: [2771],
    "Sequans Communications": [2972],
    "Sercalo Microtechnology Ltd.": [3524],
    "Serious Integrated": [1158],
    "Serpac Electronic Enclosures": [128],
    "Sevskiy GmbH": [3228],
    "SG Wireless Limited": [2427],
    "SGX Sensortech (Amphenol SGX Sensortech)": [1782],
    "Sharp Microelectronics": [425, 1149],
    "Sheetak, Inc.": [2498],
    "Shindengen America, Inc.": [2437],
    "Shoreline IoT": [2137],
    Siargo: [2257],
    "Siborg Systems Inc.": [3435],
    SICK: [1882],
    "Sierra Wireless": [1645, 1719],
    "Sierra Wireless by Talon": [1788],
    "Sifam Tinsley Instrumentation, Inc.": [2543],
    Sigfox: [1895, 1973, 2274],
    "Siglent Technologies": [2204],
    "Sigma Designs": [703],
    "Sigma Inductors / TE Connectivity": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "Signal Processing Group Inc.": [3338],
    "Signal Transformer": [595],
    "SIKA USA Inc.": [3171],
    "Silego Technology (Dialog Semiconductor)": [1564],
    "Silicon Labs": [336, 1586],
    "Silicon Motion": [1984],
    "Silicon Power": [2526],
    "Simco-Ion": [3037],
    SimpleChips: [3258],
    SINBON: [2960],
    "SINE Systems / Amphenol": [889],
    Siretta: [1679],
    "SIRIO Antenne": [2576],
    SiTime: [1473],
    "Sixfab, Inc.": [2428],
    "Skeleton Technologies": [2969],
    "Skenos Technologies, Inc.": [2424],
    SkyeTek: [753],
    "SkyHigh Memory Limited": [2120],
    "Skyworks Solutions, Inc.": [863, 1287, 8087],
    "SL Power Electronics - Manufacturer of Condor / Ault Brands": [271],
    "Sleek Socket": [3393],
    "Smart Prototyping/NOA Labs": [3099],
    "Smart Sensor Devices": [2908],
    "SMC Diode Solutions": [1655],
    "SMD Sensors": [2566],
    "Smith Systems, Inc.": [2594],
    "Soberton, Inc.": [433],
    "SOC Technologies (System-On-Chip Technologies)": [1962],
    "Socapex (Amphenol Pcd)": [623, 1032, 1591],
    "Socle Technology Corporation": [1855],
    SolaHD: [2106],
    "Solar Lighting International": [3413],
    "Solar Made": [2510],
    "Solid State Inc.": [2383],
    Solidlite: [3010],
    SolidRun: [1668],
    SoMLabs: [3128],
    "Songtian Electronics": [3487],
    "Sotcher Measurement Inc.": [2872],
    "Sound Devices, LLC": [3296],
    "Souriau-Sunbank by Eaton": [666, 874, 8055, 1539, 1792],
    "Southwire Company": [2564],
    "Space Coast Electronics": [2845],
    "Spansion (Cypress Semiconductor)": [428],
    SparkFun: [1568],
    "Spec Sensors": [1684],
    "Spectra Symbol": [905],
    SpotSee: [2297],
    "Sprague Goodman": [105],
    "Spruce Science": [3123],
    "SRA Soldering Products": [2260, 2349],
    "Sruite Electronic Technology": [3239],
    "SSI Technologies, Inc.": [734],
    "SST Sensing": [1921],
    "Stackpole Electronics, Inc.": [738],
    "Staco Energy Products Co.": [452],
    "Stage Ninja": [2555],
    "Stainless Steel Products": [2976],
    "Standex Electronics": [374],
    "Stanley Electric": [404],
    "START International": [2296],
    "Static Solutions, Inc.": [3541],
    StaticStop: [2900],
    Steinel: [96],
    "Stele Tech": [3421],
    Steute: [1743],
    "Stewart Connector": [380],
    "STI Vibration Monitoring": [2883],
    "STI-CO Industries": [2857],
    STL: [3308],
    STMicroelectronics: [497, 8090, 1138],
    "Storage & Server IO (Amphenol ICC)": [609, 664, 2188],
    "Storm Interface": [192],
    "Studio 1 Labs": [3644],
    "Suburban Embedded": [2587],
    "Suco Technologies Inc.": [3002],
    "Sullins Connector Solutions": [35],
    "Sumida Corporation": [308],
    Sumitomo: [2786],
    "Sumitomo Electric Interconnect Products (SEIP)": [2786],
    "Sungmun Electronics": [3261],
    SunLED: [1497, 3267],
    Sunon: [259],
    "Suntsu Electronics, Inc.": [2388],
    "Superior Asphalt Concepts": [3735],
    "Superior Sensor Technology": [2232],
    "Sure Electronics": [3471],
    "Sure-Fi": [3410],
    SURGE: [2616],
    Susumu: [408],
    "Suzhou Maswell Communication Technology Co. Ltd": [2626],
    "SV Microwave (Amphenol SV Microwave)": [1678, 3122],
    "Swanstrom Tools": [232],
    Swissbit: [1052],
    "Switch Components": [2299],
    "Switchcraft / Conxall": [137, 468, 8027],
    "SYBA USA": [3427],
    Syfer: [1608],
    "Synapse Wireless": [746],
    "Syndesy Technologies, Inc. ": [2054],
    Synzen: [3260],
    SystemBase: [3573],
    "System-On-Chip Technologies": [1962],
    "Tabor Electronics Ltd.": [2606],
    "Tadiran Batteries": [439],
    "TAEC Product (Toshiba Electronic Devices and Storage Corporation)": [264, 8083],
    "Tag-Connect": [1048],
    "Tagore Technology": [2713],
    "Taica Corporation": [1880],
    Taitien: [1664],
    "Taiwan Semiconductor": [1801],
    "TAIYO YUDEN": [587],
    Talema: [1295],
    "Tallysman Wireless": [1526],
    Tamura: [132],
    "TANE ALARM PRODUCTS": [3403],
    Taoglas: [931, 2599],
    TapeCase: [2636],
    TCI: [2431],
    "TDK Corporation": [445, 8044, 495, 1428],
    "TDK EPCOS": [495],
    "TDK InvenSense": [1428],
    "TDK Micronas": [246],
    "TDK Tronics (Tronics)": [1775],
    "TDK-Lambda, Inc.": [285],
    "TE Connectivity": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity Aerospace Defense and Marine": [844, 1122],
    "TE Connectivity ALCOSWITCH Switches": [450],
    "TE Connectivity AMP Connectors": [17, 1712, 2132, 2094],
    "TE Connectivity Corcom Filters": [174],
    "TE Connectivity DEUTSCH Connectors": [1508, 1208, 1506],
    "TE Connectivity DEUTSCH INDUSTRIAL & COMMERCIAL TRANSPORTATION": [1734],
    "TE Connectivity Measurement Specialties": [223],
    "TE Connectivity Potter & Brumfield Relays": [41],
    "TE Connectivity Raychem Cable Protection": [484],
    "TE Connectivity Raychem Circuit Protection / Littelfuse": [18, 3766, 33, 53, 143, 8011, 238, 8032, 212, 1898],
    "TE Connectivity's Agastat Relays": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity's Axicom Relays": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity's Buchanan Terminal Blocks": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "TE Connectivity's CGS Resistors": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity's CII": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity's Elcon Connectors": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "TE Connectivity's Holsworthy Resistors": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "TE Connectivity's Kilovac Relays": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity's Neohm Resistors": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "TE Connectivity's OEG Relays": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity's Products Unlimited Transformers & Relays": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "TE Connectivity's Q-Cee's ": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity's Schrack Relays": [8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132],
    "TE Connectivity's Sigma Inductors": [
        8004, 844, 450, 1122, 17, 174, 1208, 1508, 1506, 41, 484, 47, 223, 2109, 2132,
    ],
    "Tecate Group": [2085],
    "Teccor / Littelfuse": [18, 3766, 33, 53, 143, 8011, 238, 8032, 212, 1898],
    Techflex: [1030],
    "TechLogix Networx": [2956],
    TechNexion: [1405],
    "Techno / Vishay": [56, 1896, 749],
    Techspray: [1873],
    TechTools: [266],
    "Tecnomatic Corp": [2703],
    Tegam: [2664],
    "TEKTELIC Communications": [2287],
    "Tektos Design": [3284],
    "Tek-Trol": [3694],
    "Telaire (Amphenol Advanced Sensors)": [45],
    "TELE Controls, Inc.": [3483],
    "Teledyne LeCroy": [1133],
    Telegärtner: [2269],
    "Telit ": [943],
    "Tell-i": [3493],
    "Telonic Berkeley Inc.": [2546],
    "Temp-Flex - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Tempo Communications": [2177],
    Temprel: [2865],
    "Tensility International Corporation": [839, 1290],
    "Tera Grand": [2504],
    Terabee: [3074],
    Terasic: [771],
    "Test Products International (TPI)": [290],
    Tesuto: [3268],
    "TEWA Sensors LLC": [1912],
    "Texas Edge Computing": [2965],
    "Texas Instruments": [296, 8003],
    Texmate: [2584],
    TextSpeak: [3256],
    "TG3 Electronics": [2743],
    "t-Global Technology": [1168],
    "Thales DIS (Formerly Gemalto)": [2213],
    "Thales Visionix, Inc.": [1845],
    "The Fredericks Company": [2515],
    "The Gund Company": [2756],
    "The Imaging Source": [3134],
    "The Western Design Center Inc.": [2432],
    "Thermco Products, Inc.": [2966],
    "Thermo Heating Elements": [2855],
    "Thermoelectric Conversion Systems Ltd.": [3193],
    "Thermometrics (Amphenol Advanced Sensors)": [45],
    "THine Solutions": [3175],
    "ThingMagic, a JADAK Brand": [1523],
    "Thinxtra Solutions Limited": [1894],
    "Thomas Research Products": [1121],
    Tibbo: [3259],
    "Times Microwave Systems": [1946],
    TinyCircuits: [1832],
    TMB: [2888],
    "TNR TECHNICAL INC.": [3414],
    "TOKIN (KEMET)": [399],
    "TOKO / Murata": [490, 8051, 551],
    "Torex Semiconductor Ltd.": [893],
    "Toshiba Electronic Devices and Storage Corporation": [264, 8083],
    "Toshiba Memory America, Inc. (Kioxia America, Inc.)": [1853],
    "Touchstone Semiconductor": [1238],
    "Tower Products": [3468],
    "TPI (Test Products International)": [290],
    "TPK America LLC": [1176],
    "TRACO Power": [1951],
    "Trafag Sensors & Controls": [2264],
    "Transforming Technologies": [2240],
    Transko: [2492],
    Transphorm: [1707],
    Trek: [633, 2309],
    "Trenz Electronic": [1686],
    Treston: [2268],
    "Triad Magnetics": [237],
    "Triad Semiconductor": [2574],
    "Tridonic Inc.": [2538],
    "Trigon Components": [2747],
    "Tri-Mag, LLC": [2103],
    "TRINAMIC Motion Control GmbH": [1460],
    "Triplett Test Equipment and Tools": [2329],
    "Tripp Lite": [95, 2327],
    "Tri-Star Industries": [2254],
    "Triton Manufacturing - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "Trompeter / Cinch Connectivity Solutions": [116, 24, 367, 1097, 1255, 652, 1299, 1427, 2110, 2111, 1599],
    "Tronex (Menda/EasyBraid/Tronex)": [154, 8076],
    Tronics: [1775],
    "TRP Connector": [1419],
    Trumeter: [2218],
    Truphone: [2322],
    "TSC (Taiwan Semiconductor)": [1801],
    "TT Electronics": [8064, 987, 989, 365, 985, 1217, 1575, 1185],
    "TT Electronics / BI Technologies": [987],
    "TT Electronics / Optek Technology": [365],
    TubeDepot: [2197],
    "Tuchel / Amphenol": [889],
    "TurboFlex Heaters": [2271],
    "Twin Industries": [438],
    "TXC Corporation": [887],
    "Tyco Electronics": [8004, 1111, 844, 1122, 450, 17, 174, 1208, 1506, 41, 484, 47],
    "Tycon Systems, Inc.": [2414, 2303],
    "Tymphany (Peerless by Tymphany)": [1699],
    "U.S. Sensor (Littelfuse)": [18, 8011, 33, 53, 143],
    "u-blox": [672],
    UDOO: [1485],
    "UEi Test Instruments": [3603],
    "Ultra Librarian®": [1595],
    UltraVolt: [633, 2309],
    Uneo: [3527],
    "Ungar / Weller": [72],
    Unictron: [2047],
    "Union Semiconductor (HK) Limited": [3351],
    "Unirise USA": [2830],
    "United Chemi-Con": [565],
    UnitedSiC: [2312],
    "UNIVERSAL-SOLDER Electronics": [3647],
    "U-Reach Data Solutions, Inc.": [3007],
    "US Custom Billet": [3006],
    "US Electronics Inc.": [3544],
    "US Micro Screw": [3316],
    "US-Lasers, Inc.": [38],
    "USound GmbH": [2000],
    "VACUUMSCHMELZE GmbH & Co. KG.": [2258],
    "Vantron Technology": [2755],
    VaOpto: [2835],
    "Varitronix International Ltd.": [153],
    "VarTech Systems": [3601],
    "VCC (Visual Communications Company)": [28],
    VEAM: [1003, 998, 1408, 2009],
    "Vector Electronics & Technology, Inc.": [44],
    "Veinland GmbH": [3606],
    Vektrex: [2399],
    "Velab Co.": [2702],
    "Venkel LTD": [2679],
    Verivolt: [1780],
    "VersaLogic Corporation": [1241],
    VersaSense: [1737],
    "Versatile Power": [2927],
    Vesper: [2022],
    Vicor: [1102],
    Vicotee: [1732],
    "Vifa (Peerless by Tymphany)": [1699],
    "Viking Tech": [2577],
    "Viking Technology": [1803],
    "Virtins Technology": [3478],
    Virtium: [1550],
    "Virtual Industries, Inc.": [2441],
    VISATON: [2056],
    Vishay: [8026, 274, 112, 751, 56, 749, 541, 1135, 909, 716, 742, 693, 718, 1012, 764, 720, 1119, 1129, 1131],
    "Vishay / Beyschlag": [749],
    "Vishay / Cera-Mite": [56, 1896, 749],
    "Vishay / Dale": [541, 1135],
    "Vishay / Huntington Electric, Inc.": [274],
    "Vishay / Semiconductor - Opto Division": [751],
    "Vishay / Sfernice": [716],
    "Vishay / Siliconix": [742],
    "Vishay / Spectrol": [693],
    "Vishay / Sprague": [718, 1131, 1012],
    "Vishay / Thin Film": [764],
    "Vishay / Vitramon": [720, 1119],
    "Vishay BC Components/Beyshlag/Draloric": [56, 1896, 749],
    "Vishay General Semiconductor – Diodes Division ": [112],
    "Vision Engineering": [2286],
    "Visual Communications Company, LLC": [28],
    "Vitelec / Cinch Connectivity Solutions": [116, 24, 367, 1097, 1255, 652, 1299, 1427, 2110, 2111, 1599],
    "Volgen (Kaga Electronics USA)": [62],
    VolleyBoast: [2881],
    "Voltaic Systems": [2600],
    "Voltronics (Knowles)": [1674],
    "Vox Power": [2050],
    "VPG Foil": [804],
    "VPG Micro-Measurements": [1033],
    "VPG Sensors": [8067, 804, 1033],
    "Vue-More Manufacturing": [2426],
    "Vynckier Enclosures": [2558],
    WAGO: [2946],
    "Wakefield-Vette": [345],
    "Waldom Electronics": [2266],
    "Walsin Technology": [1292],
    Wandboard: [1406],
    "Watterott electronic": [2100],
    "Wave.N": [3170],
    "WCI (World Class Illumination)": [2474],
    "WECO Electrical Connectors": [3072],
    "WeEn Semiconductors Co., Ltd": [1740],
    Weidmuller: [281],
    Weller: [72],
    "Wenzel Associates, Inc.": [2381],
    WERMA: [2582],
    "Whitman Controls": [2155],
    "Wickmann / Littelfuse": [18, 3766, 33, 53, 143, 8011, 238, 8032, 212, 1898],
    Wiha: [431],
    "Wilcoxon (Amphenol Wilcoxon Sensing Technologies)": [2053],
    WIMA: [1928],
    "Winbond Electronics Corporation": [256],
    "Winchester Electronics": [991],
    "Winland Electronics": [3009],
    "WINSYSTEMS INC.": [3246],
    "Wintec Industries": [385, 2656],
    Wiss: [72],
    "WITHWAVE CO LTD": [3546],
    WIZnet: [1278],
    "Wolfspeed - a Cree company": [1697],
    "Woodhead - Molex": [8093, 23, 900, 1454, 1520, 1720, 2605],
    "worktables.com": [3392],
    "WPI / World Precision Instruments": [2624],
    "Würth Elektronik": [732, 1773, 1297, 1917, 2101],
    "Würth Elektronik iBE": [732, 1773, 1297, 1917, 2101],
    "Würth Elektronik ICS": [732, 1773, 1297, 1917, 2101],
    "Würth Elektronik Midcom": [732, 1773, 1297, 1917, 2101],
    "WyreStorm Technologies": [3129],
    Xaptum: [2203],
    Xcelite: [72],
    Xeltek: [415, 2578],
    "Xenarc Technologies": [3378],
    "Xenon Fever Defense, Inc.": [3371],
    XetaWave: [2433],
    "Xflight Technologies LLC": [2601],
    XFMRS: [2840],
    Xilinx: [122],
    XMOS: [880],
    "XP Power": [1470],
    "XS Power Batteries": [2722],
    Xsens: [1551],
    "XTAR Technology Inc.": [2791],
    "Y.C. Cable (East)": [2418],
    Yageo: [13],
    "Yamaichi Electronics": [2408],
    YIC: [3155],
    Yokowo: [2464],
    "YS Tech USA": [2373],
    "Z+F USA Inc.": [3033],
    Zendure: [2979],
    "Zentri (Silicon Labs)": [1586],
    "Zetex Semiconductors (Diodes Inc.)": [31, 8050, 89, 1034],
    "Zettler Magnetics": [2469],
    "ZEUS Battery Products": [2059, 2612],
    "ZF Electronics": [85],
    "Zilog / Littelfuse": [269],
    "Zimmer and Peacock": [2356],
    ZofzPCB: [3119],
};
/**
 * This function must be run inside the browser console to avoid 403 forbidden errors.
 * NOTE: Getting the full set of IDs is not trivial. See
 * https://www.digikey.com/en/supplier-centers/ . Each name may map to multiple
 * IDs. No API call returns IDs for a name directly. The best way I've found is
 * to parse the <meta> tags of detail pages such as
 * https://www.digikey.com/en/supplier-centers/panasonic .
 */
// eslint-disable-next-line import/no-unused-modules
export async function getManufacturerList() {
    const headers = {
        accept: "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9",
        "accept-language": "en-US,en;q=0.9,fr;q=0.8",
        "cache-control": "max-age=0",
        "sec-ch-ua": '" Not;A Brand";v="99", "Google Chrome";v="91", "Chromium";v="91"',
        "sec-ch-ua-mobile": "?0",
        "sec-fetch-dest": "document",
        "sec-fetch-mode": "navigate",
        "sec-fetch-site": "none",
        "sec-fetch-user": "?1",
        "upgrade-insecure-requests": "1",
        cookie: 'TS0138bc45=01460246b67eb39bff1d5b152d2424af9b2c33a781e1af8b71e8d50a4b6126d3bd9a9a344a4867353fcaadf4195a27d0b510c6c782; ASP.NET_SessionId=dbnvn443ky4rfn001eyqlhnk; SC_ANALYTICS_GLOBAL_COOKIE=61b7195960d440f8a898ca05b9eed317|False; EG-U-ID=E8603a612f-fd7d-45b1-beb7-41513701bff8; EG-S-ID=A76fb5f7c3-e9f9-4ea0-b221-7737104cf69f; _ga=GA1.2.1125802334.1623091221; _gcl_au=1.1.1735954555.1623091221; ai_user=lDI8457juDVIZVrKyY+t+/|2021-06-07T18:40:27.485Z; TS018060f7=01460246b6d410339904ca9fd29dfd11658c6e64e7440fee92c9274a6cf25e9501a75eca7bcba78f43a4cfa9b68fd529dc17ff0b27; optimizelyEndUserId=oeu1623791840811r0.4338563564711406; ken_gclid=CjwKCAjwn6GGBhADEiwAruUcKj9zSMX3WWnts_qwagw20sBrvN_3R_Rrb83KrLNMQBwXNAc67D6tOxoClC4QAvD_BwE; _gac_UA-88355857-46=1.1623792311.CjwKCAjwn6GGBhADEiwAruUcKj9zSMX3WWnts_qwagw20sBrvN_3R_Rrb83KrLNMQBwXNAc67D6tOxoClC4QAvD_BwE; _gcl_aw=GCL.1623792312.CjwKCAjwn6GGBhADEiwAruUcKj9zSMX3WWnts_qwagw20sBrvN_3R_Rrb83KrLNMQBwXNAc67D6tOxoClC4QAvD_BwE; LPVID=FiNGViMmFlNGQzZDYyZTNi; cur=USD; SiteForCur=US; domainSelect=com; pf-accept-language=en-US; ping-accept-language=en-US; TSfe8cbf36027=08374f23c1ab2000d38c7c9aaad8866b7aea26867c7b1c494d17347067cc5b9fa5a00dc46bfb3bc20830351f1e1130001f028f488a31f5cf77a5d2ebbace370d1f025aa8f58598175b4732b1223f608f067ecdc6e860bb6cbc702bf4246f0d51; search_prefs=%7B%22scrolling%22%3Afalse%7D; TS311bd558027=08374f23c1ab200020371ab27ecfceab96ddb7fed4eb09a24cf8d6acc4ce37ff1a4d908b6d6cb10d08c55d4cda1130000e03f0a666ddbf12ca75cce2098e34d7d22ad42b153617844e6e0de63ef0a655a5160d4d0c04efbdd7c42381e4e9ec2c; _evga_542b=5aca382166a78aa2.; TSe04c9a87027=08374f23c1ab200089507056c7f3649022fa9fc4fee9df3969fd4b8e417a732c9367c246c89f48b608bbf6bcd711300092998b2e21c744aa36daa3786a0fa6f0a4c1d1670bd9ba340e741448437b17b2dd9486f2cab77ceade7d75baa8d56c02; __RequestVerificationToken_L015RGlnaUtleQ2=4kJujXjGfysQf-fWNREZq444iYFexZhZpotgaEXWYRS8vKDQRJhXMyVQ1e82zOxG6C_H66BTz8jiCEsmvagkc_ofAPg1; TSbbfedf4b027=08374f23c1ab2000d3945239533df451d34c39dc6d8fbb3673088b4a3a4afa2799a9edb057f2eeb408c996a14d1130004f76f3539035c65336a26638859d002cf3af23c94f14fbd555ad0e15b05ea281270e9315f88c94997e39562167dabc01; TS819ec585027=08374f23c1ab2000ba03fd31df40d10d7a6f715ac033d88057def23aacb5c970390f8f828c227f1d089f690ccb1130002fe524ed0e247bfe36a26638859d002c52ba6348abcf86e59076636d345244c45811e51c93ba47f6b69c0c9e45a4b743; TS615aa6d2027=08374f23c1ab2000cc4f38b06211857fb284d6fc780261e24de377c9ab77d405a143453d905526c30899f68a36113000b4742d1d7bb7f07536a26638859d002cf684546a43af8a1e9e7f7f32614c53d71f7ed2eafdc7c96891635b64fa7da989; RT="z=1&dm=digikey.com&si=16984fbe-749d-453e-aa3e-eff93e8451a3&ss=kqva23v4&sl=0&tt=0"; 180144030725077320x5J2C0GE260M7E9R5783LQZBFHBICQVLSXB0Y7Z6U7UN3HIW7F5Y829MS3HODAMN4; tagxi=undefined.13790388; ping-accept-language=en-US; TS01666732=01460246b6569034a4c420ffe76c7af58e15c5e2a67aeaa90485c31356fc1d7b9fbba4219f5820643938d75f2668fad6fbc0924231; dkuhint=false; ps-eudo-sid=%7b%22CustomerId%22%3a0%2c%22LoginId%22%3a0%2c%22CustomerClass%22%3a0%2c%22Currency%22%3a%22USD%22%2c%22OrderModel%22%3a-1%2c%22UserIdentity%22%3a0%7d; _gid=GA1.2.1524145986.1626070968; search=%7B%22usage%22%3A%7B%22dailyCount%22%3A9%2C%22lastRequest%22%3A%222021-07-12T06%3A22%3A58.414Z%22%7D%2C%22version%22%3A1%7D; TS017613a9=01460246b66029a603b445bc0f6bbf69302b9631c57e92c63599706bb6cbf93589461d6a954aac4f81499f5077ac7f9e9fa45b1534; _evga_8774=906161b5badf1acd.; TS01173021=01f9ef228dc79814671f196d8cac51395728a180a1f3bbb91002ac64de34d333aaedee62633767fae1c872406b5f59e4f0c43c9bb4; bm_sz=0DC242F19B46A85FD7DD7B5EBF03412B~YAAQp38lF6DUqRl6AQAAmjIynAxd6nDTyBSG16x/yaMy1vHL6cfA8e0mEWioI+gXeZ2o5PYdXE1jlyHWZ0RSlB+sxqhpr8GwmyGYu9154cMvCCAzx/HRthSByVYGVHMh6rST5uQOIjInCweX37dzkAo+dDqER99SJ89d2ljdxMv4qxzvGjXofRrI3G3vSoF2cw==; _abck=5A830EFB08B4EEA2D0EA3DC798F20BBC~0~YAAQp38lF5mNqhl6AQAAyd6KnAaj8NDT6+g1HXUZTkg+HDOFn6WM1hKObOb9Gl7OtPMU+wZJ1RHyDE7kNc+ayUajYUuacP/KKeQXcY6aIQVWommEbybsdQ20OwSWHX3ubsT9ZM/pVOR4A2QmGvYz1m+SXYo+9ceog+dkKO8d61Ebg65lDQD7v7/rvP5/DiTUKLL+XLnLkwis5VBjBR8vChqOpsd4XmCj2BqvaVT4aKHL3GRvpDWjT84EpP4eWVrjjyGrK/DTFwMnRXjV+9bkbSq2XOgSiU13XFPBD7YgBprN6Bz6D5CZM3E4hw/2Ii9sc1TU+6XODA8fOClHw/odMq0V45v4IsBTf+WbkcZhB+Wo5crvnVk2pa51nhjJglHe/NDK0U6CDLwRdz0WpqB1wAAkvKhhlA4fgQ==~-1~-1~-1; _cs_mk=0.5607185173564322_1626128259923; ak_bmsc=AB3163228FBC6CB1B881C23B132C4883~000000000000000000000000000000~YAAQp38lFzMQqxl6AQAANh3MnAy80CWiNykeH0lKuzzJk3IZSCmQgzMjohrFVM4iTfQbyB60az7B5casZrnauGPk8FdpoPMaveRGNX25PY+neSoUv7RB2Y/bY+buwb0C55DHGRRXn1fqsszEqyQ0+MHTkLPUT24psbBFYezM8NDxQZ3JteQE3oVNQb52+sTFImWlNszkOSj6Undc6hUyOuhbnTZ+mNQ2SiJG3Tg2J2Xh81NC8UyssqtJMvSWVHNe1mu7CWFf7Np/PcIAbcfia2AeyPgyqpM3G9nI0PwEdc8yfThjCsiP0OCm14pZaMWdsUp6hUK4OxsqX1Ir+TtKl6EZgT4Jz5vd0+UXX5B1oAWAMFrj1XhE6E/8BtZNM4FfK92uCpIn8eq7HSAmL/ry3c7i2bxP/xGr6TdDyDNbNWul105P4ngasA+xoHxPp5IzTrkLhnrAuW6WItZ8uo0edalaYYwZcEkc3X0XLxbrEaKppFIxVaMPtVXoj5WF; sid=168885029929945860xJXMLM3OR9EOD46HAAUTOLTCFVXT5L1E8W8JXQT5T7N2AUJYJU446FGFKD6GJ5MQS; LPSID-63090575=YeLIZRnjQruct2u0CqcpFg; _gat_Production=1; website#lang=en-US; TS01d239f3=01460246b6c17820fba27628774894cc5e2015fd1809d05d20ffb93b5cc408366bf4ff6f530c6f0e57394845ec5e4e9febdb3adec5; TS016ae541=01460246b6c17820fba27628774894cc5e2015fd1809d05d20ffb93b5cc408366bf4ff6f530c6f0e57394845ec5e4e9febdb3adec5; TS01d5128f=01460246b6d93b84f1430dcbecf09ae03c6b0d0c8b5ded8715eb65c117fa657d0906c3bc460784f9e4554199dd3938722d9dbb44bb; TS013c3a0b=01460246b6c436651324c663f383a89cc2f365a22eb53c21a96bdae157b4c9f520e7e3a13584111b391ea782450fcc51fe1cd99e48; TS0184e6b9=01460246b6c436651324c663f383a89cc2f365a22eb53c21a96bdae157b4c9f520e7e3a13584111b391ea782450fcc51fe1cd99e48; TSc4804ab4027=08374f23c1ab2000fc150248983c0ca24f6ba9f47c8c18c9412cf9d12f2117a63ca00ff2d9a7f07708f62b774111300026784bc0c5f9fed99e481a1dc0c191259a812982c2ede18f843ed0806b9db2d20e2376d90fcb436ad05b907bab3e38ec; utag_main=v_id:0179e7c6870b001f5257fb1e07b103078001807001328$_sn:18$_se:12$_ss:0$_st:1626131726303$ses_id:1626128259821%3Bexp-session$_pn:10%3Bexp-session; bm_sv=E633CE70C6FA756B5FC1FAC456D9182B~OvHs14+06s2H/i9AtVWGQ+VhauNOePOgXUjAaq3gSDutJfGOlarkYvCho7v33PPwlR1q1xe4ZhIwV0YQpMq4uWc5J7XxKCyKhp0yFUO1JV2RA8EfPKfVU3WeTql1166GHWHU92+iAd3+UDjpXgb2WQ6yn0TsSPG7ASz2mTBAIwM=; _uetsid=93fa60f0e2d911ebba69bba13dfdb004; _uetvid=d02c2c70c7bf11ebaf846542dc464689; RT="z=1&dm=www.digikey.com&si=16984fbe-749d-453e-aa3e-eff93e8451a3&ss=kr17rqut&sl=0&tt=0&ul=y1c&bcn=%2F%2F173e2509.akstat.io%2F"',
    };
    const list = {};
    // fetch serially for more control
    for (const name in digikeyManufacturerUrls) {
        // @ts-ignore: to be run as JS
        const url = digikeyManufacturerUrls[name];
        try {
            const res = await fetch("https://www.digikey.com" + url, {
                // Copied from the Chrome dev tools network panel
                headers,
            });
            if (res.ok) {
                const text = await res.text();
                // @ts-ignore: to be run as JS
                list[name] = extractManufacturers(text);
            }
            else {
                // eslint-disable-next-line no-console
                console.error(name, res.statusText);
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(name, error);
        }
    }
    return list;
}
// @ts-ignore: to be run as JS
function extractManufacturers(html) {
    const matches = Array.from(html.matchAll(/<meta name="digikey.fss.SupplierId" content="([^"]+)"/gi));
    // @ts-ignore: to be run as JS
    return matches.flatMap((match) => parseInt(match[1]));
}
// For getting IDs from web pages
const digikeyManufacturerUrls = {
    "​Optiks Mechatronics Pvt. Ltd.": "/en/supplier-centers/optiks-mechatronics",
    "3G Shielding Specialties": "/en/supplier-centers/3g-shielding-specialties",
    "3M": "/en/supplier-centers/3m",
    "4D Systems": "/en/supplier-centers/4d-systems",
    "5G Hub": "/en/supplier-centers/5g-hub",
    "A&D Engineering": "/en/supplier-centers/a-and-d-engineering",
    Aavid: "/en/supplier-centers/aavid-thermalloy",
    "ABB Embedded Power": "/en/supplier-centers/ge-critical-power",
    "ABLIC U.S.A. Inc.": "/en/supplier-centers/sii-semiconductor",
    Abracon: "/en/supplier-centers/abracon",
    "AC Electronics": "/en/supplier-centers/ac-electronics",
    "Accelerated / Digi International": "/en/supplier-centers/digi-international",
    "Acconeer AB": "/en/supplier-centers/acconeer-ab",
    "Aceinna Electric Inc.": "/en/supplier-centers/aceinna-inc",
    "Aceinna Inc.": "/en/supplier-centers/aceinna-inc",
    "ACKme (Zentri)": "/en/supplier-centers/zentri",
    "ACL Staticide, Inc.": "/en/supplier-centers/acl-staticide",
    "ACT (Advanced Cable Ties)": "/en/supplier-centers/advanced-cable-ties",
    "Actuonix Motion Devices, Inc.": "/en/supplier-centers/actuonix-motion-devices-inc",
    "Acura Embedded Systems": "/en/supplier-centers/acura-embedded-systems",
    Acuva: "/en/supplier-centers/acuva",
    Adafruit: "/en/supplier-centers/adafruit",
    "Adam Equipment": "/en/supplier-centers/adam-equipment",
    "Adam Tech": "/en/supplier-centers/adam-tech",
    Adapteva: "/en/supplier-centers/adapteva",
    "Adels-Contact": "/en/supplier-centers/adels-contact",
    "Adesto Technologies": "/en/supplier-centers/adesto-technologies",
    "ADI (Analog Devices, Inc.)": "/en/supplier-centers/analog-devices",
    ADSANTEC: "/en/supplier-centers/adsantec",
    "Advanced Cable Ties": "/en/supplier-centers/advanced-cable-ties",
    "Advanced Energy": "/en/supplier-centers/excelsys-technologies",
    "Advanced Linear Devices, Inc.": "/en/supplier-centers/advanced-linear-devices",
    "Advanced Micro Lites": "/en/supplier-centers/advanced-micro-lites",
    "Advanced Photonix": "/en/supplier-centers/advanced-photonix",
    "Advanced Sensors / Amphenol": "/en/supplier-centers/amphenol-advanced-sensors",
    "Advanced Thermal Solutions, Inc.": "/en/supplier-centers/advanced-thermal-solutions",
    Advantech: "/en/supplier-centers/advantech",
    "Aearo Technologies, LLC – a 3M company": "/en/supplier-centers/aearo-technologies",
    AEM: "/en/supplier-centers/aem",
    "Aeon Matrix": "/en/supplier-centers/aeon-matrix",
    "Aeonsemi Inc.": "/en/supplier-centers/aeonsemi-inc",
    Aeris: "/en/supplier-centers/aeris",
    "Aeroflex (MACOM Technology Solutions)": "/en/supplier-centers/macom",
    "Aerospace Defense and Marine / TE Connectivity": "/en/supplier-centers/te-connectivity-aerospace",
    "Affinity Medical Technologies - Molex": "/en/supplier-centers/molex",
    "AFSI (Amphenol Fiber Systems International)": "/en/supplier-centers/amphenol-fiber-systems-international",
    "Agastat Relays / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "Agile Focus Designs": "/en/supplier-centers/agile-focus-designs",
    "Aim Dynamics": "/en/supplier-centers/aim-dynamics",
    "AIM-Cambridge / Cinch Connectivity Solutions": "/en/supplier-centers/cinch-connectivity-solutions",
    "AIMS Power": "/en/supplier-centers/aims-power",
    Aimtec: "/en/supplier-centers/aimtec",
    AIMtti: "/en/supplier-centers/aimtti",
    "Air LB (Amphenol Pcd)": "/en/supplier-centers/amphenol-pcd",
    "Air Science USA LLC": "/en/supplier-centers/air-science-usa-llc",
    Airgain: "/en/supplier-centers/airgain",
    "Airpax / Sensata Technologies": "/en/supplier-centers/sensata-technologies-airpax",
    "AIRTEC Pneumatics": "/en/supplier-centers/airtec-pneumatics",
    "Aker Technology USA": "/en/supplier-centers/aker-technology-usa",
    "AKM Semiconductor, Inc.": "/en/supplier-centers/akm-semiconductor",
    "AK-NORD GmbH": "/en/supplier-centers/ak-nord",
    Alango: "/en/supplier-centers/alango",
    "ALCOSWITCH Switches / TE Connectivity": "/en/supplier-centers/te-connectivity-alcoswitch",
    "ALFA Network Inc.": "/en/supplier-centers/alfa-network-inc",
    "AlfaMag Electronics (AMGIS)": "/en/supplier-centers/amgis",
    "Alfra Tools": "/en/supplier-centers/alfra-tools",
    "Alive Telecom": "/en/supplier-centers/alive-telecom",
    "All Flex, Inc.": "/en/supplier-centers/all-flex",
    "All Sensors Corporation": "/en/supplier-centers/all-sensors-corporation",
    "Allegro MicroSystems": "/en/supplier-centers/allegro-microsystems",
    Alliance: "/en/supplier-centers/alliance",
    "Alliance (Essentra Components)": "/en/supplier-centers/essentra-components",
    "Alliance Memory, Inc.": "/en/supplier-centers/alliance-memory",
    "Alliance Sensors Group a div of HG Schaevitz LLC": "/en/supplier-centers/alliance-sensors",
    "Allied Components International": "/en/supplier-centers/allied-components-international",
    "Allied Vision": "/en/supplier-centers/allied-vision",
    "Allison Park Group": "/en/supplier-centers/allison-park-group",
    Allystar: "/en/supplier-centers/allystar",
    "Almit (ANA TRADING)": "/en/supplier-centers/almit-ana-trading",
    "Alorium Technology": "/en/supplier-centers/alorium-technology",
    "Alpenglow Industries": "/en/supplier-centers/alpenglow-industries",
    "Alpha and Omega Semiconductor, Inc.": "/en/supplier-centers/alpha-and-omega-semiconductor",
    "Alpha Lighting": "/en/supplier-centers/alpha-lighting",
    "Alpha Wire": "/en/supplier-centers/alpha-wire",
    "Altech Corporation": "/en/supplier-centers/altech",
    "Altera (Intel) ": "/en/supplier-centers/altera",
    "Altran Magnetics, Inc.": "/en/supplier-centers/altran-magnetics",
    "Altum RF": "/en/supplier-centers/altum-rf",
    "AM Equipment": "/en/supplier-centers/am-equipment",
    "AMBER Wireless GmbH (Würth Elektronik)": "/en/supplier-centers/wurth-electronics",
    "Ambiq Micro, Inc.": "/en/supplier-centers/ambiq-micro",
    "American Beauty Tools": "/en/supplier-centers/american-beauty-tools",
    "American Bright": "/en/supplier-centers/american-bright",
    "American Electrical, Inc. ": "/en/supplier-centers/american-electrical",
    "American Hakko Products, Inc.": "/en/supplier-centers/american-hakko-products",
    "American Microsemiconductor, Inc.": "/en/supplier-centers/american-microsemiconductor-inc",
    "American Opto Plus LED Corp.": "/en/supplier-centers/american-opto-plus-led-corporation",
    "American Technical Ceramics": "/en/supplier-centers/american-technical-ceramics",
    "American Zettler": "/en/supplier-centers/american-zettler",
    Amerivacs: "/en/supplier-centers/amerivacs",
    "Amerway Inc.": "/en/supplier-centers/amerway-inc",
    Ametherm: "/en/supplier-centers/ametherm",
    Amgis: "/en/supplier-centers/amgis",
    "AMI (Altran Magnetics, Inc.)": "/en/supplier-centers/altran-magnetics",
    "AMI Semiconductor/ON Semiconductor": "/en/supplier-centers/on-semiconductor",
    "AMP Connectors/TE Connectivity": "/en/supplier-centers/te-connectivity-amp",
    "Ampco Safety Tools": "/en/supplier-centers/ampco-safety-tools",
    "Amp'ed RF Tech": "/en/supplier-centers/amped-rf-tech",
    Ampere: "/en/supplier-centers/ampere",
    Amphenol: "/en/supplier-centers/amphenol",
    "Amphenol Advanced Sensors": "/en/supplier-centers/amphenol-advanced-sensors",
    "Amphenol Aerospace Operations": "/en/supplier-centers/amphenol-aerospace-operations",
    "Amphenol Air LB": "/en/supplier-centers/amphenol-pcd",
    "Amphenol All Sensors": "/en/supplier-centers/all-sensors-corporation",
    "Amphenol Anytek": "/en/supplier-centers/amphenol-anytek",
    "Amphenol Aorora": "/en/supplier-centers/amphenol-icc",
    "Amphenol Audio": "/en/supplier-centers/amphenol-sine-systems",
    "Amphenol Cables on Demand": "/en/supplier-centers/amphenol-cables-on-demand",
    "Amphenol Commercial IO": "/en/supplier-centers/amphenol-icc",
    "Amphenol Connex (Amphenol RF)": "/en/supplier-centers/amphenol-rf",
    "Amphenol Custom Cable": "/en/supplier-centers/amphenol-custom-cable",
    "Amphenol Entertainment": "/en/supplier-centers/amphenol-sine-systems",
    "Amphenol FCi Basics": "/en/supplier-centers/amphenol-icc",
    "Amphenol Fiber Systems International": "/en/supplier-centers/amphenol-fiber-systems-international",
    "Amphenol High Speed Backplane Products": "/en/supplier-centers/amphenol-icc",
    "Amphenol High Speed IO": "/en/supplier-centers/amphenol-icc",
    "Amphenol Industrial": "/en/supplier-centers/amphenol-industrial",
    "Amphenol Information Communication & Commercial": "/en/supplier-centers/amphenol-icc",
    "Amphenol InterCon Systems": "/en/supplier-centers/amphenol-icc",
    "Amphenol Limited": "/en/supplier-centers/amphenol-pcd",
    "Amphenol LTD": "/en/supplier-centers/amphenol-pcd",
    "Amphenol LTW": "/en/supplier-centers/amphenol-ltw",
    "Amphenol Mezzanine Products": "/en/supplier-centers/amphenol-icc",
    "Amphenol NEXUS Technologies": "/en/supplier-centers/amphenol-nexus-technologies",
    "Amphenol NovaSensor": "/en/supplier-centers/amphenol-advanced-sensors",
    "Amphenol Pcd": "/en/supplier-centers/amphenol-pcd",
    "Amphenol Piher Sensing Systems": "/en/supplier-centers/piher-sensing-systems",
    "Amphenol Power Solutions": "/en/supplier-centers/amphenol-icc",
    "Amphenol Procom": "/en/supplier-centers/amphenol-procom",
    "Amphenol RF": "/en/supplier-centers/amphenol-rf",
    "Amphenol SGX Sensortech": "/en/supplier-centers/sgx-sensortech",
    "Amphenol Sine Systems": "/en/supplier-centers/amphenol-sine-systems",
    "Amphenol Socapex": "/en/supplier-centers/amphenol-pcd",
    "Amphenol SSI Technologies": "/en/supplier-centers/ssi-technologies",
    "Amphenol Storage & Server IO": "/en/supplier-centers/amphenol-icc",
    "Amphenol SV Microwave": "/en/supplier-centers/amphenol-sv-microwave",
    "Amphenol Telaire": "/en/supplier-centers/amphenol-advanced-sensors",
    "Amphenol Thermometrics": "/en/supplier-centers/amphenol-advanced-sensors",
    "Amphenol Times Microwave Systems": "/en/supplier-centers/times-microwave-systems",
    "Amphenol Tuchel Electronics": "/en/supplier-centers/amphenol-sine-systems",
    "Amphenol Wilcoxon Sensing Technologies": "/en/supplier-centers/amphenol-wilcoxon",
    Ampleon: "/en/supplier-centers/ampleon",
    Amprobe: "/en/supplier-centers/amprobe",
    ams: "/en/supplier-centers/ams",
    "Amtery Corporation": "/en/supplier-centers/amtery-corporation",
    "Amulet Technologies, LLC.": "/en/supplier-centers/amulet-technologies",
    "Analog Devices, Inc.": "/en/supplier-centers/analog-devices",
    "Anamet Electrical Inc": "/en/supplier-centers/anamet-electrical",
    Anaren: "/en/supplier-centers/anaren",
    "Anatech Electronics Inc.": "/en/supplier-centers/anatech-electronics-inc",
    AnDAPT: "/en/supplier-centers/andapt",
    "Anderson Power Products": "/en/supplier-centers/anderson-power-products",
    AndyMark: "/en/supplier-centers/andymark",
    "Anfield Industries": "/en/supplier-centers/anfield-industries",
    "Angstrohm / Vishay": "/en/supplier-centers/vishay-bccomponents",
    "Antenna Technologies Limited Company": "/en/supplier-centers/antenna-technologies-limited-company",
    Antenova: "/en/supplier-centers/antenova",
    "Antimatter Research": "/en/supplier-centers/antimatter-research",
    ANYSOLAR: "/en/supplier-centers/anysolar",
    "Anytek (Amphenol Anytek)": "/en/supplier-centers/amphenol-anytek",
    "Aorora (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    Apacer: "/en/supplier-centers/apacer",
    "APEM Inc.": "/en/supplier-centers/apem",
    "Apex Microtechnology": "/en/supplier-centers/apex-microtechnology",
    "Apex Tool Group": "/en/supplier-centers/apex-tool-group",
    "API Delevan": "/en/supplier-centers/api-delevan",
    "API Technologies Corp.": "/en/supplier-centers/api-technologies",
    "APM Hexseal": "/en/supplier-centers/apm-hexseal",
    "Applied Photon Technology": "/en/supplier-centers/applied-photon",
    APS: "/en/supplier-centers/aps-applied-power-systems",
    "Aptina/ON Semiconductor": "/en/supplier-centers/on-semiconductor",
    "APW Company": "/en/supplier-centers/apw-company",
    "Aras Power Technologies": "/en/supplier-centers/aras-power-technologies",
    "Arbiter Systems Inc.": "/en/supplier-centers/arbiter-systems",
    "Arc Suppression Technologies": "/en/supplier-centers/arc-suppression-technologies",
    ARCH: "/en/supplier-centers/arch",
    "ARCOL (Ohmite)": "/en/supplier-centers/arcol-ohmite",
    "Arcolectric (Bulgin)": "/en/supplier-centers/bulgin",
    Arcotek: "/en/supplier-centers/arcotek",
    "Arcotronics (KEMET)": "/en/supplier-centers/arcotronics",
    "Arcus Technology": "/en/supplier-centers/arcus-technology",
    Arduino: "/en/supplier-centers/arduino",
    Arieltech: "/en/supplier-centers/ariel-tech",
    "Aries Electronics, Inc.": "/en/supplier-centers/aries-electronics",
    "ARIES Embedded": "/en/supplier-centers/aries-embedded",
    "ArkX Laboratories": "/en/supplier-centers/arkx",
    ARM: "/en/supplier-centers/arm",
    "Arrgh!!": "/en/supplier-centers/arrgh-manufacturing",
    "Arshon Technology Inc.": "/en/supplier-centers/arshon-technology",
    "Artaflex Inc.": "/en/supplier-centers/artaflex",
    "Artesyn Embedded Power": "/en/supplier-centers/artesyn-embedded-technologies",
    "ARTIK (Samsung ARTIK)": "/en/supplier-centers/samsung-artik",
    "Asahi Kasei Microdevices / AKM Semiconductor": "/en/supplier-centers/akm-semiconductor",
    "ASAHI RUBBER INC.": "/en/supplier-centers/asahi-rubber",
    "ASC Capacitors": "/en/supplier-centers/asc-capacitors-american-shizuki-corporation",
    Asentek: "/en/supplier-centers/asentek",
    "ASI-Ez": "/en/supplier-centers/asi-ez-automation-systems-interconnect",
    "ASSMANN WSW Components": "/en/supplier-centers/assmann-wsw-components",
    "Astec America (Artesyn Embedded Technologies)": "/en/supplier-centers/artesyn-embedded-technologies",
    "Astera Labs": "/en/supplier-centers/astera-labs",
    "Astro Tool Corp.": "/en/supplier-centers/astro-tool",
    "Astrodyne TDI": "/en/supplier-centers/astrodyne-tdi",
    Asus: "/en/supplier-centers/asus",
    ATC: "/en/supplier-centers/atc-automatic-timing-and-controls",
    ATGBICS: "/en/supplier-centers/atgbics-approved-technology",
    "Atmel (Microchip Technology)": "/en/supplier-centers/atmel",
    "Atop Technologies": "/en/supplier-centers/atop-technologies",
    "ATP Electronics, Inc.": "/en/supplier-centers/atp-electronics",
    "Atrix International": "/en/supplier-centers/atrix-international",
    Attabox: "/en/supplier-centers/attabox",
    "ATX LED": "/en/supplier-centers/atx-led",
    Audiowell: "/en/supplier-centers/audiowell",
    "Ault / SL Power": "/en/supplier-centers/sl-power-electronics",
    "Autonics USA": "/en/supplier-centers/autonics",
    "Avago Technologies (Broadcom)": "/en/supplier-centers/broadcom",
    Aven: "/en/supplier-centers/aven",
    "Avery Dennison": "/en/supplier-centers/avery-dennison",
    AVMATRIX: "/en/supplier-centers/avmatrix",
    "AVR Global Technologies, Inc.": "/en/supplier-centers/avr-global-technologies",
    "AVX Corporation": "/en/supplier-centers/avx",
    "AWG TECH Pte. Ltd.": "/en/supplier-centers/awg-tech-pte-ltd",
    "Axicom Relays / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "AZ Displays": "/en/supplier-centers/azdisplays",
    Azoteq: "/en/supplier-centers/azoteq",
    "Aztronic / Vishay": "/en/supplier-centers/vishay-bccomponents",
    Azumo: "/en/supplier-centers/azumo",
    "B B Battery": "/en/supplier-centers/b-b-battery",
    "B&F Fastener Supply": "/en/supplier-centers/bf-fastener-supply",
    "B&J USA": "/en/supplier-centers/b-and-j-usa",
    "B&K Precision": "/en/supplier-centers/bk-precision",
    "B+B SmartWorx (Advantech)": "/en/supplier-centers/bb-smartworx",
    "B+B Thermo-Technik GmbH": "/en/supplier-centers/b-b-thermotechnik-gmbh",
    "B4 Limits": "/en/supplier-centers/b4-limits",
    Balluff: "/en/supplier-centers/balluff",
    "Band Solutions, LLC": "/en/supplier-centers/band-solutions",
    "Banner Engineering": "/en/supplier-centers/banner-engineering",
    "Bantam Tools": "/en/supplier-centers/bantam-tools",
    "BAPI/Building Automation Products Inc.": "/en/supplier-centers/bapi-building-automation-products",
    "Bardac Corporation": "/en/supplier-centers/bardac-corporation",
    Bartovation: "/en/supplier-centers/bartovation",
    Basler: "/en/supplier-centers/basler",
    "BATTERY WORLD": "/en/supplier-centers/battery-world",
    BatteryGuy: "/en/supplier-centers/batteryguy",
    "Bayshore Networks": "/en/supplier-centers/bayshore-networks",
    "BDE Technology": "/en/supplier-centers/bde-technology",
    "BDNC (Holding) Limited": "/en/supplier-centers/bdnc",
    "Beacon EmbeddedWorks": "/en/supplier-centers/logic-pd",
    "BeagleBoard.org": "/en/supplier-centers/beagleboardorg",
    "Beau Interconnect - Molex": "/en/supplier-centers/molex",
    "BECOM Systems GmbH": "/en/supplier-centers/bluetechnix",
    "BEI Sensors / Sensata Technologies": "/en/supplier-centers/bei-sensors",
    Bel: "/en/supplier-centers/bel",
    "Bel Fuse, Inc.": "/en/supplier-centers/bel-fuse",
    "Bel Power Solutions": "/en/supplier-centers/bel-power-solutions",
    Belden: "/en/supplier-centers/belden",
    "Belden Hirschmann": "/en/supplier-centers/hirschmann",
    "Bellnix Co., LTD.": "/en/supplier-centers/bellnix",
    BenchPro: "/en/supplier-centers/benchpro",
    "Bend Labs": "/en/supplier-centers/bend-labs",
    "Bergquist / Henkel": "/en/supplier-centers/bergquist",
    "Berkeley Nuclonics Corporation (Directed Energy Inc.)": "/en/supplier-centers/directed-energy",
    Bertech: "/en/supplier-centers/bertech",
    "BeStar Technologies, Inc.": "/en/supplier-centers/bestar-technologies-inc",
    "BI Technologies/TT Electronics": "/en/supplier-centers/tt-electronics-bi-technologies",
    "Bias Power": "/en/supplier-centers/cita",
    Binho: "/en/supplier-centers/binho",
    "Bird Technologies": "/en/supplier-centers/bird-technologies",
    "Birk Manufacturing": "/en/supplier-centers/birk-manufacturing",
    "Birtcher / nVent": "/en/supplier-centers/pentair",
    "Bittware - Molex": "/en/supplier-centers/molex",
    "Bivar, Inc.": "/en/supplier-centers/bivar",
    "BLA ETECH PVT LTD": "/en/supplier-centers/bla-etech",
    Bluatec: "/en/supplier-centers/bluatec",
    "Blue Clover Devices": "/en/supplier-centers/blue-clover-devices",
    "Blue Harmonics": "/en/supplier-centers/blue-harmonics",
    "Bluebird Labs": "/en/supplier-centers/bluebird-labs",
    BlueCreation: "/en/supplier-centers/bluecreation",
    "BNS Solutions": "/en/supplier-centers/bns-solutions",
    "Bomar (Winchester Electronics)": "/en/supplier-centers/winchester-electronics",
    "Bopla Enclosures": "/en/supplier-centers/phoenix-mecano",
    "Boréas Technologies": "/en/supplier-centers/boreas-technologies",
    "Bosch Connected Devices and Solutions": "/en/supplier-centers/bosch-cds",
    "Bosch Sensortec": "/en/supplier-centers/bosch-sensortec",
    "BotBlox/Kapek": "/en/supplier-centers/botblox",
    BotFactory: "/en/supplier-centers/botfactory",
    "Botron Company Inc.": "/en/supplier-centers/botron",
    "Boundary Devices": "/en/supplier-centers/boundary-devices",
    "Bourns, Inc.": "/en/supplier-centers/bourns",
    "Brad Harrison - Molex": "/en/supplier-centers/molex",
    "Brady Corporation": "/en/supplier-centers/brady",
    Brainboxes: "/en/supplier-centers/brainboxes",
    "Breadware, Inc.": "/en/supplier-centers/breadware",
    "Bridgelux, Inc.": "/en/supplier-centers/bridgelux",
    Bridgetek: "/en/supplier-centers/bridgetek",
    "Bright Toward Industrial": "/en/supplier-centers/bright-toward-industrial",
    "Bright Way Group": "/en/supplier-centers/bright-way-group",
    Broadcom: "/en/supplier-centers/broadcom",
    "Broadsens Corporation": "/en/supplier-centers/broadsens-corporation",
    "Buchanan Terminal Blocks / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "Bud Industries, Inc.": "/en/supplier-centers/bud-industries",
    Buildtak: "/en/supplier-centers/buildtak",
    Bulgin: "/en/supplier-centers/bulgin",
    "Bumper Specialties, Inc.": "/en/supplier-centers/bumper-specialties",
    "Burr-Brown (Texas Instruments)": "/en/supplier-centers/burr-brown",
    "BusBoard Prototype Systems": "/en/supplier-centers/busboard-prototype-systems",
    "Business Systems Connection Inc.": "/en/supplier-centers/business-systems-connection-inc",
    "Bussmann (Eaton)": "/en/supplier-centers/eaton-bussmann-electrical-division",
    "BWI Eagle": "/en/supplier-centers/bwi-eagle",
    "C&D Technologies (Murata Power Solutions)": "/en/supplier-centers/cd-technologies",
    "C&K": "/en/supplier-centers/ck-components",
    c3controls: "/en/supplier-centers/c3controls",
    "Cables on Demand (Amphenol Cables on Demand)": "/en/supplier-centers/amphenol-cables-on-demand",
    "Caddock Electronics, Inc.": "/en/supplier-centers/caddock-electronics",
    "CAIG Laboratories, Inc.": "/en/supplier-centers/caig",
    "Cal Test Electronics": "/en/supplier-centers/cal-test-electronics",
    "CAL-CHIP ELECTRONICS INC.": "/en/supplier-centers/cal-chip-electronics-inc",
    "Califia Lighting (Bivar)": "/en/supplier-centers/bivar",
    "Calmark / nVent": "/en/supplier-centers/pentair",
    "Caly Technologies": "/en/supplier-centers/caly-technologies",
    Cannon: "/en/supplier-centers/itt-interconnect-solutions",
    Canon: "/en/supplier-centers/canon",
    Cantherm: "/en/supplier-centers/cantherm",
    CapeSym: "/en/supplier-centers/capesym",
    "Capital Advanced Technologies, Inc.": "/en/supplier-centers/capital-advanced-technologies",
    "Carclo Technical Plastics": "/en/supplier-centers/carclo-technical-plastics",
    "Cardinal Components": "/en/supplier-centers/cardinal-components",
    "Carling Technologies": "/en/supplier-centers/carling-technologies",
    "Carlisle Interconnect Technologies": "/en/supplier-centers/carlisle-interconnect-technologies",
    "Carlo Gavazzi": "/en/supplier-centers/carlo-gavazzi",
    "Carnegie Manufacturing": "/en/supplier-centers/carnegie-manufacturing",
    Cartesiam: "/en/supplier-centers/cartesiam",
    "Catalyst Semiconductor/ON Semiconductor": "/en/supplier-centers/on-semiconductor",
    "CCI (Conductive Containers, Inc.)": "/en/supplier-centers/conductive-containers",
    "CEL (California Eastern Laboratories)": "/en/supplier-centers/cel",
    "CENTER TECHNOLOGY": "/en/supplier-centers/center-technology",
    "Central Semiconductor": "/en/supplier-centers/central-semiconductor",
    "Century Spring Corp.": "/en/supplier-centers/century-spring-corp",
    "Cera-Mite / Vishay": "/en/supplier-centers/vishay-bccomponents",
    CEVA: "/en/supplier-centers/hillcrest-labs",
    "CEVA Hillcrest Labs": "/en/supplier-centers/hillcrest-labs",
    "CGS Resistors / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "CH Products": "/en/supplier-centers/ch-products",
    "Challenge Electronics": "/en/supplier-centers/challenge-electronics",
    "CHASM Advanced Materials": "/en/supplier-centers/chasm-advanced-materials",
    "Chemi-Con": "/en/supplier-centers/united-chemi-con",
    "Chempure Brand Chemicals": "/en/supplier-centers/chempure-brand-chemicals",
    Chemtronics: "/en/supplier-centers/chemtronics",
    "Cherry Americas": "/en/supplier-centers/cherry-americas",
    Cheval: "/en/supplier-centers/cheval",
    "Chicago Electronic Distributors": "/en/supplier-centers/chicago-electronic-distributors",
    "Chilisin Electronics": "/en/supplier-centers/chilisin-electronics",
    "ChinCheng Casters Co., Ltd.": "/en/supplier-centers/chincheng-casters",
    "Chip Quik, Inc.": "/en/supplier-centers/chip-quik",
    "Chip Shine / CSRF": "/en/supplier-centers/chip-shine-csrf",
    "Chiral Photonics": "/en/supplier-centers/chiral-photonics",
    "Chogori Technologies": "/en/supplier-centers/chogori",
    ChromeLED: "/en/supplier-centers/chromeled",
    Cicoil: "/en/supplier-centers/cicoil",
    "CII / TE Connectivity": "/en/supplier-centers/te-connectivity",
    CIMON: "/en/supplier-centers/cimon",
    "Cinch Connectivity Solutions": "/en/supplier-centers/cinch-connectivity-solutions",
    Cincon: "/en/supplier-centers/cincon",
    "Circuit Design": "/en/supplier-centers/circuit-design",
    "Circuit Dojo": "/en/supplier-centers/circuit-dojo",
    "Circuit Scribe/Electroninks Writeables Inc.": "/en/supplier-centers/circuit-scribe-electroninks-writeables-inc",
    "Cirronet / RFM (Murata Power Solutions)": "/en/supplier-centers/cirronet-rfm",
    "Cirrus Logic": "/en/supplier-centers/cirrus-logic",
    CISSOID: "/en/supplier-centers/cissoid",
    "CIT (Carlisle Interconnect Technologies)": "/en/supplier-centers/carlisle-interconnect-technologies",
    "CIT Relay and Switch": "/en/supplier-centers/cit-relay-switch",
    "Cita Technologies": "/en/supplier-centers/cita",
    "CITEL INC": "/en/supplier-centers/citel-inc",
    "Citizen Electronics Co., Ltd.": "/en/supplier-centers/citizen",
    "Citizen Finedevice Co., LTD.": "/en/supplier-centers/citizen-finedevice",
    "City Technology": "/en/supplier-centers/city-technology",
    "Clarion Safety Systems": "/en/supplier-centers/clarion-safety-systems",
    "Clarostat (Honeywell Sensing and Productivity Solutions)": "/en/supplier-centers/clarostat",
    Cliff: "/en/supplier-centers/cliff",
    "CMD (ON Semiconductor)": "/en/supplier-centers/cmd",
    "CML Innovative Technologies": "/en/supplier-centers/cml-innovative-technologies",
    "CML Microcircuits": "/en/supplier-centers/cml-microcircuits",
    "CnC Tech": "/en/supplier-centers/cnc-tech",
    Coex: "/en/supplier-centers/coex",
    COILCRAFT: "/en/supplier-centers/coilcraft",
    "Coiltronics (Eaton)": "/en/supplier-centers/eaton-electronics-division",
    "Comair Rotron": "/en/supplier-centers/comair-rotron",
    "Comchip Technology": "/en/supplier-centers/comchip-technology",
    "Comet America": "/en/supplier-centers/comet-america",
    "Commercial IO (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    "Compass Instruments": "/en/supplier-centers/compass-instruments",
    ComScire: "/en/supplier-centers/comscire",
    "Comus International": "/en/supplier-centers/comus-international",
    "Concept Technologie (Power Integrations)": "/en/supplier-centers/concept-technologie",
    "Concord Electronics": "/en/supplier-centers/concord-electronics",
    "Condor / SL Power": "/en/supplier-centers/sl-power-electronics",
    "Conductive Containers, Inc.": "/en/supplier-centers/conductive-containers",
    ConductRF: "/en/supplier-centers/conductrf",
    CONEC: "/en/supplier-centers/conec",
    congatec: "/en/supplier-centers/congatec",
    "Connective Peripherals": "/en/supplier-centers/connective-peripherals",
    "Connex (Amphenol RF)": "/en/supplier-centers/amphenol-rf",
    "Connor Winfield": "/en/supplier-centers/connor-winfield",
    "Construction Resource Management, LLC": "/en/supplier-centers/construction-resource-mgmt",
    "Conta-Clip": "/en/supplier-centers/conta-clip",
    "Contrinex - Molex": "/en/supplier-centers/molex",
    "Control By Web": "/en/supplier-centers/control-by-web",
    ControlAir: "/en/supplier-centers/controlair",
    "Conxall / Switchcraft": "/en/supplier-centers/switchcraft-conxall",
    Coolgear: "/en/supplier-centers/coolgear",
    "Cooper Bussmann (Eaton)": "/en/supplier-centers/eaton-bussmann-electrical-division",
    "Copal Electronics (Nidec Copal Electronics)": "/en/supplier-centers/copal-electronics",
    "Corcom Filters / TE Connectivity": "/en/supplier-centers/te-connectivity-corcom-filters",
    "Cordova Flow Controls": "/en/supplier-centers/cordova-flow-controls",
    "CoreLED Systems LLC": "/en/supplier-centers/coreled-systems",
    "Cornell Dubilier Electronics": "/en/supplier-centers/cornell-dubilier-electronics",
    "Correct Products": "/en/supplier-centers/correct-products",
    Cosel: "/en/supplier-centers/cosel",
    "Coto Technology": "/en/supplier-centers/coto-technology",
    "CPR Global Tech": "/en/supplier-centers/cpr-global-tech",
    "CR Magnetics, Inc.": "/en/supplier-centers/cr-magnetics",
    "Cree LED": "/en/supplier-centers/cree",
    "Cree Wolfspeed": "/en/supplier-centers/wolfspeed",
    Crescent: "/en/supplier-centers/apex-tool-group",
    "Crest Electronics": "/en/supplier-centers/crest-electronics",
    "Criteria Labs": "/en/supplier-centers/criteria-labs",
    "Critical Link": "/en/supplier-centers/critical-link",
    Crouzet: "/en/supplier-centers/crouzet-controls",
    "Crown Matting Technologies": "/en/supplier-centers/crown-matting-technologies",
    "Crydom / Sensata Technologies": "/en/supplier-centers/crydom",
    "Crystal IS": "/en/supplier-centers/crystal-is",
    Crystalfontz: "/en/supplier-centers/crystalfontz",
    "Crystek Corporation": "/en/supplier-centers/crystek",
    Crytur: "/en/supplier-centers/crytur-usa",
    "CS Hyde Company": "/en/supplier-centers/cs-hyde-company",
    "CS Instruments": "/en/supplier-centers/cs-instruments",
    "CTI Electronics": "/en/supplier-centers/cti-electronics",
    "CTi Sensors": "/en/supplier-centers/cti-sensors",
    "C-Ton Industries": "/en/supplier-centers/c-ton-industries",
    "CTR Electronics": "/en/supplier-centers/ctr-electronics",
    "CTS Corporation": "/en/supplier-centers/cts-electronic-components",
    "CUI Devices": "/en/supplier-centers/cui-devices",
    "CUI Inc.": "/en/supplier-centers/cui",
    "Curtis Industries": "/en/supplier-centers/curtis-industries",
    "Curtis Instruments": "/en/supplier-centers/curtis-instruments",
    "Custom Computer Services": "/en/supplier-centers/custom-computer-services",
    CviLux: "/en/supplier-centers/cvilux",
    "CW Industries": "/en/supplier-centers/cw-industries",
    Cymbet: "/en/supplier-centers/cymbet",
    "Cynergy3 / Sensata Technologies": "/en/supplier-centers/cynergy3",
    "Cyntec / Delta Electronics": "/en/supplier-centers/cyntec",
    "Cypress Semiconductor": "/en/supplier-centers/cypress-semiconductor",
    "D6 Labs": "/en/supplier-centers/d6-labs",
    "DAB-Embedded": "/en/supplier-centers/dab-embedded",
    Daburn: "/en/supplier-centers/daburn",
    "Dale / Vishay": "/en/supplier-centers/vishay-dale",
    Danisense: "/en/supplier-centers/danisense",
    "Dantona Industries, Inc.": "/en/supplier-centers/dantona-industries",
    "Dart Controls": "/en/supplier-centers/dart-controls",
    "Darwin Tech": "/en/supplier-centers/darwin-tech",
    "Data Modul Inc.": "/en/supplier-centers/data-modul-inc",
    "DataComm Electronics, Inc.": "/en/supplier-centers/datacomm-electronics-inc",
    Dataforth: "/en/supplier-centers/dataforth",
    "Datawave Wireless": "/en/supplier-centers/datawave",
    "DAVE Embedded Systems": "/en/supplier-centers/dave-embedded-systems",
    "Davies Molding, LLC.": "/en/supplier-centers/davies-molding",
    "DB Unlimited": "/en/supplier-centers/db-unlimited",
    DComponents: "/en/supplier-centers/dcomponents",
    "ddm hopt+schuler": "/en/supplier-centers/ddm-hopt-schuler",
    Deca: "/en/supplier-centers/deca",
    "DEI (Berkeley Nuclonics Corporation)": "/en/supplier-centers/directed-energy",
    "Delkin Devices": "/en/supplier-centers/delkin-devices",
    "Delta Electronics": "/en/supplier-centers/delta-product-groups",
    "Delta Electronics / Cyntec": "/en/supplier-centers/cyntec",
    "Delta Electronics / EMI": "/en/supplier-centers/delta-product-groups-emi",
    "Delta Electronics / Fans": "/en/supplier-centers/delta-product-groups-fans",
    "Delta Electronics / Industrial Automation": "/en/supplier-centers/delta-electronics-industrial-automation",
    "Delta Electronics / Power": "/en/supplier-centers/delta-product-groups-power",
    "Deltatech / Sensata Technologies": "/en/supplier-centers/sensata-technologies-deltatech",
    "Denso Robotics": "/en/supplier-centers/denso-robotics",
    "Deschner Corporation": "/en/supplier-centers/deschner-corporation",
    Desco: "/en/supplier-centers/desco",
    "DET LLC/Diamond Edge Technology LLC": "/en/supplier-centers/det-llc-diamond-edge-technology-llc",
    "DEUTSCH Connectors / TE Connectivity": "/en/supplier-centers/te-connectivity-deutsch-connectors",
    "DEUTSCH ICT / TE Connectivity": "/en/supplier-centers/te-connectivity-deutsch-industrial-commercial-transportation",
    DFRobot: "/en/supplier-centers/dfrobot",
    "DGH Corporation": "/en/supplier-centers/dgh-corporation",
    Dialight: "/en/supplier-centers/dialight",
    "Dialog Semiconductor": "/en/supplier-centers/add_rule_dialog-semiconductor",
    "Diamond Systems": "/en/supplier-centers/diamond-systems",
    "Dielectric Laboratories": "/en/supplier-centers/knowles-dli",
    "Dielectric Laboratories (Knowles)": "/en/supplier-centers/dielectric-laboratories",
    Digi: "/en/supplier-centers/digi-international",
    "Digilent, Inc.": "/en/supplier-centers/digilent",
    "Digi-Pas Technologies": "/en/supplier-centers/digi-pas-technologies",
    "Digital Power Corporation": "/en/supplier-centers/digital-power-corporation",
    "Digital Six Laboratories, LLC": "/en/supplier-centers/d6-labs",
    "Digital View Inc.": "/en/supplier-centers/digital-view",
    "DINKLE Corporation USA": "/en/supplier-centers/dinkle-corporation-usa",
    "Diodes Incorporated": "/en/supplier-centers/diodes",
    "Diotec Semiconductor": "/en/supplier-centers/diotec-semiconductor",
    "Directed Energy Inc. (Berkeley Nuclonics Corporation)": "/en/supplier-centers/directed-energy",
    "Display Visions": "/en/supplier-centers/electronic-assembly",
    Displaytech: "/en/supplier-centers/displaytech",
    "DiTom Microwave Inc.": "/en/supplier-centers/ditom",
    "Divelbiss Corporation": "/en/supplier-centers/divelbiss-corporation",
    DLI: "/en/supplier-centers/knowles-dli",
    "DLP Design, Inc.": "/en/supplier-centers/dlp-design",
    "Doodle Labs": "/en/supplier-centers/doodle-labs",
    "Dormeyer (Division of Johnson Electric)": "/en/supplier-centers/ledex-dormeyer-saia",
    "Dou Yee Enterprises": "/en/supplier-centers/dou-yee-enterprises",
    "Draloric/Vishay": "/en/supplier-centers/vishay-beyschlag",
    Dremel: "/en/supplier-centers/dremel",
    "dresden elektronik": "/en/supplier-centers/dresden-elektronik",
    "Dreyer Electronics LLC": "/en/supplier-centers/dreyer-electronics-llc",
    "Dunwell Tech, Inc.": "/en/supplier-centers/dunwell-tech-inc",
    Duracell: "/en/supplier-centers/duracell",
    "Dynapar Corp": "/en/supplier-centers/dynapar-corp",
    "Dynastream Innovations Inc. (Garmin Canada Inc.)": "/en/supplier-centers/dynastream-innovations",
    Dynics: "/en/supplier-centers/dynics",
    "E Ink": "/en/supplier-centers/e-ink",
    "E S D Control Centre Ltd.": "/en/supplier-centers/esd-control-centre",
    EAO: "/en/supplier-centers/eao",
    "Earth People Technology": "/en/supplier-centers/earth-people-technology",
    EarthLCD: "/en/supplier-centers/earthlcd",
    "East Electronics": "/en/supplier-centers/east-electronics",
    "EasyBraid (Menda/EasyBraid/Tronex)": "/en/supplier-centers/easybraid",
    Eaton: "/en/supplier-centers/eaton",
    "Eaton Souriau-Sunbank": "/en/supplier-centers/souriau-connection-technology",
    "Eaton-Bussmann Electrical Division": "/en/supplier-centers/eaton-bussmann-electrical-division",
    "Eaton-Electronics Division": "/en/supplier-centers/eaton-electronics-division",
    "ebm-papst Inc.": "/en/supplier-centers/ebm-papst",
    "Echelon by Adesto": "/en/supplier-centers/echelon",
    "Eclipse Tools": "/en/supplier-centers/eclipse-tools",
    Ecliptek: "/en/supplier-centers/ecliptek",
    "ECS Inc. International": "/en/supplier-centers/ecs",
    "Ectron Corporation": "/en/supplier-centers/ectron-corporation",
    "ED2 Corp": "/en/supplier-centers/ed2-corp",
    "EDAC Inc.": "/en/supplier-centers/edac",
    "EDSYN Inc.": "/en/supplier-centers/edsyn-inc",
    EFCO: "/en/supplier-centers/efco",
    "Effulgent Inc.": "/en/supplier-centers/effulgent-inc",
    "Efinix, Inc.": "/en/supplier-centers/efinix",
    "EI Sensor Technologies": "/en/supplier-centers/ei-sensor-technologies",
    "EIC Semiconductor, Inc.": "/en/supplier-centers/eic-semiconductor-inc",
    "EKSMA Optics": "/en/supplier-centers/eksma-optics",
    "Elba Lubes": "/en/supplier-centers/elba-lubes",
    "Elco (AVX)": "/en/supplier-centers/elco",
    "Elcom International Pvt Ltd.": "/en/supplier-centers/elcom-international",
    "Elcon Connectors / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "Electric Imp": "/en/supplier-centers/electric-imp",
    "Electric Motors & Specialties": "/en/supplier-centers/electric-motors-and-specialties",
    "Electro Corp (Honeywell Sensing and Productivity Solutions)": "/en/supplier-centers/electro-corp",
    "Electro-Films (EFI) / Vishay": "/en/supplier-centers/vishay",
    "Electronic Assembly (Display Visions)": "/en/supplier-centers/electronic-assembly",
    "Electronic Concepts Inc.": "/en/supplier-centers/electronic-concepts-inc",
    "Electroreel Components, LLC": "/en/supplier-centers/electroreel-components",
    Electroswitch: "/en/supplier-centers/electroswitch",
    Electrotech: "/en/supplier-centers/electrotech",
    "Ellsworth Adhesives": "/en/supplier-centers/ellsworth-adhesives",
    "Elna America": "/en/supplier-centers/elna-america",
    Elprotronic: "/en/supplier-centers/elprotronic",
    "EM Microelectronic": "/en/supplier-centers/em-microelectronic",
    "EMA Design Automation": "/en/supplier-centers/ema-design-automation",
    "EMAC, Inc.": "/en/supplier-centers/emac-inc",
    "Embedded Artists": "/en/supplier-centers/embedded-artists",
    "EMC Test Design": "/en/supplier-centers/emc-test-design",
    "Emerging Power, Inc.": "/en/supplier-centers/emerging-power-inc",
    "Emerson Connectivity Solutions": "/en/supplier-centers/cinch-connectivity-solutions",
    "Emerson Embedded Power (Artesyn Embedded Technologies)": "/en/supplier-centers/artesyn-embedded-technologies",
    "Emerson SolaHD": "/en/supplier-centers/solahd",
    "EMI Filter Co": "/en/supplier-centers/emi-filter-co",
    EMIT: "/en/supplier-centers/desco",
    "EMO Inc.": "/en/supplier-centers/emo-systems",
    Enclustra: "/en/supplier-centers/enclustra",
    "Encoder Products Company": "/en/supplier-centers/encoder-products-company",
    enDAQ: "/en/supplier-centers/endaq",
    "Energizer Battery Company": "/en/supplier-centers/energizer-battery",
    "Energy Micro (Silicon Labs)": "/en/supplier-centers/silicon-labs",
    EnerSys: "/en/supplier-centers/enersys",
    "ENG ELECTRIC CO., LTD": "/en/supplier-centers/eng-electric",
    "ENM Counting Instruments": "/en/supplier-centers/enm-counting-instruments",
    "enmo Technologies": "/en/supplier-centers/enmo-technologies",
    "Enmotus, Inc.": "/en/supplier-centers/enmotus",
    EnOcean: "/en/supplier-centers/enocean",
    "EOS Power": "/en/supplier-centers/eos-power",
    EPC: "/en/supplier-centers/epc",
    "EPCOS (TDK)": "/en/supplier-centers/epcos",
    "e-peas SA": "/en/supplier-centers/e-peas-sa",
    "EPS WORKS SL (ArduSimple)": "/en/supplier-centers/eps-works-sl-ardusimple",
    Epson: "/en/supplier-centers/epson",
    "EPtronics, Inc.": "/en/supplier-centers/eptronics-inc",
    "Equinox Technologies": "/en/supplier-centers/equinox-technologies",
    EREM: "/en/supplier-centers/apex-tool-group",
    "Ergo Advantage": "/en/supplier-centers/ergo-advantage",
    "ERNI Electronics": "/en/supplier-centers/erni",
    "ERP Power": "/en/supplier-centers/erp-power",
    "Espressif Systems": "/en/supplier-centers/espressif-systems",
    "ESPROS Photonics AG": "/en/supplier-centers/espros",
    "Essen Deinki": "/en/supplier-centers/essen-deinki",
    "Essentra Access Solutions": "/en/supplier-centers/essentra-access-solutions",
    "Essentra Access Solutions / Mesan": "/en/supplier-centers/essentra-access-solutions",
    "Essentra Components": "/en/supplier-centers/essentra-components",
    "Essentra Components / Alliance": "/en/supplier-centers/essentra-components",
    "Essentra Components / Micro Plastics, Inc.": "/en/supplier-centers/essentra-components",
    "Essentra Components / Richco, Inc.": "/en/supplier-centers/essentra-components",
    "ESTA / Vishay": "/en/supplier-centers/vishay-bccomponents",
    Estatec: "/en/supplier-centers/estatec",
    "E-Switch": "/en/supplier-centers/e-switch",
    "E-T-A": "/en/supplier-centers/e-t-a",
    "ETA Compute": "/en/supplier-centers/eta-compute",
    "ETA-USA": "/en/supplier-centers/eta-usa",
    Ethertronics: "/en/supplier-centers/ethertronics",
    "Etron Technology": "/en/supplier-centers/etron-technology",
    EuControls: "/en/supplier-centers/eucontrols",
    "Eupec (Infineon)": "/en/supplier-centers/eupec",
    "Ever Win International Corporation": "/en/supplier-centers/ever-win-international-corporation",
    "Eveready (Energizer Battery Company)": "/en/supplier-centers/energizer-battery",
    "Everlight Electronics": "/en/supplier-centers/everlight-electronics",
    "Everspin Technologies, Inc.": "/en/supplier-centers/everspin-technologies",
    Everswitch: "/en/supplier-centers/everswitch-barantec",
    "Exar (MaxLinear)": "/en/supplier-centers/maxlinear",
    ExAscend: "/en/supplier-centers/exascend",
    "Excelitas Technologies": "/en/supplier-centers/excelitas-technologies",
    Excelsys: "/en/supplier-centers/excelsys-technologies",
    Excelta: "/en/supplier-centers/excelta",
    Exeltech: "/en/supplier-centers/exeltech",
    "Exostiv Labs": "/en/supplier-centers/exostiv-labs",
    "Extech (FLIR Extech)": "/en/supplier-centers/flir-extech",
    EXXELIA: "/en/supplier-centers/exxelia",
    "Eyecloud, Inc.": "/en/supplier-centers/eyecloud",
    "eze System, Inc.": "/en/supplier-centers/eze-system",
    "E-Z-Hook": "/en/supplier-centers/e-z-hook",
    "EZQuest, Inc.": "/en/supplier-centers/ezquest-inc",
    "Fairchild (ON Semiconductor)": "/en/supplier-centers/fairchild",
    "Fair-Rite Products Corp.": "/en/supplier-centers/fair-rite",
    "Falconer Electronics, Inc.": "/en/supplier-centers/falconer-electronics-inc",
    "Fan-S Division / Qualtek Electronics Corp.": "/en/supplier-centers/qualtek",
    "Fanstel Corp.": "/en/supplier-centers/fanstel",
    "FATH Inc.": "/en/supplier-centers/fath-inc",
    "FCi Basics (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    "FCT Electronics - Molex": "/en/supplier-centers/molex",
    "FDK America": "/en/supplier-centers/fdk-america",
    Fechometal: "/en/supplier-centers/fechometal",
    "Fedco Batteries": "/en/supplier-centers/fedco-batteries",
    "FEIG ELECTRONIC": "/en/supplier-centers/feig-electronic",
    "FEITIAN Technologies": "/en/supplier-centers/feitian-technologies",
    FERROXCUBE: "/en/supplier-centers/ferroxcube",
    Festo: "/en/supplier-centers/festo",
    "Fiber Instrument Sales": "/en/supplier-centers/fiber-instrument-sales",
    "FiberSource, Inc.": "/en/supplier-centers/fibersource-inc",
    "FIBOX Enclosures": "/en/supplier-centers/fibox-enclosures",
    "Finder Relays, Inc.": "/en/supplier-centers/finder-relays",
    "Fingerprint Cards AB": "/en/supplier-centers/fingerprints",
    "Finisar Corporation": "/en/supplier-centers/finisar",
    FinishAdapt: "/en/supplier-centers/finishadapt",
    "FIT (Foxconn Interconnect Technology)": "/en/supplier-centers/foxconn-optical-interconnect-technologies",
    "Flamar - Molex": "/en/supplier-centers/molex",
    "Flambeau, Inc.": "/en/supplier-centers/flambeau",
    "Flex Power Modules": "/en/supplier-centers/flex-power-modules",
    FlexPoint: "/en/supplier-centers/flexpoint",
    Flexxon: "/en/supplier-centers/flexxon",
    "Flip Electronics": "/en/supplier-centers/flip-electronics",
    FLIR: "/en/supplier-centers/flir",
    "FLIR Extech": "/en/supplier-centers/flir-extech",
    "FLIR Lepton": "/en/supplier-centers/flir-lepton",
    "Floyd Bell, Inc.": "/en/supplier-centers/floyd-bell-inc",
    "Fluke Electronics": "/en/supplier-centers/fluke-electronics",
    "Fluke Networks": "/en/supplier-centers/fluke-networks",
    Flusso: "/en/supplier-centers/flusso",
    "Focus LCDs": "/en/supplier-centers/focus-lcds",
    "Formerica Optoelectronics Inc.": "/en/supplier-centers/formerica",
    "Formosa Microsemi Co. Ltd.": "/en/supplier-centers/formosa-microsemi",
    Fotofab: "/en/supplier-centers/fotofab",
    "Fox Electronics": "/en/supplier-centers/fox-electronics",
    "Foxconn OE Technologies": "/en/supplier-centers/foxconn-optical-interconnect-technologies",
    "FRÄENKISCHE INDUSTRIAL PIPES": "/en/supplier-centers/frankische-usa",
    "FRÄENKISCHE USA, LP": "/en/supplier-centers/frankische-usa",
    Free2move: "/en/supplier-centers/free2move",
    "Freescale / NXP Semiconductors": "/en/supplier-centers/nxp-semiconductors",
    "Freescale Semiconductor, Inc. (NXP Semiconductors)": "/en/supplier-centers/freescale-semiconductor",
    "FreeWave Technologies, Inc.": "/en/supplier-centers/freewave-technologies",
    "Fremont Micro Devices": "/en/supplier-centers/fremont-micro-devices",
    "FRESH DIGIT": "/en/supplier-centers/fresh-digit",
    "Frontier Electronics": "/en/supplier-centers/frontier-electronics",
    "FSP Technology": "/en/supplier-centers/fsp",
    "FTDI (Future Technology Devices International, Ltd.)": "/en/supplier-centers/future-technology-devices-intl",
    FTS: "/en/supplier-centers/fts",
    "Fujitsu Electronics America, Inc.": "/en/supplier-centers/fujitsu",
    FULLSTEM: "/en/supplier-centers/fullstem",
    "Furuno (Kaga Electronics USA)": "/en/supplier-centers/volgen",
    Fuspower: "/en/supplier-centers/fuspower",
    Futaba: "/en/supplier-centers/futaba",
    Future: "/en/supplier-centers/future",
    "Future Designs, Inc.": "/en/supplier-centers/future-designs",
    "Future Technology Devices International, Ltd.": "/en/supplier-centers/future-technology-devices-intl",
    "Gaia Converter": "/en/supplier-centers/gaia-converter",
    "Gamma Electronics": "/en/supplier-centers/gamma-electronics",
    "GAPTEC Electronic": "/en/supplier-centers/gaptec-electronic",
    GardTec: "/en/supplier-centers/gardtec",
    "Garmin Canada Inc.": "/en/supplier-centers/dynastream-innovations",
    "Gas Sensing Solutions Ltd": "/en/supplier-centers/gas-sensing-solutions",
    "Gateworks Corporation": "/en/supplier-centers/gateworks-corporation",
    "GC Electronics": "/en/supplier-centers/gc-electronics",
    GCT: "/en/supplier-centers/gct",
    "GE Critical Power (ABB Embedded Power)": "/en/supplier-centers/ge-critical-power",
    Geckodrive: "/en/supplier-centers/geckodrive",
    "GEDORE Tools, Inc.": "/en/supplier-centers/gedore-tools",
    "Gemalto (Thales DIS)": "/en/supplier-centers/thales-dis",
    "Genasun by Sunforge LLC": "/en/supplier-centers/genasun",
    "General Cable": "/en/supplier-centers/general-cable",
    "General Semiconductor (Vishay)": "/en/supplier-centers/general-semiconductor",
    "GeneSiC Semiconductor": "/en/supplier-centers/genesic-semiconductor",
    Genicom: "/en/supplier-centers/genicom",
    "Genuino (Arduino)": "/en/supplier-centers/arduino",
    "GES High Voltage": "/en/supplier-centers/ges-high-voltage",
    "Gettop Acoustics": "/en/supplier-centers/gettop-acoustics",
    "Geyer Electronic America, Inc.": "/en/supplier-centers/geyer-electronic-america-inc",
    "GHI Electronics, LLC": "/en/supplier-centers/ghi-electronics",
    GigaDevice: "/en/supplier-centers/gigadevice",
    "Glas-Col, LLC": "/en/supplier-centers/glas-col-llc",
    "GLF Integrated Power": "/en/supplier-centers/glf-integrated-power",
    "Global Connector Technology, Limited (GCT)": "/en/supplier-centers/gct",
    "Global Specialties": "/en/supplier-centers/global-specialties",
    "Global Technologies Group, Inc.": "/en/supplier-centers/global-technologies-group",
    "GlobTek, Inc.": "/en/supplier-centers/globtek",
    Glowforge: "/en/supplier-centers/glowforge",
    "GMEMS Technologies": "/en/supplier-centers/gmems-technologies",
    "GMW Associates": "/en/supplier-centers/gmw-associates",
    GotRad: "/en/supplier-centers/gotrad",
    "GP Systems GmbH": "/en/supplier-centers/gp-systems-gmbh",
    GradConn: "/en/supplier-centers/gradconn",
    "Grayhill, Inc.": "/en/supplier-centers/grayhill",
    "Greenlee Communications": "/en/supplier-centers/greenlee-communications",
    "Grepow Inc.": "/en/supplier-centers/grepow",
    GroupGets: "/en/supplier-centers/groupgets",
    "GS Software": "/en/supplier-centers/gs-software",
    "GSI Technology": "/en/supplier-centers/gsi-technology",
    "GWConnect - Molex": "/en/supplier-centers/molex",
    "H&D Wireless": "/en/supplier-centers/h-d-wireless",
    "H.G. Schaevitz, LLC / Alliance Sensors Group": "/en/supplier-centers/alliance-sensors",
    "Hagiwara Solutions": "/en/supplier-centers/hagiwara-solutions",
    Hakko: "/en/supplier-centers/american-hakko-products",
    "Hallsten Innovations": "/en/supplier-centers/hallsten-innovations",
    "Hamlin / Littelfuse": "/en/supplier-centers/littelfuse",
    "Hammond Manufacturing": "/en/supplier-centers/hammond-manufacturing",
    "Hankscraft, Inc.": "/en/supplier-centers/hankscraft-inc",
    HARTING: "/en/supplier-centers/harting",
    "Harvatek Corporation": "/en/supplier-centers/harvatek-corporation",
    Harwin: "/en/supplier-centers/harwin",
    "Hasco Relays": "/en/supplier-centers/hasco-relays",
    Hayata: "/en/supplier-centers/hayata",
    "HDP Power": "/en/supplier-centers/hdp-power",
    Heatron: "/en/supplier-centers/heatron",
    Helium: "/en/supplier-centers/helium",
    "Helix Semiconductors": "/en/supplier-centers/helix-semiconductors",
    HellermannTyton: "/en/supplier-centers/hellermanntyton",
    "Henkel / Bergquist": "/en/supplier-centers/bergquist",
    "Henkel/Loctite": "/en/supplier-centers/henkel-loctite",
    "Henrich Electronics Corporation": "/en/supplier-centers/henrich-electronics-corporation",
    "Heraeus Nexensos USA": "/en/supplier-centers/heraeus",
    "High Speed Backplane Products (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    "High Speed IO (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    "High-Tech Conversions": "/en/supplier-centers/high-tech-conversions",
    "Hillcrest Labs (CEVA)": "/en/supplier-centers/hillcrest-labs",
    "HI-LO Systems": "/en/supplier-centers/hi-lo-systems",
    "HiRel Systems / Vishay": "/en/supplier-centers/vishay-dale",
    Hirose: "/en/supplier-centers/hirose",
    Hirschmann: "/en/supplier-centers/hirschmann",
    "Hitec Commercial Solutions LLC": "/en/supplier-centers/hitec-commercial-solutions-llc",
    HiTek: "/en/supplier-centers/excelsys-technologies",
    "Hittite (Analog Devices)": "/en/supplier-centers/hittite",
    HKC: "/en/supplier-centers/hkc-hong-kong-xtals-limited",
    "HMS Networks": "/en/supplier-centers/hms-industrial-networks",
    HOBO: "/en/supplier-centers/hobo",
    Hoffman: "/en/supplier-centers/hoffman",
    Hologram: "/en/supplier-centers/hologram",
    "Holsworthy Resistors / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "Holt Integrated Circuits, Inc.": "/en/supplier-centers/holt-integrated-circuits",
    "Holy Stone Enterprise": "/en/supplier-centers/holy-stone",
    "HOMEVISION TECHNOLOGY INC.": "/en/supplier-centers/homevision-technology",
    "Honeywell Aerospace": "/en/supplier-centers/honeywell-microelectronics-and-precision-sensors",
    "Honeywell Sensing and Productivity Solutions": "/en/supplier-centers/honeywell-sensing-productivity-solutions",
    "Hong Kong X’tals Limited (HKC)": "/en/supplier-centers/hkc-hong-kong-xtals-limited",
    "Horus Scope": "/en/supplier-centers/horus-scope-medimaging-integrated-solution",
    "Hosonic Electronic": "/en/supplier-centers/hosonic-electronic",
    "HPC Optics": "/en/supplier-centers/hpc-optics",
    "Hubbell Lighting Components (Thomas Research Products)": "/en/supplier-centers/thomas-research-products",
    "HVM Technology, Inc.": "/en/supplier-centers/hvm-technology",
    HYPERSPACE: "/en/supplier-centers/hyperspace",
    "I W Tremont": "/en/supplier-centers/i-w-tremont",
    "I/O Interconnect": "/en/supplier-centers/io-interconnect",
    "IAC Industries": "/en/supplier-centers/iac-industries",
    "IAR Systems Software Inc": "/en/supplier-centers/iar-systems-software",
    "iBASE Technology": "/en/supplier-centers/ibase-technology",
    "ICCNexergy (Inventus Power)": "/en/supplier-centers/iccnexergy",
    "ICP DAS USA Inc.": "/en/supplier-centers/icp-das-usa-inc",
    "Ideal Power": "/en/supplier-centers/ideal-power",
    "Ideal-tek": "/en/supplier-centers/ideal-tek",
    IDEC: "/en/supplier-centers/idec",
    "IdentaZone Inc.": "/en/supplier-centers/identazone",
    "IDT (Renesas Electronics America)": "/en/supplier-centers/integrated-device-tech",
    "iEi Technology": "/en/supplier-centers/iei-technology",
    iFixit: "/en/supplier-centers/ifixit",
    "ifm Efector": "/en/supplier-centers/ifm",
    Ignion: "/en/supplier-centers/fractus-antennas",
    "Ignion (Fractus Antennas)": "/en/supplier-centers/fractus-antennas",
    "Igus, Inc.": "/en/supplier-centers/igus-inc",
    "II-VI Marlow": "/en/supplier-centers/marlow-industries",
    "iKey, Ltd.": "/en/supplier-centers/ikey-ltd",
    "Illinois Capacitor": "/en/supplier-centers/illinois-capacitor",
    illumequip: "/en/supplier-centers/illumequip",
    ILLUMRA: "/en/supplier-centers/illumra",
    ILSI: "/en/supplier-centers/ilsi",
    "Imagination Supply Co": "/en/supplier-centers/imagination-supply-co",
    Imperix: "/en/supplier-centers/imperix",
    IMS: "/en/supplier-centers/ims",
    "Industrial Fiber Optics, Inc.": "/en/supplier-centers/industrial-fiber-optics",
    "Industrial Safety Controls, Inc.": "/en/supplier-centers/industrial-safety-controls",
    "Industrial Shields": "/en/supplier-centers/industrial-shields",
    IndustrialeMart: "/en/supplier-centers/industrialemart",
    "IndustrialSupplies.com": "/en/supplier-centers/industrialsupplies",
    "Infineon Technologies": "/en/supplier-centers/infineon-technologies",
    Infiray: "/en/supplier-centers/infiray-visir",
    "Initial State Technologies, Inc.": "/en/supplier-centers/initial-state-technologies",
    "InnoSenT GmbH": "/en/supplier-centers/innosent",
    "Innovasic Semiconductor / Analog Devices, Inc.": "/en/supplier-centers/innovasic-semiconductor",
    "Innovative Sensor Technology": "/en/supplier-centers/innovative-sensor-technology",
    Innovisionsemi: "/en/supplier-centers/innovisionsemi",
    Inolux: "/en/supplier-centers/inolux",
    iNRCORE: "/en/supplier-centers/pulse-ruggedized",
    "Insight SiP": "/en/supplier-centers/insight-sip",
    "Insignis Technology Corporation": "/en/supplier-centers/insignis",
    "Inspired LED": "/en/supplier-centers/inspired-led",
    "Integra Enclosures": "/en/supplier-centers/integra-enclosures",
    "Integra Technologies": "/en/supplier-centers/integra-technologies",
    "Integrated Device Technology (IDT) ": "/en/supplier-centers/integrated-device-tech",
    "Integrated Device Technology (Renesas Electronics America)": "/en/supplier-centers/integrated-device-tech",
    "Integrated Power Designs": "/en/supplier-centers/integrated-power-designs",
    "Integrated Silicon Solution, Inc. (ISSI)": "/en/supplier-centers/integrated-silicon-solution",
    Intel: "/en/supplier-centers/intel",
    "Intelligent Technology Trade": "/en/supplier-centers/intelligent-technology-trade-ittww",
    Intematix: "/en/supplier-centers/intematix",
    "InterCon Systems (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    "Interconnect Systems - Molex": "/en/supplier-centers/molex",
    "Interlink Electronics": "/en/supplier-centers/interlink-electronics",
    "International Components Corp.": "/en/supplier-centers/international-components-corp",
    "International Power DC Power Supplies": "/en/supplier-centers/international-power-dc-power-supplies",
    "International Rectifier (Infineon Technologies)": "/en/supplier-centers/infineon-technologies",
    "International Test Instruments Corporation": "/en/supplier-centers/international-test-instruments",
    Interpower: "/en/supplier-centers/interpower",
    "Intersil (Renesas Electronics America)": "/en/supplier-centers/intersil",
    "Introspect Technology": "/en/supplier-centers/introspect-technology",
    "Intwine Connect LLC": "/en/supplier-centers/intwine-connect-llc",
    "InvenSense/TDK": "/en/supplier-centers/invensense",
    "Inventek Systems": "/en/supplier-centers/inventek-systems",
    "Inventus Power": "/en/supplier-centers/iccnexergy",
    "Io Audio Technologies": "/en/supplier-centers/io-audio-technologies",
    "IOT-BOTS.COM": "/en/supplier-centers/iot-bots",
    "IoThink Solutions": "/en/supplier-centers/iothink-solutions",
    IoTize: "/en/supplier-centers/iotize",
    "Iowa Scaled Engineering": "/en/supplier-centers/iowa-scaled-engineering",
    "I-PEX": "/en/supplier-centers/i-pex",
    "IQD Frequency Products": "/en/supplier-centers/iqd-frequency-products",
    "IR (Infineon Technologies)": "/en/supplier-centers/infineon-technologies",
    "IRISO Electronics": "/en/supplier-centers/iriso",
    "IRTOUCH Systems Co., Ltd.": "/en/supplier-centers/irtouch-systems",
    ISC: "/en/supplier-centers/isc",
    "ISL Products International": "/en/supplier-centers/isl-products-international",
    "Isocom Components": "/en/supplier-centers/isocom-components",
    "ISSI (Integrated Silicon Solution, Inc.)": "/en/supplier-centers/integrated-silicon-solution",
    "itbrainpower.net/R&D Software Solutions": "/en/supplier-centers/itbrainpower-rd-software-solutions",
    Iteco: "/en/supplier-centers/iteco",
    "ITG Electronics, Inc.": "/en/supplier-centers/itg-electronics-inc",
    "ITT Cannon, LLC": "/en/supplier-centers/itt-interconnect-solutions",
    "ITT Interconnect Solutions": "/en/supplier-centers/itt-interconnect-solutions",
    "ITW Chemtronics (Chemtronics)": "/en/supplier-centers/chemtronics",
    "iVativ Inc.": "/en/supplier-centers/ivativ",
    "iWave Systems": "/en/supplier-centers/iwave-systems",
    "IXYS / Littelfuse": "/en/supplier-centers/ixys-corporation",
    "IXYS Integrated Circuits Division": "/en/supplier-centers/ixys-corporation",
    "IXYS RF": "/en/supplier-centers/ixys-corporation",
    "J.W. Miller / Bourns": "/en/supplier-centers/bourns",
    "J.W. Winco": "/en/supplier-centers/jw-winco",
    Jabil: "/en/supplier-centers/jabil",
    Jacob: "/en/supplier-centers/jacob",
    "JAE Electronics": "/en/supplier-centers/jae-electronics",
    "Jameson LLC": "/en/supplier-centers/jameson-llc",
    "Janesville Tool & Mfg. Inc.": "/en/supplier-centers/janesville-tool-and-mfg-inc",
    "Janus Remote Communications": "/en/supplier-centers/janus-remote-communications",
    "Jasper Electronics": "/en/supplier-centers/jasper-electronics",
    "Jauch Quartz": "/en/supplier-centers/jauch",
    "JBC TOOLS USA INC.": "/en/supplier-centers/jbc-tools-usa-inc",
    "JBL Products, Inc.": "/en/supplier-centers/jbl-products-inc",
    "Jensen Global Inc.": "/en/supplier-centers/jensen-global",
    "Jinlong Machinery & Electronics, Inc.": "/en/supplier-centers/jinlong-machinery",
    "JKL Components Corporation": "/en/supplier-centers/jkl-components-corporation",
    "Johanson Dielectrics, Inc.": "/en/supplier-centers/johanson-dielectrics",
    "Johanson Manufacturing": "/en/supplier-centers/knowles-johanson-manufacturing",
    "Johanson Technology": "/en/supplier-centers/johanson-technology",
    "Johnson / Cinch Connectivity Solutions": "/en/supplier-centers/cinch-connectivity-solutions",
    "Johnson Electric - Ledex Dormeyer Saia": "/en/supplier-centers/ledex-dormeyer-saia",
    "Jonard Tools": "/en/supplier-centers/jonard",
    Jorjin: "/en/supplier-centers/jorjin",
    Joulescope: "/en/supplier-centers/joulescope",
    "JRC Corporation / NJRC": "/en/supplier-centers/njr-corporation",
    JST: "/en/supplier-centers/jst",
    "Judco Manufacturing, Inc.": "/en/supplier-centers/judco-manufacturing",
    JULABO: "/en/supplier-centers/julabo",
    "Kaga Electronics USA": "/en/supplier-centers/volgen",
    "Kainos Systems": "/en/supplier-centers/kainos-systems",
    Kamaya: "/en/supplier-centers/kamaya",
    "Kang Yang International": "/en/supplier-centers/kang-yang-international",
    "Kavlico Pressure Sensors / Sensata Technologies": "/en/supplier-centers/kavlico",
    "Keene Village Plastics": "/en/supplier-centers/keene-village-plastics",
    "Keil (ARM)": "/en/supplier-centers/arm",
    "Keller America Inc.": "/en/supplier-centers/keller-america-inc",
    KEMET: "/en/supplier-centers/kemet",
    "Kendall Howard": "/en/supplier-centers/kendall-howard",
    "Kennedy Labs": "/en/supplier-centers/kennedy-labs",
    "Kepco Power": "/en/supplier-centers/kepco",
    Kester: "/en/supplier-centers/kester",
    "Keystone Electronics Corp.": "/en/supplier-centers/keystone-electronics",
    Khadas: "/en/supplier-centers/khadas",
    Khatod: "/en/supplier-centers/khatod",
    "Kilo International": "/en/supplier-centers/kilo-international",
    "Kilovac Relays / TE Connectivity": "/en/supplier-centers/te-connectivity",
    Kimya: "/en/supplier-centers/kimya",
    "Kinetic Technologies": "/en/supplier-centers/kinetic-technologies",
    Kingbright: "/en/supplier-centers/kingbright",
    "Kings (Winchester Electronics)": "/en/supplier-centers/winchester-electronics",
    Kingston: "/en/supplier-centers/kingston",
    Kionix: "/en/supplier-centers/kionix",
    "Kioxia America, Inc.": "/en/supplier-centers/toshiba-memory-america",
    Kitronik: "/en/supplier-centers/kitronik",
    "Klein Tools": "/en/supplier-centers/klein-tools",
    "Knick Interface": "/en/supplier-centers/knick-interface",
    "KNIPEX Tools": "/en/supplier-centers/knipex-tools",
    Knowles: "/en/supplier-centers/knowles",
    "Knowles DLI": "/en/supplier-centers/knowles-dli",
    "Knowles Johanson Manufacturing": "/en/supplier-centers/knowles-johanson-manufacturing",
    "Knowles NOVACAP": "/en/supplier-centers/knowles-novacap",
    "Knowles Syfer": "/en/supplier-centers/syfer",
    "Knowles Voltronics": "/en/supplier-centers/knowles-voltronics",
    "KOA Speer Electronics, Inc.": "/en/supplier-centers/koa-speer",
    "Krohn-Hite Corporation": "/en/supplier-centers/krohn-hite-corporation",
    "Kübler, Inc.": "/en/supplier-centers/kubler",
    "KUKA Robotics ": "/en/supplier-centers/kuka-robotics",
    "KUNBUS GmbH": "/en/supplier-centers/kunbus",
    KUROKESU: "/en/supplier-centers/kurokesu",
    "Kurtz Ersa, Inc.": "/en/supplier-centers/kurtz-ersa-inc",
    Kycon: "/en/supplier-centers/kycon",
    "KYOCERA Corporation": "/en/supplier-centers/kyocera",
    "Kyocera Display": "/en/supplier-centers/kyocera-display",
    "L3 Narda-MITEQ": "/en/supplier-centers/l3-narda-miteq",
    LabJack: "/en/supplier-centers/labjack",
    "Laird - Antennas": "/en/supplier-centers/laird-technologies-antennas",
    "Laird - Performance Materials": "/en/supplier-centers/laird-technologies-emi",
    "Laird Connectivity": "/en/supplier-centers/laird-embedded-wireless-solutions",
    "Laird Connectivity (LSR)": "/en/supplier-centers/lsr",
    "Laird Thermal Systems": "/en/supplier-centers/laird-thermal-systems",
    Lantronix: "/en/supplier-centers/lantronix",
    "LAPIS Technology": "/en/supplier-centers/rohm-semi",
    LAPP: "/en/supplier-centers/lapp",
    "Lascar Electronics": "/en/supplier-centers/lascar-electronics",
    "Laser Technology, Inc.": "/en/supplier-centers/laser-technology",
    "Lattice Semiconductor": "/en/supplier-centers/lattice-semiconductor",
    "Leader Tech Inc. ": "/en/supplier-centers/leader-tech",
    "LeCroy (Teledyne LeCroy)": "/en/supplier-centers/teledyne-lecroy",
    "LED Engin": "/en/supplier-centers/led-engin",
    "LED Lighting Inc.": "/en/supplier-centers/led-lighting-inc",
    "LEDdynamics, Inc.": "/en/supplier-centers/leddynamics",
    "Ledex Dormeyer Saia": "/en/supplier-centers/ledex-dormeyer-saia",
    LEDiL: "/en/supplier-centers/ledil",
    "LEM USA, Inc.": "/en/supplier-centers/lem-usa",
    LEMO: "/en/supplier-centers/lemo",
    "Leopard Imaging Inc.": "/en/supplier-centers/leopard-imaging",
    "Lepton (FLIR Lepton)": "/en/supplier-centers/flir-lepton",
    Leuze: "/en/supplier-centers/leuze",
    "LICAP Technologies": "/en/supplier-centers/licap-technologies",
    "Lighthorse Technologies Inc.": "/en/supplier-centers/lighthorse-technologies-inc",
    "Lighting Science": "/en/supplier-centers/lighting-science",
    "Lilliput Electronics USA": "/en/supplier-centers/lilliput-electronics-usa",
    "Lime Microsystems": "/en/supplier-centers/lime-microsystems",
    "Limited (Amphenol Pcd)": "/en/supplier-centers/amphenol-pcd",
    "Lin Engineering": "/en/supplier-centers/lin-engineering",
    "Linear Integrated Systems, Inc.": "/en/supplier-centers/linear-integrated-systems",
    "Linear Technology (Analog Devices, Inc.)": "/en/supplier-centers/analog-devices",
    "Link Labs": "/en/supplier-centers/link-labs",
    "Linx Technologies": "/en/supplier-centers/linx-technologies",
    "Lite-On, Inc.": "/en/supplier-centers/lite-on",
    Littelfuse: "/en/supplier-centers/littelfuse",
    "LMB Heeger, Inc.": "/en/supplier-centers/lmb-heeger",
    "Loadstar Sensors": "/en/supplier-centers/loadstar-sensors",
    "LOCTITE / Henkel": "/en/supplier-centers/henkel-loctite",
    LoggerFlex: "/en/supplier-centers/loggerflex",
    "Logic PD (Beacon EmbeddedWorks)": "/en/supplier-centers/logic-pd",
    "Logical Systems": "/en/supplier-centers/logical-systems",
    LogiSwitch: "/en/supplier-centers/logiswitch",
    "LOW PIM RF/Mobiyu Corporation": "/en/supplier-centers/mobiyu-corporation",
    "LPD TRADE INC": "/en/supplier-centers/lpd-trade",
    "LSI/CSI": "/en/supplier-centers/lsi-csi",
    "LTI (Laser Technology, Inc.)": "/en/supplier-centers/laser-technology",
    "LTW (Amphenol LTW)": "/en/supplier-centers/amphenol-ltw",
    LulzBot: "/en/supplier-centers/lulzbot",
    "Lumberg Automation": "/en/supplier-centers/lumberg-automation",
    "Lumex, Inc.": "/en/supplier-centers/lumex",
    Lumileds: "/en/supplier-centers/lumileds",
    "Luminary Micro/Texas Instruments": "/en/supplier-centers/texas-instruments",
    "Luminus Devices": "/en/supplier-centers/luminus-devices",
    "Lumissil Microsystems": "/en/supplier-centers/lumissil",
    "Luna Optoelectronics (Advanced Photonix)": "/en/supplier-centers/advanced-photonix",
    "Lunasea Lighting": "/en/supplier-centers/lunasea-lighting",
    Luner: "/en/supplier-centers/luner",
    LUXTECH: "/en/supplier-centers/luxtech",
    "Lyn-Tron": "/en/supplier-centers/lyn-tron",
    "M+A Matting": "/en/supplier-centers/m-a-matting",
    M5Stack: "/en/supplier-centers/m5stack",
    Macchina: "/en/supplier-centers/macchina",
    Machinechat: "/en/supplier-centers/machinechat",
    "MACOM Technology Solutions": "/en/supplier-centers/macom",
    "Macraigor Systems LLC": "/en/supplier-centers/macraigor-systems",
    "Macromatic Industrial Controls": "/en/supplier-centers/macromatic-industrial-controls",
    Macronix: "/en/supplier-centers/macronix",
    "Made Systems": "/en/supplier-centers/made-systems",
    MadgeTech: "/en/supplier-centers/madgetech",
    "Maestro Wireless Solutions (Lantronix)": "/en/supplier-centers/maestro-wireless",
    "Mag Layers": "/en/supplier-centers/mag-layers",
    MagicDAQ: "/en/supplier-centers/magicdaq",
    "Mag-LED Solutions": "/en/supplier-centers/mag-led-solutions",
    "Magna-Power Electronics": "/en/supplier-centers/magna-power-electronics",
    "Magnasphere Corp.": "/en/supplier-centers/magnasphere",
    "Magnetic Shield Corporation": "/en/supplier-centers/magnetic-shield-corporation",
    "Magnitude Lighting": "/en/supplier-centers/magnitude-lighting",
    "Maida Development Company": "/en/supplier-centers/maida-development-company",
    "Major League Electronics": "/en/supplier-centers/major-league-electronics",
    Makeblock: "/en/supplier-centers/makeblock",
    MakersLED: "/en/supplier-centers/makersled",
    "MAKESafe Tools, Inc.": "/en/supplier-centers/makesafe-tools",
    "Mallory Sonalert Products": "/en/supplier-centers/mallory-sonalert-products",
    "Man & Machine Inc.": "/en/supplier-centers/man-and-machine",
    "Maple Systems": "/en/supplier-centers/maple-systems",
    "Mark-10": "/en/supplier-centers/mark-10",
    "Marktech Optoelectronics": "/en/supplier-centers/marktech-optoelectronics",
    "Marlin Technologies": "/en/supplier-centers/marlin-technologies",
    "Marlow Industries, Inc.": "/en/supplier-centers/marlow-industries",
    Marutsuelec: "/en/supplier-centers/marutsu",
    "Marvell Semiconductor, Inc.": "/en/supplier-centers/marvell",
    Masach: "/en/supplier-centers/masach",
    "Master Appliance Corp.": "/en/supplier-centers/master-appliance",
    "MATRIX Industries": "/en/supplier-centers/matrix-industries",
    "MATRIX Labs": "/en/supplier-centers/matrix-labs",
    "Matrix Orbital": "/en/supplier-centers/matrix-orbital",
    "Matter and Form": "/en/supplier-centers/matter-and-form",
    "Maudlin Products": "/en/supplier-centers/maudlin-products",
    "MaxBotix Inc.": "/en/supplier-centers/maxbotix",
    "Maxim Integrated": "/en/supplier-centers/maxim-integrated",
    MaxLinear: "/en/supplier-centers/maxlinear",
    "MaxStream (Digi International)": "/en/supplier-centers/maxstream",
    "Maxwell Technologies, Inc.": "/en/supplier-centers/maxwell-technologies",
    "MCB Industrie/Vishay": "/en/supplier-centers/vishay-sfernice",
    "McGraw-Hill Education": "/en/supplier-centers/mcgraw-hill-education",
    mCube: "/en/supplier-centers/mcube",
    "MEAN WELL": "/en/supplier-centers/mean-well",
    "Measurement Computing Corporation": "/en/supplier-centers/measurement-computing-corporation",
    "Measurement Specialties / TE Connectivity": "/en/supplier-centers/te-connectivity-measurement-specialties",
    "MEC switches": "/en/supplier-centers/mec-switches",
    Mechatronics: "/en/supplier-centers/mechatronics",
    "Mechatronics Bearing Group": "/en/supplier-centers/mechatronics-bearing-group",
    Meftronics: "/en/supplier-centers/meftronics",
    MegaChips: "/en/supplier-centers/megachips",
    Megapro: "/en/supplier-centers/megapro",
    Melexis: "/en/supplier-centers/melexis",
    "Memory Protection Devices": "/en/supplier-centers/memory-protection-devices",
    MEMSIC: "/en/supplier-centers/memsic",
    "Menda/EasyBraid/Tronex ": "/en/supplier-centers/easybraid",
    "Mentech Technology USA Inc.": "/en/supplier-centers/mentech-technology",
    "Mercury United Electronics": "/en/supplier-centers/mercury-united-electronics",
    Meritek: "/en/supplier-centers/meritek",
    "Mesan (Essentra Access Solutions)": "/en/supplier-centers/essentra-access-solutions",
    "Metelics (MACOM Technology Solutions)": "/en/supplier-centers/macom",
    "Methode Datamate": "/en/supplier-centers/methode-datamate",
    "METZ CONNECT": "/en/supplier-centers/metz-connect",
    "Mezzanine Products (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    "MG Chemicals": "/en/supplier-centers/mg-chemicals",
    "Micrel / Microchip Technology": "/en/supplier-centers/microchip-technology",
    Micrium: "/en/supplier-centers/micrium",
    "Micro Commercial Components (MCC)": "/en/supplier-centers/micro-commercial-components",
    "Micro Connectors, Inc.": "/en/supplier-centers/micro-connectors-inc",
    "Micro Crystal": "/en/supplier-centers/micro-crystal",
    "Micro Plastics, Inc. (Essentra Components)": "/en/supplier-centers/essentra-components",
    "Micro/sys": "/en/supplier-centers/micro-sys",
    MicroCare: "/en/supplier-centers/microcare",
    "Microchip Technology": "/en/supplier-centers/microchip-technology",
    "Microfire LLC": "/en/supplier-centers/microfire",
    "Micro-Measurements / Vishay Precision Group": "/en/supplier-centers/micro-measurements",
    "Micromega Dynamics Recovib": "/en/supplier-centers/micromega-dynamics",
    "Micron Technology": "/en/supplier-centers/micron-technology",
    "Micronas / TDK": "/en/supplier-centers/micronas",
    "Micronel USA": "/en/supplier-centers/micronel-usa",
    Micronet: "/en/supplier-centers/bnl-technologies",
    "Micropower Battery Company": "/en/supplier-centers/micropower-battery-company",
    Microsemi: "/en/supplier-centers/microsemi",
    "Microwave Technology": "/en/supplier-centers/microwave-technology",
    "Mid Atlantic Rugged Systems": "/en/supplier-centers/mid-atlantic-rugged-systems",
    "Midas Displays": "/en/supplier-centers/midas-displays",
    "Mide Technology": "/en/supplier-centers/mide-tech",
    "Midwest Microwave / Cinch Connectivity Solutions": "/en/supplier-centers/cinch-connectivity-solutions",
    "Midwest Motion Products": "/en/supplier-centers/midwest-motion-products",
    MightyZAP: "/en/supplier-centers/ir-robot",
    MikroElektronika: "/en/supplier-centers/mikroelektronika",
    "Mill-Max": "/en/supplier-centers/mill-max",
    "Mills / Vishay": "/en/supplier-centers/vishay-huntington-electric",
    "Millspaw Electronics": "/en/supplier-centers/millspaw-electronics",
    "Milwaukee / Vishay": "/en/supplier-centers/vishay-huntington-electric",
    "MinebeaMitsumi / NMB": "/en/supplier-centers/nmb-technologies",
    "Mini-Circuits": "/en/supplier-centers/mini-circuits",
    MISCO: "/en/supplier-centers/misco",
    "MITEQ, Inc.（L3 Narda-MITEQ）": "/en/supplier-centers/l3-narda-miteq",
    "mitex LLC": "/en/supplier-centers/mitex",
    "Mitsubishi Materials U.S.A": "/en/supplier-centers/mitsubishi-materials",
    "Mitsumi  Electric Company": "/en/supplier-centers/mitsumi",
    "MM Newman Corporation": "/en/supplier-centers/mm-newman-corporation",
    "MMB Networks": "/en/supplier-centers/mmb-networks",
    MMD: "/en/supplier-centers/mmd",
    "Mobiveil Technologies": "/en/supplier-centers/mobiveil-technologies",
    Moddable: "/en/supplier-centers/moddable",
    "Moffatt Products": "/en/supplier-centers/moffatt-products",
    Molex: "/en/supplier-centers/molex",
    "Molex Affinity Medical Technologies ": "/en/supplier-centers/molex",
    "Molex Beau Interconnect ": "/en/supplier-centers/molex",
    "Molex Bittware": "/en/supplier-centers/molex",
    "Molex Brad Harrison": "/en/supplier-centers/molex",
    "Molex Contrinex": "/en/supplier-centers/molex",
    "Molex FCT Electronics ": "/en/supplier-centers/molex",
    "Molex Flamar ": "/en/supplier-centers/molex",
    "Molex GWConnect ": "/en/supplier-centers/molex",
    "Molex Interconnect Systems ": "/en/supplier-centers/molex",
    "Molex Nallatech": "/en/supplier-centers/molex",
    "Molex Nistica": "/en/supplier-centers/molex",
    "Molex NuCurrent": "/en/supplier-centers/molex",
    "Molex Oplink Communications, LLC": "/en/supplier-centers/oplink",
    "Molex Phillips-Medisize": "/en/supplier-centers/molex",
    "Molex PolyMicro Technologies ": "/en/supplier-centers/molex",
    "Molex SensorCon": "/en/supplier-centers/molex",
    "Molex Temp-Flex ": "/en/supplier-centers/molex",
    "Molex Triton Manufacturing": "/en/supplier-centers/molex",
    "Molex Woodhead ": "/en/supplier-centers/molex",
    Monnit: "/en/supplier-centers/monnit",
    MonoDAQ: "/en/supplier-centers/monodaq",
    "Monolithic Power Systems": "/en/supplier-centers/monolithic-power-systems",
    "Monsoon Solutions Inc.": "/en/supplier-centers/monsoon-solutions",
    Monzite: "/en/supplier-centers/monzite",
    Mornsun: "/en/supplier-centers/mornsun",
    MoSys: "/en/supplier-centers/mosys",
    Moujen: "/en/supplier-centers/moujen",
    "Move-X": "/en/supplier-centers/move-x",
    MP: "/en/supplier-centers/mp-mechanical-products",
    "MP Antenna": "/en/supplier-centers/mp-antenna",
    "MPD (Memory Protection Devices)": "/en/supplier-centers/memory-protection-devices",
    "MPS (Monolithic Power Systems)": "/en/supplier-centers/monolithic-power-systems",
    "MTE Corporation": "/en/supplier-centers/mte-corporation",
    MtronPTI: "/en/supplier-centers/mtronpti",
    "Mueller Electric Co.": "/en/supplier-centers/mueller-electric",
    MULTIDIMENSION: "/en/supplier-centers/multidimension-dowaytech",
    "Multi-Tech Systems, Inc.": "/en/supplier-centers/multi-tech-systems",
    "Multi-Tek": "/en/supplier-centers/multi-tek",
    "Murata Electronics": "/en/supplier-centers/murata-electronics",
    "Murata Power Solutions": "/en/supplier-centers/murata-power-solutions",
    Murrplastik: "/en/supplier-centers/murrplastik",
    myDevices: "/en/supplier-centers/mydevices",
    "MYIR Tech Limited": "/en/supplier-centers/myir-tech-limited",
    "N2 Power": "/en/supplier-centers/n2-power",
    NAC: "/en/supplier-centers/nac",
    "Naina Semiconductor Ltd.": "/en/supplier-centers/naina-semiconductor",
    "Nakagawa Manufacturing USA, Inc.": "/en/supplier-centers/nakagawa",
    "Nallatech - Molex": "/en/supplier-centers/molex",
    Nanmac: "/en/supplier-centers/nanmac",
    "Nano3DPrint/Carbon Design Innovations": "/en/supplier-centers/nano3dprint-carbon-design-innovations",
    "Nanoport Technology Inc.": "/en/supplier-centers/nanoport-technology-inc",
    "Nanotron, an Inpixon Company": "/en/supplier-centers/sensera",
    "National Control Devices": "/en/supplier-centers/national-control-devices",
    "National Instruments (NI)": "/en/supplier-centers/ni",
    "National Semiconductor/Texas Instruments": "/en/supplier-centers/texas-instruments",
    "Navitas Semiconductor": "/en/supplier-centers/navitas-semiconductor",
    "Navman Wireless (Telit)": "/en/supplier-centers/telit-wireless-solutions",
    NDK: "/en/supplier-centers/ndk",
    Nearson: "/en/supplier-centers/nearson",
    "Neohm Resistors / TE Connectivity": "/en/supplier-centers/te-connectivity",
    Neonode: "/en/supplier-centers/neonode",
    "Neptune Control": "/en/supplier-centers/neptune-control",
    "Nesscap Co., Ltd": "/en/supplier-centers/nesscap",
    "NetBurner, Inc.": "/en/supplier-centers/netburner",
    "Netlist Inc.": "/en/supplier-centers/netlist-inc",
    "NetPower Corporation": "/en/supplier-centers/netpower-corporation",
    "New Age Enclosures": "/en/supplier-centers/new-age-enclosures",
    "New Boundary Technologies, Inc.": "/en/supplier-centers/new-boundary-technologies",
    "New Energy": "/en/supplier-centers/new-energy",
    "New Japan Radio (NJR)": "/en/supplier-centers/njr-corporation",
    "Newava Technology": "/en/supplier-centers/newava-technology",
    "Newhaven Display, Intl.": "/en/supplier-centers/newhaven-display",
    Newland: "/en/supplier-centers/newland",
    "NexLight-PerfectSense": "/en/supplier-centers/nexlight-perfectsense",
    Nexperia: "/en/supplier-centers/nexperia",
    "Next Industries SRL, The Tactigon": "/en/supplier-centers/next-industries",
    "Nextera Video": "/en/supplier-centers/nextera-video",
    "NextGen Components": "/en/supplier-centers/nextgen-components",
    "NEXUS (Amphenol NEXUS Technologies)": "/en/supplier-centers/amphenol-nexus-technologies",
    "NGD Systems": "/en/supplier-centers/ngd-systems",
    NI: "/en/supplier-centers/ni",
    Nichicon: "/en/supplier-centers/nichicon",
    Nicomatic: "/en/supplier-centers/nicomatic",
    "Nidec Copal Electronics": "/en/supplier-centers/copal-electronics",
    "NightShade Electronics": "/en/supplier-centers/nightshade-electronics-liebold-technologies",
    NimbeLink: "/en/supplier-centers/nimbelink",
    "Nippon Chemi-Con": "/en/supplier-centers/united-chemi-con",
    "Nippon Pulse America": "/en/supplier-centers/nippon-pulse-america",
    Niryo: "/en/supplier-centers/niryo",
    "Nistica - Molex": "/en/supplier-centers/molex",
    "NK Technologies": "/en/supplier-centers/nk-technologies-neilsen-kuljian",
    "NKK Switches": "/en/supplier-centers/nkk-switches",
    "NMB Technologies Corp.": "/en/supplier-centers/nmb-technologies",
    "Nominal Controls": "/en/supplier-centers/nominal-controls",
    NorComp: "/en/supplier-centers/norcomp",
    "Nordic Semiconductor": "/en/supplier-centers/nordic-semiconductor",
    "Noritake Co., Inc.": "/en/supplier-centers/noritake",
    "North Atlantic Industries (NAI)": "/en/supplier-centers/north-atlantic-industries-nai",
    "Northern Mechatronics Inc.": "/en/supplier-centers/northern-mechatronics",
    "Northwest Scada": "/en/supplier-centers/northwest-scada",
    NOVACAP: "/en/supplier-centers/knowles-novacap",
    "NovaSensor (Amphenol Advanced Sensors)": "/en/supplier-centers/amphenol-advanced-sensors",
    "Novasom Industries": "/en/supplier-centers/novasom-industries",
    "Novus Automation": "/en/supplier-centers/novus-automation",
    Nowi: "/en/supplier-centers/nowi",
    "NTE Electronics, Inc.": "/en/supplier-centers/nte-electronics-inc",
    "NuCurrent - Molex": "/en/supplier-centers/molex",
    "Nuvoton Technology Corporation America": "/en/supplier-centers/nuvoton-technology-corporation-america",
    "NuWaves Engineering": "/en/supplier-centers/nuwaves-engineering",
    "NVE Corporation": "/en/supplier-centers/nve-corporation",
    nVent: "/en/supplier-centers/nvent",
    "nVent Birtcher": "/en/supplier-centers/pentair",
    "nVent Calmark": "/en/supplier-centers/pentair",
    "nVent Hoffman": "/en/supplier-centers/hoffman",
    "nVent Schroff": "/en/supplier-centers/pentair",
    "NXP Semiconductors": "/en/supplier-centers/nxp-semiconductors",
    "O.C. White Co.": "/en/supplier-centers/oc-white",
    "Octavo Systems": "/en/supplier-centers/octavo-systems",
    ODU: "/en/supplier-centers/odu",
    "OEG Relays / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "OHM Americas": "/en/supplier-centers/ohm-americas",
    Ohmite: "/en/supplier-centers/ohmite",
    "OK Industries (Jonard Tools)": "/en/supplier-centers/jonard",
    OKdo: "/en/supplier-centers/okdo",
    "Ole Wolff": "/en/supplier-centers/ole-wolff",
    Olimex: "/en/supplier-centers/olimex",
    Omnetics: "/en/supplier-centers/omnetics",
    OmniPreSense: "/en/supplier-centers/omnipresense",
    "OmniVision Technologies": "/en/supplier-centers/omnivision-technologies",
    "Omron Automation": "/en/supplier-centers/omron-automation",
    "Omron Electronics Components": "/en/supplier-centers/omron",
    "OMS Motion": "/en/supplier-centers/oms-motion",
    "ON Semiconductor": "/en/supplier-centers/on-semiconductor",
    OneSimCard: "/en/supplier-centers/onesimcard",
    "Onion Corporation": "/en/supplier-centers/onion",
    "On-Shore Technology, Inc.": "/en/supplier-centers/on-shore-technology",
    "Oplink, a Molex company": "/en/supplier-centers/oplink",
    OptConnect: "/en/supplier-centers/optconnect",
    "Optek Technology/TT Electronics": "/en/supplier-centers/tt-electronics-optek-technology",
    OptiFuse: "/en/supplier-centers/optifuse",
    "Optilumen Inc.": "/en/supplier-centers/optilumen-inc",
    "Optimus Logic": "/en/supplier-centers/optimus-logic",
    "Option NV": "/en/supplier-centers/option-nv",
    Optiwave: "/en/supplier-centers/optiwave",
    "Opto Diode Corporation": "/en/supplier-centers/opto-diode",
    Orbel: "/en/supplier-centers/orbel",
    "O'Reilly Media, Inc.": "/en/supplier-centers/oreilly-media",
    "Orient Display": "/en/supplier-centers/orient-display",
    "Orion Fans": "/en/supplier-centers/orion-fans",
    Oscium: "/en/supplier-centers/oscium",
    Osela: "/en/supplier-centers/osela",
    "OSEPP Electronics": "/en/supplier-centers/osepp-electronics",
    "Oshino Lamps": "/en/supplier-centers/oshino-lamps",
    "OSI Optoelectronics": "/en/supplier-centers/osi-optoelectronics",
    "OSRAM Opto Semiconductors, Inc.": "/en/supplier-centers/osram-opto-semiconductors",
    Oupiin: "/en/supplier-centers/oupiin",
    "OVERCONN SRL": "/en/supplier-centers/overconn",
    "OWON Technology Lilliput Electronics": "/en/supplier-centers/owon-technology-lilliput-electronics",
    "Oyen Digital": "/en/supplier-centers/oyen-digital",
    "P1dB, Inc.": "/en/supplier-centers/p1db",
    "Pacer Instruments": "/en/supplier-centers/pacer-instruments",
    "Pacific Goal": "/en/supplier-centers/pacific-goal",
    "Packet Digital LLC": "/en/supplier-centers/packet-digital",
    Pactech: "/en/supplier-centers/pactech-saco-enterprises",
    Paktron: "/en/supplier-centers/paktron",
    "Paladin Tools (Greenlee Communications)": "/en/supplier-centers/greenlee-communications",
    "Palmer Wahl Instruments, Inc.": "/en/supplier-centers/palmer-wahl-instruments-inc",
    PalmSens: "/en/supplier-centers/palmsens",
    Panasonic: "/en/supplier-centers/panasonic",
    PanaVise: "/en/supplier-centers/panavise",
    "Panduit Corporation": "/en/supplier-centers/panduit",
    "Parallax, Inc.": "/en/supplier-centers/parallax",
    "Parker Chomerics": "/en/supplier-centers/parker-chomerics",
    "Parlex Corp.": "/en/supplier-centers/parlex",
    Particle: "/en/supplier-centers/particle",
    "Patco Electronics": "/en/supplier-centers/patco-electronics",
    "Patco Services": "/en/supplier-centers/patco-services",
    "PCA Electronics, Inc.": "/en/supplier-centers/pca-electronics",
    "PCD / Amphenol": "/en/supplier-centers/amphenol-pcd",
    "PCE Instruments": "/en/supplier-centers/pce-instruments",
    "P-DUKE Technology, Inc.": "/en/supplier-centers/p-duke-technology-inc",
    "Peak Electronic Design Ltd": "/en/supplier-centers/peak",
    "Peerless by Tymphany": "/en/supplier-centers/peerless-by-tymphany",
    "PEI-Genesis": "/en/supplier-centers/pei-genesis",
    "Pelonis Technologies": "/en/supplier-centers/pelonis-technologies",
    "Peltec Timers and Controls": "/en/supplier-centers/pelco-peltec-timers-and-controls",
    Peplink: "/en/supplier-centers/peplink",
    "Pepperl+Fuchs": "/en/supplier-centers/pepperl-fuchs",
    "Peregrine Semiconductor (pSemi)": "/en/supplier-centers/peregrine-semiconductor",
    "Pericom Semiconductor Corp. (Diodes Incorporated)": "/en/supplier-centers/pericom-semiconductor",
    "Pervasive Displays": "/en/supplier-centers/pervasive-displays",
    PFLITSCH: "/en/supplier-centers/pflitsch",
    "Phase Dock Inc.": "/en/supplier-centers/phase-dock-inc",
    "PHIHONG USA": "/en/supplier-centers/phihong-usa",
    "Philips (LUMILEDS)": "/en/supplier-centers/lumileds",
    "Phillips-Medisize - Molex": "/en/supplier-centers/molex",
    "Phoenix America": "/en/supplier-centers/phoenix-america",
    "Phoenix Contact": "/en/supplier-centers/phoenix-contact",
    "Phoenix Mecano": "/en/supplier-centers/phoenix-mecano",
    "Phoenix Passive Components / Vishay": "/en/supplier-centers/vishay",
    "Photo Solutions, Inc.": "/en/supplier-centers/photo-solutions-inc",
    "Phytec America": "/en/supplier-centers/phytec-america",
    "Phyton, Inc.": "/en/supplier-centers/phyton",
    Phytools: "/en/supplier-centers/phytools",
    "Pi Supply": "/en/supplier-centers/pi-supply",
    "PIC GmbH": "/en/supplier-centers/pic-gmbh",
    "Picker Components": "/en/supplier-centers/picker-components",
    "Piezo Electric Technology": "/en/supplier-centers/piezo-electric-technology",
    "Piezo System Jena": "/en/supplier-centers/piezo-system-jena",
    "Piher Sensing Systems, an Amphenol company": "/en/supplier-centers/piher-sensing-systems",
    "Pilot Things / 9386-2845": "/en/supplier-centers/pilot-things",
    Pimoroni: "/en/supplier-centers/pimoroni",
    "Piton Engineering": "/en/supplier-centers/piton-engineering",
    "pi-top": "/en/supplier-centers/pi-top",
    Pixelink: "/en/supplier-centers/pixelink",
    "Plastronics Sockets & Connectors": "/en/supplier-centers/plastronics-sockets-and-connectors",
    "Platinum Tools": "/en/supplier-centers/platinum-tools",
    "Playing With Fusion": "/en/supplier-centers/playing-with-fusion",
    "Plazmo Industries": "/en/supplier-centers/plazmo-industries",
    "Pletronics, Inc.": "/en/supplier-centers/pletronics-inc",
    "Pokit Innovations": "/en/supplier-centers/pokit-innovations",
    "Pololu Corporation": "/en/supplier-centers/pololu",
    Polymaker: "/en/supplier-centers/polymaker",
    "Polymer Optics Ltd.": "/en/supplier-centers/polymer-optics-ltd",
    "PolyMicro Technologies - Molex": "/en/supplier-centers/molex",
    "Polyrack Tech Group": "/en/supplier-centers/polyrack-tech-group",
    "Polytech / Vishay": "/en/supplier-centers/vishay-bccomponents",
    "Pomona Electronics": "/en/supplier-centers/pomona-electronics",
    "Pontiac Coil, Inc.": "/en/supplier-centers/pontiac-coil",
    Portescap: "/en/supplier-centers/portescap",
    "Posifa Technologies": "/en/supplier-centers/posifa-technologies",
    "Potter & Brumfield Relays / TE Connectivity": "/en/supplier-centers/te-connectivity-potter-brumfield-relays",
    "Powell Electronics": "/en/supplier-centers/powell-electronics",
    "Power Connector": "/en/supplier-centers/power-connector",
    "Power Dynamics, Inc.": "/en/supplier-centers/power-dynamics-inc",
    "Power Integrations": "/en/supplier-centers/power-integrations",
    "Power Solutions (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    "Power Sonic": "/en/supplier-centers/power-sonic",
    Powerbox: "/en/supplier-centers/powerbox",
    "Powerbx Inc.": "/en/supplier-centers/powerbx",
    Powercast: "/en/supplier-centers/powercast",
    "Powerex, Inc.": "/en/supplier-centers/powerex",
    "PowerFilm Inc.": "/en/supplier-centers/powerfilm",
    "Power-One (Bel Power Solutions)": "/en/supplier-centers/bel-power-solutions",
    PowerRESPONDER: "/en/supplier-centers/powerresponder",
    PowerSight: "/en/supplier-centers/powersight",
    "PowerStor (Eaton)": "/en/supplier-centers/eaton-electronics-division",
    "Powertip Technology Inc.": "/en/supplier-centers/powertip-technology-inc",
    Powertraveller: "/en/supplier-centers/powertraveller",
    POWERWAREHOUSE: "/en/supplier-centers/powerwarehouse",
    "PRD Plastics": "/en/supplier-centers/prd-plastics",
    "Preci-Dip": "/en/supplier-centers/preci-dip",
    "Precision Design Associates, Inc.": "/en/supplier-centers/precision-design-associates",
    "Precision Electronics Corporation": "/en/supplier-centers/precision-electronic-components",
    "Precision Fiber MX": "/en/supplier-centers/precision-fiber-mx",
    "Precision Resistive Products Inc.": "/en/supplier-centers/precision-resistive-products",
    "Precision Technology, Inc.": "/en/supplier-centers/precision-technology",
    PrehKeyTec: "/en/supplier-centers/prehkeytec",
    "Premo S.A.U.": "/en/supplier-centers/premo-sau",
    Prinsta: "/en/supplier-centers/prinsta",
    ProAnt: "/en/supplier-centers/proant",
    "ProComSol, Ltd.": "/en/supplier-centers/procomsol",
    "Prodigy SmartLock": "/en/supplier-centers/prodigy-smartlock",
    "Prodigy Technovations": "/en/supplier-centers/prodigy-technovations",
    Productech: "/en/supplier-centers/productech",
    "Products Unlimited Transformers & Relays / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "Professional Cable": "/en/supplier-centers/professional-cable",
    Promik: "/en/supplier-centers/promik",
    Prostat: "/en/supplier-centers/prostat",
    "ProTek Devices": "/en/supplier-centers/protek-devices",
    "Protektive Pak": "/en/supplier-centers/protektive-pak",
    pSemi: "/en/supplier-centers/peregrine-semiconductor",
    "PSI Technics GmbH": "/en/supplier-centers/psi-technics",
    "Psiber Data Systems, Inc.": "/en/supplier-centers/psiber-data-systems-inc",
    "PUI Audio, Inc.": "/en/supplier-centers/pui-audio",
    PULS: "/en/supplier-centers/puls",
    Pulsar: "/en/supplier-centers/pulsar",
    "Pulse Electronics": "/en/supplier-centers/pulse-electronics",
    "PulseCore Semiconductor/ON Semiconductor": "/en/supplier-centers/on-semiconductor",
    "PulseLarsen Antenna": "/en/supplier-centers/pulse-electronics",
    "PulseR (iNRCORE": "/en/supplier-centers/pulse-ruggedized",
    Pycom: "/en/supplier-centers/pycom",
    "Pyro-E, Inc.": "/en/supplier-centers/pyro-e",
    "Q-Cee's / TE Connectivity": "/en/supplier-centers/te-connectivity",
    Qoitech: "/en/supplier-centers/qoitech",
    QST: "/en/supplier-centers/qst",
    "QT Brightek": "/en/supplier-centers/qt-brightek",
    Quadcept: "/en/supplier-centers/quadcept",
    Qualcomm: "/en/supplier-centers/csr-plc",
    "Qualcomm® RF front-end (RFFE) filter products": "/en/supplier-centers/rf360",
    "Quallink Technology Inc.": "/en/supplier-centers/quallink-technology-inc",
    "Qualtek Electronics Corp.": "/en/supplier-centers/qualtek",
    "Quantum Integration": "/en/supplier-centers/quantum-integration",
    "Quantum Microwave Components": "/en/supplier-centers/quantum-microwave-components",
    "Quarton, Inc.": "/en/supplier-centers/quarton",
    "Quatech / B+B SmartWorx": "/en/supplier-centers/bb-smartworx",
    Quectel: "/en/supplier-centers/quectel",
    "Quest Manufacturing": "/en/supplier-centers/quest-manufacturing",
    "Quest Technology International": "/en/supplier-centers/quest-technology-international",
    "R&R Lotion": "/en/supplier-centers/rr-lotion",
    "Rabbit Semiconductor (Digi)": "/en/supplier-centers/rabbit-semiconductor",
    "Radial Magnets, Inc.": "/en/supplier-centers/radial-magnet",
    "Radiall USA, Inc.": "/en/supplier-centers/radiall",
    Radian: "/en/supplier-centers/radian-thermal-products",
    "Radio Bridge Inc.": "/en/supplier-centers/radio-bridge",
    RadioControlli: "/en/supplier-centers/radiocontrolli",
    Radiocrafts: "/en/supplier-centers/radiocrafts",
    RAF: "/en/supplier-centers/raf",
    RAFI: "/en/supplier-centers/rafi",
    Raltron: "/en/supplier-centers/raltron",
    "Ramtron (Cypress Semiconductor)": "/en/supplier-centers/ramtron",
    "Raspberry Pi": "/en/supplier-centers/raspberry-pi",
    Rathbun: "/en/supplier-centers/rathbun",
    "RATOC Systems": "/en/supplier-centers/ratoc-systems",
    "Raychem Cable Protection/TE Connectivity": "/en/supplier-centers/te-connectivity-raychem-cable-protection",
    Raytac: "/en/supplier-centers/raytac",
    "RDI Inc.": "/en/supplier-centers/rdi-inc",
    "Reach Technology": "/en/supplier-centers/reach-technology",
    "RECOM Power": "/en/supplier-centers/recom-power",
    "Rectron USA": "/en/supplier-centers/rectron-usa",
    "Red Lion": "/en/supplier-centers/red-lion-controls",
    "Red Pitaya": "/en/supplier-centers/red-pitaya",
    "REDEL / LEMO": "/en/supplier-centers/lemo",
    "REED Instruments": "/en/supplier-centers/reed-instruments",
    "Rees, Inc.": "/en/supplier-centers/rees-inc",
    REGAL: "/en/supplier-centers/regal",
    "Remington Industries": "/en/supplier-centers/remington-industries",
    "Rendeer Systems": "/en/supplier-centers/rendeer-systems",
    "Renesas Electronics America": "/en/supplier-centers/renesas-electronics-america",
    "Renetec, Inc.": "/en/supplier-centers/renetec-inc",
    "Rennsteig Tools": "/en/supplier-centers/rennsteig-tools",
    "Reonix Automation": "/en/supplier-centers/reonix-automation",
    "ReVibe Energy": "/en/supplier-centers/revibe-energy",
    "RevX Systems": "/en/supplier-centers/revx-systems",
    "RF Industries": "/en/supplier-centers/rf-industries",
    "RF Solutions": "/en/supplier-centers/rf-solutions",
    "RFbeam Microwave GmbH": "/en/supplier-centers/rfbeam",
    "RFE/Fuzetec": "/en/supplier-centers/rfe-fuzetec",
    RFMD: "/en/supplier-centers/rfmd",
    RFMi: "/en/supplier-centers/rfmi",
    "Rhomb.io": "/en/supplier-centers/rhomb-io",
    "RIA Connect / METZ CONNECT ": "/en/supplier-centers/metz-connect",
    "Richco, Inc. (Essentra Components)": "/en/supplier-centers/essentra-components",
    Richtek: "/en/supplier-centers/richtek",
    "RICOH Electronic Devices Co., LTD.": "/en/supplier-centers/ricoh",
    Riedon: "/en/supplier-centers/riedon",
    "Rieker Inc.": "/en/supplier-centers/rieker",
    Rigado: "/en/supplier-centers/rigado",
    "RIGOL Technologies": "/en/supplier-centers/rigol-technologies",
    "Ritron Wireless Solutions": "/en/supplier-centers/ritron-wireless-solutions",
    "RIVER/River Eletec Corporation": "/en/supplier-centers/river-eletec-corporation",
    Riverdi: "/en/supplier-centers/riverdi",
    "R-K Electronics, Inc.": "/en/supplier-centers/r-k-electronics",
    "RLE Technologies": "/en/supplier-centers/rle-technologies",
    ROBOTIS: "/en/supplier-centers/robotis",
    RobotShop: "/en/supplier-centers/robotshop",
    "Rochester Electronics": "/en/supplier-centers/rochester-electronics",
    "Rochester Gauges, LLC": "/en/supplier-centers/rochester-gauges-llc",
    "Rocom Couplings": "/en/supplier-centers/rocom-couplings",
    "Roederstein / Vishay": "/en/supplier-centers/vishay-bccomponents",
    "ROHM Semiconductor": "/en/supplier-centers/rohm-semi",
    "Rose Enclosures": "/en/supplier-centers/phoenix-mecano",
    "Rose+Krieger": "/en/supplier-centers/phoenix-mecano",
    Rosenberger: "/en/supplier-centers/rosenberger",
    Rotrics: "/en/supplier-centers/rotrics",
    "Roving Networks / Microchip Technology": "/en/supplier-centers/microchip-technology",
    "RPM Systems": "/en/supplier-centers/rpm-systems",
    Rubycon: "/en/supplier-centers/rubycon",
    "Ruffy Controls": "/en/supplier-centers/ruffy-controls",
    "Ruland Manufacturing": "/en/supplier-centers/ruland-manufacturing",
    "Runic Technology": "/en/supplier-centers/jiangsu-runic",
    RushUp: "/en/supplier-centers/rushup",
    "Russtech Engineering": "/en/supplier-centers/russtech-engineering",
    "S.I. Tech, Inc.": "/en/supplier-centers/s-i-tech",
    "SAB North America": "/en/supplier-centers/sab-north-america",
    "Saelig Company Inc.": "/en/supplier-centers/saelig-company-inc",
    Sagrad: "/en/supplier-centers/sagrad",
    "Saia (Division of Johnson Electric)": "/en/supplier-centers/ledex-dormeyer-saia",
    "Saiko Systems": "/en/supplier-centers/saiko-systems",
    "Samsung ARTIK": "/en/supplier-centers/samsung-artik",
    "Samsung Electro-Mechanics": "/en/supplier-centers/samsung-electro-mechanics-america",
    "Samsung Semiconductor": "/en/supplier-centers/samsung-semiconductor",
    "Samtec, Inc.": "/en/supplier-centers/samtec",
    "Sanken Electric Co., Ltd.": "/en/supplier-centers/sanken",
    "SanMotion Products (Sanyo Denki)": "/en/supplier-centers/sanyo-denki-sanmotion-products",
    Sanoxy: "/en/supplier-centers/sanoxy",
    "SanUPS Products (Sanyo Denki)": "/en/supplier-centers/sanyo-denki-sanups-products",
    "Sanyo Denki": "/en/supplier-centers/sanyo-denki",
    "Sanyo Denki SanMotion Products": "/en/supplier-centers/sanyo-denki-sanmotion-products",
    "Sanyo Denki SanUPS Products": "/en/supplier-centers/sanyo-denki-sanups-products",
    "Sanyo Semiconductor/ON Semiconductor": "/en/supplier-centers/on-semiconductor",
    "Sanyou Relay": "/en/supplier-centers/sanyou-relay",
    Sarnikon: "/en/supplier-centers/sarnikon",
    "Schaffner EMC, Inc.": "/en/supplier-centers/schaffner-emc",
    "SchmalzTech, LLC": "/en/supplier-centers/schmalztech-llc",
    SchmartBoard: "/en/supplier-centers/schmartboard",
    "Schrack Relays / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "Schroff / nVent": "/en/supplier-centers/pentair",
    SCHUNK: "/en/supplier-centers/schunk",
    Schurter: "/en/supplier-centers/schurter",
    ScioSense: "/en/supplier-centers/sciosense",
    SCS: "/en/supplier-centers/scs",
    SD: "/en/supplier-centers/surpless-dunn-and-co-inc",
    "Sealing Devices, Inc.": "/en/supplier-centers/sealing-devices",
    Seeed: "/en/supplier-centers/seeed",
    "Seek Thermal": "/en/supplier-centers/seek-thermal",
    "Segger Microcontroller Systems": "/en/supplier-centers/segger-microcontroller-systems",
    "Seiko Instruments, Inc.": "/en/supplier-centers/seiko-instruments",
    "SEIP (Sumitomo Electric Interconnect Products)": "/en/supplier-centers/sumitomo",
    Seltech: "/en/supplier-centers/seltech",
    "Semflex / Cinch Connectivity Solutions": "/en/supplier-centers/cinch-connectivity-solutions",
    "Semiconductor Circuits, Inc.": "/en/supplier-centers/semiconductor-circuits-inc",
    SemiQ: "/en/supplier-centers/global-power-technologies-group",
    Semtech: "/en/supplier-centers/semtech",
    Senasys: "/en/supplier-centers/senasys",
    Senix: "/en/supplier-centers/senix",
    Sensaphone: "/en/supplier-centers/sensaphone",
    "Sensata Pressure & Temperature Sensors & Switches": "/en/supplier-centers/sensata-sensors",
    "Sensata Technologies": "/en/supplier-centers/sensata-technologies",
    "Sensata Technologies – Airpax": "/en/supplier-centers/sensata-technologies-airpax",
    "Sensata Technologies – BEI Sensors": "/en/supplier-centers/bei-sensors",
    "Sensata Technologies – Crydom": "/en/supplier-centers/crydom",
    "Sensata Technologies – Cynergy3": "/en/supplier-centers/cynergy3",
    "Sensata Technologies – Deltatech": "/en/supplier-centers/sensata-technologies-deltatech",
    "Sensata Technologies – Kavlico Pressure Sensors": "/en/supplier-centers/kavlico",
    "SENSE Software": "/en/supplier-centers/sense-software",
    Senseair: "/en/supplier-centers/senseair",
    SensiML: "/en/supplier-centers/sensiml-quicklogic",
    Sensirion: "/en/supplier-centers/sensirion",
    "Sensor Electronic Technology": "/en/supplier-centers/sensor-electronic-technology",
    "SensorCon - Molex": "/en/supplier-centers/molex",
    "Sensorview America": "/en/supplier-centers/sensorview",
    "Seoul Semiconductor": "/en/supplier-centers/seoul-semiconductor",
    Septentrio: "/en/supplier-centers/septentrio",
    "Sequans Communications": "/en/supplier-centers/sequans",
    "Sercalo Microtechnology Ltd.": "/en/supplier-centers/sercalo-microtechnology",
    "Serious Integrated": "/en/supplier-centers/serious-integrated",
    "Serpac Electronic Enclosures": "/en/supplier-centers/serpac",
    "Sevskiy GmbH": "/en/supplier-centers/sevskiy-gmbh",
    "SG Wireless Limited": "/en/supplier-centers/sg-wireless-limited",
    "SGX Sensortech (Amphenol SGX Sensortech)": "/en/supplier-centers/sgx-sensortech",
    "Sharp Microelectronics": "/en/supplier-centers/sharp-microelectronics",
    "Sheetak, Inc.": "/en/supplier-centers/sheetak-inc",
    "Shindengen America, Inc.": "/en/supplier-centers/shindengen-america-inc",
    "Shoreline IoT": "/en/supplier-centers/shoreline-iot",
    Siargo: "/en/supplier-centers/siargo",
    "Siborg Systems Inc.": "/en/supplier-centers/siborg-systems",
    SICK: "/en/supplier-centers/sick",
    "Sierra Wireless": "/en/supplier-centers/sierra-wireless",
    "Sierra Wireless by Talon": "/en/supplier-centers/talon-communications",
    "Sifam Tinsley Instrumentation, Inc.": "/en/supplier-centers/sifam-tinsley-instrumentation",
    Sigfox: "/en/supplier-centers/sigfox",
    "Siglent Technologies": "/en/supplier-centers/siglent-technologies",
    "Sigma Designs": "/en/supplier-centers/sigma-designs",
    "Sigma Inductors / TE Connectivity": "/en/supplier-centers/te-connectivity",
    "Signal Processing Group Inc.": "/en/supplier-centers/signal-processing-group",
    "Signal Transformer": "/en/supplier-centers/signal-transformer",
    "SIKA USA Inc.": "/en/supplier-centers/sika-usa",
    "Silego Technology (Dialog Semiconductor)": "/en/supplier-centers/silego-technology",
    "Silicon Labs": "/en/supplier-centers/silicon-labs",
    "Silicon Motion": "/en/supplier-centers/silicon-motion",
    "Silicon Power": "/en/supplier-centers/silicon-power",
    "Simco-Ion": "/en/supplier-centers/simco-ion",
    SimpleChips: "/en/supplier-centers/simplechips",
    SINBON: "/en/supplier-centers/sinbon",
    "SINE Systems / Amphenol": "/en/supplier-centers/amphenol-sine-systems",
    Siretta: "/en/supplier-centers/siretta",
    "SIRIO Antenne": "/en/supplier-centers/sirio-antenne",
    SiTime: "/en/supplier-centers/sitime",
    "Sixfab, Inc.": "/en/supplier-centers/sixfab-inc",
    "Skeleton Technologies": "/en/supplier-centers/skeleton-technologies",
    "Skenos Technologies, Inc.": "/en/supplier-centers/skenos-technologies-inc",
    SkyeTek: "/en/supplier-centers/skyetek",
    "SkyHigh Memory Limited": "/en/supplier-centers/skyhigh-memory",
    "Skyworks Solutions, Inc.": "/en/supplier-centers/skyworks-solutions",
    "SL Power Electronics - Manufacturer of Condor / Ault Brands": "/en/supplier-centers/sl-power-electronics",
    "Sleek Socket": "/en/supplier-centers/sleek-socket",
    "Smart Prototyping/NOA Labs": "/en/supplier-centers/noa-labs",
    "Smart Sensor Devices": "/en/supplier-centers/smart-sensor-devices",
    "SMC Diode Solutions": "/en/supplier-centers/smc-diode-solutions",
    "SMD Sensors": "/en/supplier-centers/smd-sensors",
    "Smith Systems, Inc.": "/en/supplier-centers/smith-systems-inc",
    "Soberton, Inc.": "/en/supplier-centers/soberton",
    "SOC Technologies (System-On-Chip Technologies)": "/en/supplier-centers/soc-technologies",
    "Socapex (Amphenol Pcd)": "/en/supplier-centers/amphenol-pcd",
    "Socle Technology Corporation": "/en/supplier-centers/socle",
    SolaHD: "/en/supplier-centers/solahd",
    "Solar Lighting International": "/en/supplier-centers/solar-lighting",
    "Solar Made": "/en/supplier-centers/solar-made",
    "Solid State Inc.": "/en/supplier-centers/solid-state-inc",
    Solidlite: "/en/supplier-centers/solidlite",
    SolidRun: "/en/supplier-centers/solidrun",
    SoMLabs: "/en/supplier-centers/somlabs",
    "Songtian Electronics": "/en/supplier-centers/shantou-free-trade-zone",
    "Sotcher Measurement Inc.": "/en/supplier-centers/sotcher-measurement-inc",
    "Sound Devices, LLC": "/en/supplier-centers/sound-devices",
    "Souriau-Sunbank by Eaton": "/en/supplier-centers/souriau-connection-technology",
    "Southwire Company": "/en/supplier-centers/southwire-company",
    "Space Coast Electronics": "/en/supplier-centers/space-coast-electronics",
    "Spansion (Cypress Semiconductor)": "/en/supplier-centers/spansion",
    SparkFun: "/en/supplier-centers/sparkfun",
    "Spec Sensors": "/en/supplier-centers/spec-sensors",
    "Spectra Symbol": "/en/supplier-centers/spectra-symbol",
    SpotSee: "/en/supplier-centers/spotsee",
    "Sprague Goodman": "/en/supplier-centers/sprague-goodman",
    "Spruce Science": "/en/supplier-centers/spruce-science",
    "SRA Soldering Products": "/en/supplier-centers/sra-soldering-products",
    "Sruite Electronic Technology": "/en/supplier-centers/sruite-electronic-technology",
    "SSI Technologies, Inc.": "/en/supplier-centers/ssi-technologies",
    "SST Sensing": "/en/supplier-centers/sst-sensing",
    "Stackpole Electronics, Inc.": "/en/supplier-centers/stackpole-electronics",
    "Staco Energy Products Co.": "/en/supplier-centers/staco-energy-products",
    "Stage Ninja": "/en/supplier-centers/stage-ninja",
    "Stainless Steel Products": "/en/supplier-centers/stainless-steel-products",
    "Standex Electronics": "/en/supplier-centers/standex-meder-electronics",
    "Stanley Electric": "/en/supplier-centers/stanley-electric",
    "START International": "/en/supplier-centers/start-international",
    "Static Solutions, Inc.": "/en/supplier-centers/static-solutions",
    StaticStop: "/en/supplier-centers/staticstop",
    Steinel: "/en/supplier-centers/steinel",
    "Stele Tech": "/en/supplier-centers/stele-corporation",
    Steute: "/en/supplier-centers/steute-wireless",
    "Stewart Connector": "/en/supplier-centers/stewart-connector",
    "STI Vibration Monitoring": "/en/supplier-centers/sti-vibration-monitoring",
    "STI-CO Industries": "/en/supplier-centers/sti-co-industries",
    STL: "/en/supplier-centers/stl",
    STMicroelectronics: "/en/supplier-centers/stmicroelectronics",
    "Storage & Server IO (Amphenol ICC)": "/en/supplier-centers/amphenol-icc",
    "Storm Interface": "/en/supplier-centers/storm-interface",
    "Studio 1 Labs": "/en/supplier-centers/studio-1-labs",
    "Suburban Embedded": "/en/supplier-centers/suburban-embedded",
    "Suco Technologies Inc.": "/en/supplier-centers/suco-technologies-inc",
    "Sullins Connector Solutions": "/en/supplier-centers/sullins-connector-solutions",
    "Sumida Corporation": "/en/supplier-centers/sumida",
    Sumitomo: "/en/supplier-centers/sumitomo",
    "Sumitomo Electric Interconnect Products (SEIP)": "/en/supplier-centers/sumitomo",
    "Sungmun Electronics": "/en/supplier-centers/sungmun-electronics",
    SunLED: "/en/supplier-centers/sunled",
    Sunon: "/en/supplier-centers/sunon",
    "Suntsu Electronics, Inc.": "/en/supplier-centers/suntsu-electronics-inc",
    "Superior Asphalt Concepts": "/en/supplier-centers/superior-asphalt-concepts",
    "Superior Sensor Technology": "/en/supplier-centers/superior-sensor-technology",
    "Sure Electronics": "/en/supplier-centers/sure-electronics",
    "Sure-Fi": "/en/supplier-centers/sure-fi",
    SURGE: "/en/supplier-centers/surge",
    Susumu: "/en/supplier-centers/susumu",
    "Suzhou Maswell Communication Technology Co. Ltd": "/en/supplier-centers/suzhou-maswell-communication-technology-co-ltd",
    "SV Microwave (Amphenol SV Microwave)": "/en/supplier-centers/amphenol-sv-microwave",
    "Swanstrom Tools": "/en/supplier-centers/swanstrom-tools",
    Swissbit: "/en/supplier-centers/swissbit",
    "Switch Components": "/en/supplier-centers/switch-components",
    "Switchcraft / Conxall": "/en/supplier-centers/switchcraft-conxall",
    "SYBA USA": "/en/supplier-centers/syba",
    Syfer: "/en/supplier-centers/syfer",
    "Synapse Wireless": "/en/supplier-centers/synapse-wireless",
    "Syndesy Technologies, Inc. ": "/en/supplier-centers/syndesy",
    Synzen: "/en/supplier-centers/synzen",
    SystemBase: "/en/supplier-centers/systembase",
    "System-On-Chip Technologies": "/en/supplier-centers/soc-technologies",
    "Tabor Electronics Ltd.": "/en/supplier-centers/tabor-electronics-ltd",
    "Tadiran Batteries": "/en/supplier-centers/tadiran-batteries",
    "TAEC Product (Toshiba Electronic Devices and Storage Corporation)": "/en/supplier-centers/toshiba-semiconductor-and-storage",
    "Tag-Connect": "/en/supplier-centers/tag-connect",
    "Tagore Technology": "/en/supplier-centers/tagore-technology",
    "Taica Corporation": "/en/supplier-centers/taica",
    Taitien: "/en/supplier-centers/taitien",
    "Taiwan Semiconductor": "/en/supplier-centers/taiwan-semiconductor",
    "TAIYO YUDEN": "/en/supplier-centers/taiyo-yuden",
    Talema: "/en/supplier-centers/talema",
    "Tallysman Wireless": "/en/supplier-centers/tallysman-wireless",
    Tamura: "/en/supplier-centers/tamura",
    "TANE ALARM PRODUCTS": "/en/supplier-centers/tane-alarm-products",
    Taoglas: "/en/supplier-centers/taoglas",
    TapeCase: "/en/supplier-centers/tapecase",
    TCI: "/en/supplier-centers/tci",
    "TDK Corporation": "/en/supplier-centers/tdk",
    "TDK EPCOS": "/en/supplier-centers/epcos",
    "TDK InvenSense": "/en/supplier-centers/invensense",
    "TDK Micronas": "/en/supplier-centers/micronas",
    "TDK Tronics (Tronics)": "/en/supplier-centers/tronics",
    "TDK-Lambda, Inc.": "/en/supplier-centers/tdk-lambda",
    "TE Connectivity": "/en/supplier-centers/te-connectivity",
    "TE Connectivity Aerospace Defense and Marine": "/en/supplier-centers/te-connectivity-aerospace",
    "TE Connectivity ALCOSWITCH Switches": "/en/supplier-centers/te-connectivity-alcoswitch",
    "TE Connectivity AMP Connectors": "/en/supplier-centers/te-connectivity-amp",
    "TE Connectivity Corcom Filters": "/en/supplier-centers/te-connectivity-corcom-filters",
    "TE Connectivity DEUTSCH Connectors": "/en/supplier-centers/te-connectivity-deutsch-connectors",
    "TE Connectivity DEUTSCH INDUSTRIAL & COMMERCIAL TRANSPORTATION": "/en/supplier-centers/te-connectivity-deutsch-industrial-commercial-transportation",
    "TE Connectivity Measurement Specialties": "/en/supplier-centers/te-connectivity-measurement-specialties",
    "TE Connectivity Potter & Brumfield Relays": "/en/supplier-centers/te-connectivity-potter-brumfield-relays",
    "TE Connectivity Raychem Cable Protection": "/en/supplier-centers/te-connectivity-raychem-cable-protection",
    "TE Connectivity Raychem Circuit Protection / Littelfuse": "/en/supplier-centers/littelfuse",
    "TE Connectivity's Agastat Relays": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Axicom Relays": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Buchanan Terminal Blocks": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's CGS Resistors": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's CII": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Elcon Connectors": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Holsworthy Resistors": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Kilovac Relays": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Neohm Resistors": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's OEG Relays": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Products Unlimited Transformers & Relays": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Q-Cee's ": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Schrack Relays": "/en/supplier-centers/te-connectivity",
    "TE Connectivity's Sigma Inductors": "/en/supplier-centers/te-connectivity",
    "Tecate Group": "/en/supplier-centers/tecate-group",
    "Teccor / Littelfuse": "/en/supplier-centers/littelfuse",
    Techflex: "/en/supplier-centers/techflex",
    "TechLogix Networx": "/en/supplier-centers/techlogix-networx",
    TechNexion: "/en/supplier-centers/technexion",
    "Techno / Vishay": "/en/supplier-centers/vishay-bccomponents",
    Techspray: "/en/supplier-centers/techspray",
    TechTools: "/en/supplier-centers/techtools",
    "Tecnomatic Corp": "/en/supplier-centers/tecnomatic-corp",
    Tegam: "/en/supplier-centers/tegam",
    "TEKTELIC Communications": "/en/supplier-centers/tektelic",
    "Tektos Design": "/en/supplier-centers/tektos",
    "Tek-Trol": "/en/supplier-centers/tek-trol",
    "Telaire (Amphenol Advanced Sensors)": "/en/supplier-centers/amphenol-advanced-sensors",
    "TELE Controls, Inc.": "/en/supplier-centers/tele-controls",
    "Teledyne LeCroy": "/en/supplier-centers/teledyne-lecroy",
    Telegärtner: "/en/supplier-centers/telegartner",
    "Telit ": "/en/supplier-centers/telit-wireless-solutions",
    "Tell-i": "/en/supplier-centers/telli-technologies",
    "Telonic Berkeley Inc.": "/en/supplier-centers/telonic-berkeley-inc",
    "Temp-Flex - Molex": "/en/supplier-centers/molex",
    "Tempo Communications": "/en/supplier-centers/tempo-communications",
    Temprel: "/en/supplier-centers/temprel",
    "Tensility International Corporation": "/en/supplier-centers/tensility-international",
    "Tera Grand": "/en/supplier-centers/tera-grand-corporation",
    Terabee: "/en/supplier-centers/terabee",
    Terasic: "/en/supplier-centers/terasic-technologies",
    "Test Products International (TPI)": "/en/supplier-centers/test-products-international",
    Tesuto: "/en/supplier-centers/tesuto",
    "TEWA Sensors LLC": "/en/supplier-centers/tewa-sensors",
    "Texas Edge Computing": "/en/supplier-centers/texas-edge-computing",
    "Texas Instruments": "/en/supplier-centers/texas-instruments",
    Texmate: "/en/supplier-centers/texmate",
    TextSpeak: "/en/supplier-centers/textspeak",
    "TG3 Electronics": "/en/supplier-centers/tg3-electronics",
    "t-Global Technology": "/en/supplier-centers/t-global-technology",
    "Thales DIS (Formerly Gemalto)": "/en/supplier-centers/thales-dis",
    "Thales Visionix, Inc.": "/en/supplier-centers/thales-visionix",
    "The Fredericks Company": "/en/supplier-centers/fredericks-company",
    "The Gund Company": "/en/supplier-centers/gund-company",
    "The Imaging Source": "/en/supplier-centers/the-imaging-source",
    "The Western Design Center Inc.": "/en/supplier-centers/western-design-center-inc",
    "Thermco Products, Inc.": "/en/supplier-centers/thermco-products-inc",
    "Thermo Heating Elements": "/en/supplier-centers/thermo-heating-elements",
    "Thermoelectric Conversion Systems Ltd.": "/en/supplier-centers/thermoelectric-conversion-systems",
    "Thermometrics (Amphenol Advanced Sensors)": "/en/supplier-centers/amphenol-advanced-sensors",
    "THine Solutions": "/en/supplier-centers/thine-solutions",
    "ThingMagic, a JADAK Brand": "/en/supplier-centers/thingmagic",
    "Thinxtra Solutions Limited": "/en/supplier-centers/thinxtra",
    "Thomas Research Products": "/en/supplier-centers/thomas-research-products",
    Tibbo: "/en/supplier-centers/tibbo",
    "Times Microwave Systems": "/en/supplier-centers/times-microwave-systems",
    TinyCircuits: "/en/supplier-centers/tinycircuits",
    TMB: "/en/supplier-centers/tmb",
    "TNR TECHNICAL INC.": "/en/supplier-centers/tnr-technical",
    "TOKIN (KEMET)": "/en/supplier-centers/tokin",
    "TOKO / Murata": "/en/supplier-centers/murata-electronics",
    "Torex Semiconductor Ltd.": "/en/supplier-centers/torex-semiconductor",
    "Toshiba Electronic Devices and Storage Corporation": "/en/supplier-centers/toshiba-semiconductor-and-storage",
    "Toshiba Memory America, Inc. (Kioxia America, Inc.)": "/en/supplier-centers/toshiba-memory-america",
    "Touchstone Semiconductor": "/en/supplier-centers/touchstone-semiconductor",
    "Tower Products": "/en/supplier-centers/tower-products",
    "TPI (Test Products International)": "/en/supplier-centers/test-products-international",
    "TPK America LLC": "/en/supplier-centers/tpk-america",
    "TRACO Power": "/en/supplier-centers/traco-power",
    "Trafag Sensors & Controls": "/en/supplier-centers/trafag-sensors-and-controls",
    "Transforming Technologies": "/en/supplier-centers/transforming-technologies",
    Transko: "/en/supplier-centers/transko",
    Transphorm: "/en/supplier-centers/transphorm",
    Trek: "/en/supplier-centers/excelsys-technologies",
    "Trenz Electronic": "/en/supplier-centers/trenz-electronic",
    Treston: "/en/supplier-centers/treston",
    "Triad Magnetics": "/en/supplier-centers/triad-magnetics",
    "Triad Semiconductor": "/en/supplier-centers/triad-semiconductor",
    "Tridonic Inc.": "/en/supplier-centers/tridonic-inc",
    "Trigon Components": "/en/supplier-centers/trigon-components",
    "Tri-Mag, LLC": "/en/supplier-centers/tri-mag",
    "TRINAMIC Motion Control GmbH": "/en/supplier-centers/trinamic",
    "Triplett Test Equipment and Tools": "/en/supplier-centers/triplett-test-equipment-and-tools",
    "Tripp Lite": "/en/supplier-centers/tripp-lite",
    "Tri-Star Industries": "/en/supplier-centers/tri-star",
    "Triton Manufacturing - Molex": "/en/supplier-centers/molex",
    "Trompeter / Cinch Connectivity Solutions": "/en/supplier-centers/cinch-connectivity-solutions",
    "Tronex (Menda/EasyBraid/Tronex)": "/en/supplier-centers/easybraid",
    Tronics: "/en/supplier-centers/tronics",
    "TRP Connector": "/en/supplier-centers/trp-connector",
    Trumeter: "/en/supplier-centers/trumeter",
    Truphone: "/en/supplier-centers/truphone",
    "TSC (Taiwan Semiconductor)": "/en/supplier-centers/taiwan-semiconductor",
    "TT Electronics": "/en/supplier-centers/tt-electronics",
    "TT Electronics / BI Technologies": "/en/supplier-centers/tt-electronics-bi-technologies",
    "TT Electronics / Optek Technology": "/en/supplier-centers/tt-electronics-optek-technology",
    TubeDepot: "/en/supplier-centers/tubedepot",
    "Tuchel / Amphenol": "/en/supplier-centers/amphenol-sine-systems",
    "TurboFlex Heaters": "/en/supplier-centers/turboflex-heaters",
    "Twin Industries": "/en/supplier-centers/twin-industries",
    "TXC Corporation": "/en/supplier-centers/txc",
    "Tyco Electronics": "/en/supplier-centers/tyco-electronics",
    "Tycon Systems, Inc.": "/en/supplier-centers/tycon-systems-inc",
    "Tymphany (Peerless by Tymphany)": "/en/supplier-centers/peerless-by-tymphany",
    "U.S. Sensor (Littelfuse)": "/en/supplier-centers/us-sensor",
    "u-blox": "/en/supplier-centers/u-blox",
    UDOO: "/en/supplier-centers/udoo",
    "UEi Test Instruments": "/en/supplier-centers/uei-test-instruments",
    "Ultra Librarian®": "/en/supplier-centers/ultra-librarian",
    UltraVolt: "/en/supplier-centers/excelsys-technologies",
    Uneo: "/en/supplier-centers/uneo",
    "Ungar / Weller": "/en/supplier-centers/apex-tool-group",
    Unictron: "/en/supplier-centers/unictron",
    "Union Semiconductor (HK) Limited": "/en/supplier-centers/union-semiconductor-hk",
    "Unirise USA": "/en/supplier-centers/unirise-usa",
    "United Chemi-Con": "/en/supplier-centers/united-chemi-con",
    UnitedSiC: "/en/supplier-centers/unitedsic",
    "UNIVERSAL-SOLDER Electronics": "/en/supplier-centers/universal-solder-electronics",
    "U-Reach Data Solutions, Inc.": "/en/supplier-centers/u-reach-data-solutions-inc",
    "US Custom Billet": "/en/supplier-centers/us-custom-billet",
    "US Electronics Inc.": "/en/supplier-centers/us-electronics-usei",
    "US Micro Screw": "/en/supplier-centers/us-micro-screw",
    "US-Lasers, Inc.": "/en/supplier-centers/us-lasers",
    "USound GmbH": "/en/supplier-centers/usound",
    "VACUUMSCHMELZE GmbH & Co. KG.": "/en/supplier-centers/vacuumschmelze",
    "Vantron Technology": "/en/supplier-centers/vantron-technology",
    VaOpto: "/en/supplier-centers/vaopto",
    "Varitronix International Ltd.": "/en/supplier-centers/varitronix",
    "VarTech Systems": "/en/supplier-centers/vartech-systems",
    "VCC (Visual Communications Company)": "/en/supplier-centers/visual-communications-company",
    VEAM: "/en/supplier-centers/itt-interconnect-solutions",
    "Vector Electronics & Technology, Inc.": "/en/supplier-centers/vector-electronics-and-technology",
    "Veinland GmbH": "/en/supplier-centers/veinland",
    Vektrex: "/en/supplier-centers/vektrex",
    "Velab Co.": "/en/supplier-centers/velab-co",
    "Venkel LTD": "/en/supplier-centers/venkel-ltd",
    Verivolt: "/en/supplier-centers/verivolt",
    "VersaLogic Corporation": "/en/supplier-centers/versalogic-corporation",
    VersaSense: "/en/supplier-centers/versasense",
    "Versatile Power": "/en/supplier-centers/versatile-power",
    Vesper: "/en/supplier-centers/vesper",
    Vicor: "/en/supplier-centers/vicor",
    Vicotee: "/en/supplier-centers/vicotee",
    "Vifa (Peerless by Tymphany)": "/en/supplier-centers/peerless-by-tymphany",
    "Viking Tech": "/en/supplier-centers/viking-tech",
    "Viking Technology": "/en/supplier-centers/viking-technology",
    "Virtins Technology": "/en/supplier-centers/virtins-technology",
    Virtium: "/en/supplier-centers/virtium-technology",
    "Virtual Industries, Inc.": "/en/supplier-centers/virtual-industries-inc",
    VISATON: "/en/supplier-centers/visaton",
    Vishay: "/en/supplier-centers/vishay",
    "Vishay / Beyschlag": "/en/supplier-centers/vishay-beyschlag",
    "Vishay / Cera-Mite": "/en/supplier-centers/vishay-bccomponents",
    "Vishay / Dale": "/en/supplier-centers/vishay-dale",
    "Vishay / Huntington Electric, Inc.": "/en/supplier-centers/vishay-huntington-electric",
    "Vishay / Semiconductor - Opto Division": "/en/supplier-centers/vishay-semi-opto",
    "Vishay / Sfernice": "/en/supplier-centers/vishay-sfernice",
    "Vishay / Siliconix": "/en/supplier-centers/vishay-siliconix",
    "Vishay / Spectrol": "/en/supplier-centers/vishay-spectrol",
    "Vishay / Sprague": "/en/supplier-centers/vishay-sprague",
    "Vishay / Thin Film": "/en/supplier-centers/vishay-thin-film",
    "Vishay / Vitramon": "/en/supplier-centers/vishay-vitramon",
    "Vishay BC Components/Beyshlag/Draloric": "/en/supplier-centers/vishay-bccomponents",
    "Vishay General Semiconductor – Diodes Division ": "/en/supplier-centers/vishay-semi-diodes",
    "Vision Engineering": "/en/supplier-centers/vision-engineering",
    "Visual Communications Company, LLC": "/en/supplier-centers/visual-communications-company",
    "Vitelec / Cinch Connectivity Solutions": "/en/supplier-centers/cinch-connectivity-solutions",
    "Volgen (Kaga Electronics USA)": "/en/supplier-centers/volgen",
    VolleyBoast: "/en/supplier-centers/volleyboast",
    "Voltaic Systems": "/en/supplier-centers/voltaic-systems",
    "Voltronics (Knowles)": "/en/supplier-centers/knowles-voltronics",
    "Vox Power": "/en/supplier-centers/vox-power",
    "VPG Foil": "/en/supplier-centers/vishay-foil-resistors",
    "VPG Micro-Measurements": "/en/supplier-centers/micro-measurements",
    "VPG Sensors": "/en/supplier-centers/vishay-precision-group",
    "Vue-More Manufacturing": "/en/supplier-centers/vue-more-manufacturing",
    "Vynckier Enclosures": "/en/supplier-centers/vynckier-enclosures",
    WAGO: "/en/supplier-centers/wago",
    "Wakefield-Vette": "/en/supplier-centers/wakefield",
    "Waldom Electronics": "/en/supplier-centers/waldom-electronics",
    "Walsin Technology": "/en/supplier-centers/walsin-technology",
    Wandboard: "/en/supplier-centers/wandboard",
    "Watterott electronic": "/en/supplier-centers/watterott-electronic",
    "Wave.N": "/en/supplier-centers/wave-n",
    "WCI (World Class Illumination)": "/en/supplier-centers/wci-world-class-illumination",
    "WECO Electrical Connectors": "/en/supplier-centers/weco-electrical-connectors",
    "WeEn Semiconductors Co., Ltd": "/en/supplier-centers/ween-semiconductors",
    Weidmuller: "/en/supplier-centers/weidmuller",
    Weller: "/en/supplier-centers/apex-tool-group",
    "Wenzel Associates, Inc.": "/en/supplier-centers/wenzel-associates",
    WERMA: "/en/supplier-centers/werma",
    "Whitman Controls": "/en/supplier-centers/whitman-controls",
    "Wickmann / Littelfuse": "/en/supplier-centers/littelfuse",
    Wiha: "/en/supplier-centers/wiha",
    "Wilcoxon (Amphenol Wilcoxon Sensing Technologies)": "/en/supplier-centers/amphenol-wilcoxon",
    WIMA: "/en/supplier-centers/wima",
    "Winbond Electronics Corporation": "/en/supplier-centers/winbond-electronics",
    "Winchester Electronics": "/en/supplier-centers/winchester-electronics",
    "Winland Electronics": "/en/supplier-centers/winland-electronics",
    "WINSYSTEMS INC.": "/en/supplier-centers/winsystems",
    "Wintec Industries": "/en/supplier-centers/wintec-industries",
    Wiss: "/en/supplier-centers/apex-tool-group",
    "WITHWAVE CO LTD": "/en/supplier-centers/withwave",
    WIZnet: "/en/supplier-centers/wiznet",
    "Wolfspeed - a Cree company": "/en/supplier-centers/wolfspeed",
    "Woodhead - Molex": "/en/supplier-centers/molex",
    "worktables.com": "/en/supplier-centers/worktables-intercept-industries",
    "WPI / World Precision Instruments": "/en/supplier-centers/wpi-world-precision-instruments",
    "Würth Elektronik": "/en/supplier-centers/wurth-electronics",
    "Würth Elektronik iBE": "/en/supplier-centers/wurth-electronics",
    "Würth Elektronik ICS": "/en/supplier-centers/wurth-electronics",
    "Würth Elektronik Midcom": "/en/supplier-centers/wurth-electronics",
    "WyreStorm Technologies": "/en/supplier-centers/wyrestorm-technologies",
    Xaptum: "/en/supplier-centers/xaptum",
    Xcelite: "/en/supplier-centers/apex-tool-group",
    Xeltek: "/en/supplier-centers/xeltek",
    "Xenarc Technologies": "/en/supplier-centers/xenarc-technologies",
    "Xenon Fever Defense, Inc.": "/en/supplier-centers/xenon-fever-defense",
    XetaWave: "/en/supplier-centers/xetawave",
    "Xflight Technologies LLC": "/en/supplier-centers/xflight-technologies-llc",
    XFMRS: "/en/supplier-centers/xfmrs",
    Xilinx: "/en/supplier-centers/xilinx",
    XMOS: "/en/supplier-centers/xmos",
    "XP Power": "/en/supplier-centers/xp-power",
    "XS Power Batteries": "/en/supplier-centers/xs-power-batteries",
    Xsens: "/en/supplier-centers/xsens",
    "XTAR Technology Inc.": "/en/supplier-centers/xtar-technology-inc",
    "Y.C. Cable (East)": "/en/supplier-centers/yc-cable-east",
    Yageo: "/en/supplier-centers/yageo",
    "Yamaichi Electronics": "/en/supplier-centers/yamaichi-electronics",
    YIC: "/en/supplier-centers/yic-yuechung-international-corp",
    Yokowo: "/en/supplier-centers/yokowo",
    "YS Tech USA": "/en/supplier-centers/ys-tech-usa",
    "Z+F USA Inc.": "/en/supplier-centers/zplusf-usa-inc",
    Zendure: "/en/supplier-centers/zendure",
    "Zentri (Silicon Labs)": "/en/supplier-centers/zentri",
    "Zetex Semiconductors (Diodes Inc.)": "/en/supplier-centers/diodes",
    "Zettler Magnetics": "/en/supplier-centers/zettler-magnetics",
    "ZEUS Battery Products": "/en/supplier-centers/zeus-battery-products",
    "ZF Electronics": "/en/supplier-centers/cherry",
    "Zilog / Littelfuse": "/en/supplier-centers/zilog",
    "Zimmer and Peacock": "/en/supplier-centers/zimmer-and-peacock",
    ZofzPCB: "/en/supplier-centers/zofzpcb",
};
export const digikeyManufacturerListLowercase = Object.fromEntries(Object.entries(digikeyManufacturerList).map(([name, id]) => [name.toLowerCase(), id]));
export function digikeyManufacturerIdsBySubstring(substring) {
    substring = normalizeSubstring(substring);
    const keys = Object.keys(digikeyManufacturerList).filter((name) => {
        return name.toLowerCase().includes(substring);
    });
    const values = keys.flatMap((key) => digikeyManufacturerList?.[key] ?? []);
    if (!values.length) {
        return undefined;
    }
    return [...new Set(values)];
}
//# sourceMappingURL=digikeyManufacturerList.js.map